export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateTimeUTC: any;
  EmailType: any;
  MixedType: any;
  UploadType: any;
  keyValueData: any;
  targetingData: any;
  zohoDate: any;
};

export enum AccountType {
  /** POSTPAID account */
  Postpaid = 'POSTPAID',
  /** PREPAID account */
  Prepaid = 'PREPAID'
}

export type Dataset = {
  readonly __typename?: 'Dataset';
  readonly filters?: Maybe<Scalars['MixedType']>;
  readonly groups?: Maybe<Scalars['MixedType']>;
  /** Raw specs data. Use for if provider argument is set. */
  readonly rawData?: Maybe<Scalars['MixedType']>;
  readonly rows?: Maybe<Scalars['MixedType']>;
  readonly values?: Maybe<Scalars['MixedType']>;
};

export enum DatasetSpecsProvider {
  Aggrid = 'aggrid',
  ChartSpecs = 'chart_specs',
  Legacygrid = 'legacygrid',
  ObjectiveResults = 'objective_results',
  RulesSpecs = 'rules_specs',
  Translation = 'translation'
}

export enum DepositStatus {
  /** Cancelled status */
  Cancelled = 'CANCELLED',
  /** Pending status */
  Pending = 'PENDING',
  /** Confirmed status */
  Processed = 'PROCESSED',
  /** Rejected status */
  Rejected = 'REJECTED'
}

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly addFbAdAccountToFbExtendedCreditInvoiceGroup?: Maybe<FbAdAccount>;
  readonly authorizeAdminFbExternalAdvertiser?: Maybe<KvsKey>;
  readonly authorizeFbExternalAdvertiser?: Maybe<KvsKey>;
  readonly connectErpAccount?: Maybe<ErpAccount>;
  readonly connectZohoContact?: Maybe<ZohoContact>;
  readonly createAdminUser?: Maybe<AdminUser>;
  readonly createCustomerNotice?: Maybe<CustomerNotice>;
  readonly createDeposit?: Maybe<Deposit>;
  readonly createEContract?: Maybe<EContract>;
  readonly createExternalAdAccountPayin?: Maybe<ExternalAdAccountPayin>;
  readonly createFbAdAccount?: Maybe<FbAdAccount>;
  readonly createFbCustomer?: Maybe<FbTaUserAccount>;
  readonly createFbExtendedCreditInvoiceGroup?: Maybe<FbLiveExtendedCreditInvoiceGroup>;
  readonly createFbRule?: Maybe<ReadonlyArray<Maybe<FbRule>>>;
  readonly createFbRuleLog?: Maybe<ReadonlyArray<Maybe<FbRuleLog>>>;
  readonly createFbUser?: Maybe<FbTaUser>;
  readonly createReport?: Maybe<Report>;
  readonly createReportGoogleAccess?: Maybe<ReportOAuth>;
  readonly createSmsapiDutySchedule?: Maybe<ReadonlyArray<Maybe<SmsapiDutySchedule>>>;
  readonly createSmsapiMessage?: Maybe<ReadonlyArray<Maybe<SmsapiMessage>>>;
  readonly createTransactionExternal?: Maybe<TransactionExternal>;
  readonly createWalletDeposit?: Maybe<Deposit>;
  readonly createWithdraw?: Maybe<Withdraw>;
  readonly createZohoContact?: Maybe<ZohoContact>;
  readonly createZohoCustomerPayment?: Maybe<ExternalZohoCustomerPayment>;
  readonly createZohoInvoice?: Maybe<ZohoInvoice>;
  readonly createZohoItem?: Maybe<ExternalZohoItem>;
  readonly createZohoUser?: Maybe<ExternalZohoUser>;
  readonly deleteFbCreditSettings?: Maybe<Scalars['Boolean']>;
  readonly deleteFbExtendedCreditInvoiceGroup?: Maybe<Scalars['Boolean']>;
  readonly deleteImportSettings?: Maybe<ImportSetting>;
  readonly disableFbAdAccountStats?: Maybe<FbAdAccount>;
  readonly email?: Maybe<ReadonlyArray<Maybe<Email>>>;
  readonly enableFbAdAccountStats?: Maybe<FbAdAccount>;
  readonly importNewExternalFbAdAccounts?: Maybe<ReadonlyArray<Maybe<ExternalFbAdAccount>>>;
  readonly insertFbCreditSettingsTransaction?: Maybe<FbCreditSetting>;
  readonly jsErrorTrace?: Maybe<StackTrace>;
  readonly linkFbAdAccountsWithCustomer?: Maybe<ReadonlyArray<Maybe<FbAdAccount>>>;
  readonly lockFbAdAccount?: Maybe<GlobalChangeLog>;
  readonly refreshFbAdAccounts?: Maybe<ReadonlyArray<Maybe<ExternalFbAdAccount>>>;
  readonly removeFbAdAccountFromFbExtendedCreditInvoiceGroup?: Maybe<FbAdAccount>;
  readonly sendZohoInvoiceEmail?: Maybe<Scalars['Boolean']>;
  readonly signEContract?: Maybe<EContract>;
  readonly syncExternalFbAdAccount?: Maybe<ExternalFbAdAccount>;
  readonly transferFbAdAccountFunds?: Maybe<TransactionExternal>;
  readonly updateAdminUser?: Maybe<AdminUser>;
  readonly updateBusinessEmailRecipients?: Maybe<ReadonlyArray<Maybe<BusinessEmailRecipients>>>;
  readonly updateCustomerNotice?: Maybe<CustomerNotice>;
  readonly updateDeposit?: Maybe<Deposit>;
  readonly updateFbAdAccount?: Maybe<FbAdAccount>;
  readonly updateFbAdAccountAgencies?: Maybe<ReadonlyArray<Maybe<FbAdAccountAgency>>>;
  readonly updateFbAdAccountAssignedUsers?: Maybe<ReadonlyArray<Maybe<FbAdAccountAssignedUser>>>;
  readonly updateFbCreditLimitLog?: Maybe<Scalars['Boolean']>;
  readonly updateFbCreditSettings?: Maybe<FbCreditSetting>;
  readonly updateFbCustomer?: Maybe<FbTaUserAccount>;
  readonly updateFbExtendedCreditInvoiceGroup?: Maybe<FbLiveExtendedCreditInvoiceGroup>;
  readonly updateFbRule?: Maybe<ReadonlyArray<Maybe<FbRule>>>;
  readonly updateFbRuleLog?: Maybe<ReadonlyArray<Maybe<FbRuleLog>>>;
  readonly updateFbUser?: Maybe<FbTaUser>;
  readonly updateImportSettings?: Maybe<ImportSetting>;
  readonly updateReport?: Maybe<Report>;
  readonly updateSmsapiDutySchedule?: Maybe<ReadonlyArray<Maybe<SmsapiDutySchedule>>>;
  readonly updateWalletDeposit?: Maybe<Deposit>;
  readonly uploadProfileImage?: Maybe<ReadonlyArray<Maybe<UploadProfileImage>>>;
  readonly uploadSourceMaps?: Maybe<UploadJsSourceMap>;
};


export type MutationAddFbAdAccountToFbExtendedCreditInvoiceGroupArgs = {
  extendedCreditInvoiceGroupId: Scalars['String'];
  externalAdAccountId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
};


export type MutationAuthorizeAdminFbExternalAdvertiserArgs = {
  code?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<SsoUser>;
  sessionId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type MutationAuthorizeFbExternalAdvertiserArgs = {
  code?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<SsoUser>;
  sessionId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type MutationConnectErpAccountArgs = {
  customerAccountId: Scalars['ID'];
  dataAreaId: Scalars['ID'];
  taUserAccountId: Scalars['ID'];
};


export type MutationConnectZohoContactArgs = {
  customerId: Scalars['ID'];
  zohoContactId: Scalars['ID'];
  zohoTaxId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateAdminUserArgs = {
  adminUserCredentials: ReadonlyArray<InputMaybe<Credential>>;
  adminUserEmail: Scalars['EmailType'];
  adminUserFbEmail?: InputMaybe<Scalars['EmailType']>;
  adminUserHasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  adminUserLogin: Scalars['String'];
  adminUserName: Scalars['String'];
  adminUserPassword: Scalars['String'];
  adminUserPhone?: InputMaybe<Scalars['String']>;
  adminUserSurname: Scalars['String'];
  permittedExternalAdvertisers?: InputMaybe<ReadonlyArray<InputMaybe<PermittedExternalAdvertiser>>>;
};


export type MutationCreateCustomerNoticeArgs = {
  customerId: Scalars['ID'];
  customerNoticeIsMass?: InputMaybe<Scalars['Boolean']>;
  customerNoticeIsNews?: InputMaybe<Scalars['Boolean']>;
  customerNoticeIsTranslated?: InputMaybe<Scalars['Boolean']>;
  customerNoticeMessage: Scalars['String'];
  customerNoticeTitle: Scalars['String'];
  customerNoticeType: CustomerNoticeTypeEnum;
};


export type MutationCreateDepositArgs = {
  bankId: Scalars['ID'];
  depositDescription?: InputMaybe<Scalars['String']>;
  depositPaymentType: PaymentType;
  externalAdAccounts?: InputMaybe<ReadonlyArray<InputMaybe<DepositExternalAdAccountInput>>>;
};


export type MutationCreateEContractArgs = {
  companyAddress: Scalars['String'];
  companyContactEmail: Scalars['String'];
  companyContactName: Scalars['String'];
  companyContactSurname: Scalars['String'];
  companyName: Scalars['String'];
  companyRepEmail: Scalars['String'];
  companyRepName: Scalars['String'];
  companyRepSurname: Scalars['String'];
  companyRepTitle: Scalars['String'];
  ip?: InputMaybe<Scalars['String']>;
  isRepresentative: Scalars['Boolean'];
  isVatCommitted: Scalars['Boolean'];
  regNumber: Scalars['String'];
  signatureImage?: InputMaybe<UploadFilesInput>;
  taUserAccountId: Scalars['ID'];
  taxNumber: Scalars['String'];
  variants: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type MutationCreateExternalAdAccountPayinArgs = {
  amount: Scalars['Float'];
  externalAdAccountId: Scalars['String'];
  payinId: Scalars['Int'];
  status: Scalars['String'];
};


export type MutationCreateFbAdAccountArgs = {
  accountType: Scalars['String'];
  currency: Scalars['String'];
  endAdvertiserId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
  fundingId?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<Scalars['Boolean']>;
  invoiceGroupId?: InputMaybe<Scalars['String']>;
  invoicingEmails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  spendCap?: InputMaybe<Scalars['Float']>;
  taUserAccountId?: InputMaybe<Scalars['String']>;
  timezoneId: Scalars['Int'];
};


export type MutationCreateFbCustomerArgs = {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankLocalAccountNumber?: InputMaybe<Scalars['String']>;
  bankLocalName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  bankTotalAmount?: InputMaybe<Scalars['String']>;
  bankType?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['String']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerCity?: InputMaybe<Scalars['String']>;
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerContractSigned?: InputMaybe<Scalars['Boolean']>;
  customerCountryId: Scalars['String'];
  customerEmail: Scalars['String'];
  customerIsActivated?: InputMaybe<Scalars['Boolean']>;
  customerIsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerIsFullyRegistered?: InputMaybe<Scalars['Boolean']>;
  customerIsTest?: InputMaybe<Scalars['Boolean']>;
  customerIsValidated?: InputMaybe<Scalars['Boolean']>;
  customerIsVatCommitted?: InputMaybe<Scalars['Boolean']>;
  customerLocalAddress?: InputMaybe<Scalars['String']>;
  customerLocalCity?: InputMaybe<Scalars['String']>;
  customerLocalCompanyName?: InputMaybe<Scalars['String']>;
  customerLocalCountry?: InputMaybe<Scalars['String']>;
  customerLocalName?: InputMaybe<Scalars['String']>;
  customerLocalRegNumber?: InputMaybe<Scalars['String']>;
  customerLocalSurname?: InputMaybe<Scalars['String']>;
  customerLocalVatNumber?: InputMaybe<Scalars['String']>;
  customerLocalZip?: InputMaybe<Scalars['String']>;
  customerMailSubscribed?: InputMaybe<Scalars['Boolean']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerProfileImage?: InputMaybe<Scalars['String']>;
  customerProfileImageId?: InputMaybe<Scalars['ID']>;
  customerRegNumber?: InputMaybe<Scalars['String']>;
  customerSalesforceId?: InputMaybe<Scalars['ID']>;
  customerSurname?: InputMaybe<Scalars['String']>;
  customerVatNumber?: InputMaybe<Scalars['String']>;
  customerZip?: InputMaybe<Scalars['String']>;
  externalAdAccountIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  fbUserEmails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type MutationCreateFbExtendedCreditInvoiceGroupArgs = {
  emails: ReadonlyArray<InputMaybe<Scalars['String']>>;
  extendedCreditId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateFbRuleArgs = {
  actions: Scalars['String'];
  activatedAt?: InputMaybe<Scalars['String']>;
  applyOn?: InputMaybe<Scalars['String']>;
  conditions: Scalars['String'];
  data?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyAbsolute?: InputMaybe<Scalars['String']>;
  isFinished?: InputMaybe<Scalars['Int']>;
  lastRun?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentId: Scalars['ID'];
  parentTable: Scalars['String'];
  sendEmail?: InputMaybe<Scalars['Int']>;
  startAfter?: InputMaybe<Scalars['String']>;
  timezoneName: Scalars['String'];
  type: Scalars['String'];
};


export type MutationCreateFbRuleLogArgs = {
  entity: Scalars['String'];
  entityId: Scalars['ID'];
  result: Scalars['String'];
  ruleId: Scalars['ID'];
  runTime: Scalars['String'];
};


export type MutationCreateFbUserArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  email: Scalars['String'];
  hasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  tourFinished?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateReportArgs = {
  action: ReportAction;
  conditions?: InputMaybe<ReadonlyArray<InputMaybe<ReportCondition>>>;
  dataset: Scalars['String'];
  date?: InputMaybe<ReportDateOption>;
  dimensions: ReadonlyArray<InputMaybe<Scalars['String']>>;
  externalAdvertiserIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  filters?: InputMaybe<ReadonlyArray<InputMaybe<ReportFilterOption>>>;
  hideZeroRows?: InputMaybe<Scalars['Boolean']>;
  language: ReportLanguage;
  metrics: ReadonlyArray<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  overviewType?: InputMaybe<ReportOverview>;
  reportReady?: InputMaybe<Scalars['Boolean']>;
  schedule: ReportSchedule;
  scope?: InputMaybe<ReportScope>;
  token: Scalars['String'];
};


export type MutationCreateReportGoogleAccessArgs = {
  adminUserId: Scalars['ID'];
  hash: Scalars['ID'];
  password?: InputMaybe<Scalars['String']>;
};


export type MutationCreateSmsapiDutyScheduleArgs = {
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  externalAdvertiserId: Scalars['ID'];
  recipients: ReadonlyArray<InputMaybe<Scalars['ID']>>;
};


export type MutationCreateSmsapiMessageArgs = {
  message: Scalars['String'];
  recipients: ReadonlyArray<InputMaybe<Scalars['ID']>>;
  sender?: InputMaybe<Scalars['String']>;
};


export type MutationCreateTransactionExternalArgs = {
  amountInput: FbSpendCap;
  bankId: Scalars['ID'];
  externalAdAccountId: Scalars['ID'];
  transactionExternalDescription?: InputMaybe<Scalars['String']>;
};


export type MutationCreateWalletDepositArgs = {
  bankId: Scalars['ID'];
  depositAmount: Scalars['Float'];
  depositDescription?: InputMaybe<Scalars['String']>;
  depositPaymentType: PaymentType;
};


export type MutationCreateWithdrawArgs = {
  bankId: Scalars['ID'];
  externalAdAccountId: Scalars['ID'];
  withdrawAmount: Scalars['Float'];
  withdrawDescription?: InputMaybe<Scalars['String']>;
  withdrawIncomeTaxBasePercentage?: InputMaybe<Scalars['Float']>;
  withdrawIncomeTaxPercentage?: InputMaybe<Scalars['Float']>;
  withdrawReferenceFinal?: InputMaybe<Scalars['String']>;
  withdrawStatus: DepositStatus;
  withdrawTaxPercentage?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateZohoContactArgs = {
  billingAddress?: InputMaybe<ZohoAddress>;
  companyName?: InputMaybe<Scalars['String']>;
  contactName: Scalars['String'];
  contactPersons?: InputMaybe<ReadonlyArray<InputMaybe<ZohoContactPerson>>>;
  contactType?: InputMaybe<Scalars['String']>;
  creditLimit?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  customFields?: InputMaybe<ReadonlyArray<InputMaybe<ZohoCustomField>>>;
  customerSubType?: InputMaybe<Scalars['String']>;
  defaultTemplates?: InputMaybe<ZohoDefaultTemplates>;
  exchangeRate?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  gstNo?: InputMaybe<Scalars['String']>;
  gstTreatment?: InputMaybe<ZohoGstTreatment>;
  isPortalEnabled?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<ZohoLanguageCode>;
  notes?: InputMaybe<Scalars['String']>;
  openingBalanceAmount?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  ownerId?: InputMaybe<Scalars['ID']>;
  paymentTerms?: InputMaybe<Scalars['Int']>;
  paymentTermsLabel?: InputMaybe<Scalars['String']>;
  placeOfContact?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<ZohoAddress>;
  tags?: InputMaybe<ReadonlyArray<InputMaybe<ZohoTag>>>;
  taxAuthorityName?: InputMaybe<Scalars['String']>;
  taxExemptionCode?: InputMaybe<Scalars['String']>;
  taxExemptionId?: InputMaybe<Scalars['ID']>;
  taxId?: InputMaybe<Scalars['ID']>;
  twitter?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};


export type MutationCreateZohoCustomerPaymentArgs = {
  amount: Scalars['String'];
  bankCharges?: InputMaybe<Scalars['Float']>;
  customFields?: InputMaybe<ReadonlyArray<InputMaybe<ZohoCustomField>>>;
  customerId: Scalars['String'];
  date: Scalars['zohoDate'];
  description?: InputMaybe<Scalars['String']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  invoices?: InputMaybe<ReadonlyArray<InputMaybe<ZohoInputInvoice>>>;
  paymentMode: ZohoPaymentMode;
  referenceNumber?: InputMaybe<Scalars['String']>;
};


export type MutationCreateZohoInvoiceArgs = {
  adjustment?: InputMaybe<Scalars['String']>;
  adjustmentDescription?: InputMaybe<Scalars['String']>;
  allowPartialPayments?: InputMaybe<Scalars['Boolean']>;
  contactPersons?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  customBody?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<ReadonlyArray<InputMaybe<ZohoCustomField>>>;
  customSubject?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  date: Scalars['zohoDate'];
  discount?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['zohoDate']>;
  exchangeRate?: InputMaybe<Scalars['Int']>;
  gstNo?: InputMaybe<Scalars['String']>;
  gstTreatment?: InputMaybe<ZohoGstTreatment>;
  invoiceEstimateId?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isDiscountBeforeTax?: InputMaybe<Scalars['Boolean']>;
  isInclusiveTax?: InputMaybe<Scalars['Boolean']>;
  lineItems: ReadonlyArray<InputMaybe<ZohoLineItem>>;
  notes?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  paymentOptions?: InputMaybe<ZohoPaymentOptions>;
  paymentTerms?: InputMaybe<Scalars['String']>;
  paymentTermsLabel?: InputMaybe<Scalars['String']>;
  placeOfSupply?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  quickCreatePayment?: InputMaybe<ZohoQuickCreatePayment>;
  reason?: InputMaybe<Scalars['String']>;
  recurringInvoiceId?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  salespersonName?: InputMaybe<Scalars['String']>;
  shippingCharge?: InputMaybe<Scalars['String']>;
  taxExemptionId?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['String']>;
};


export type MutationCreateZohoItemArgs = {
  description?: InputMaybe<Scalars['String']>;
  hsnOrSac?: InputMaybe<Scalars['String']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  itemTaxPreferences?: InputMaybe<ZohoItemTaxPreferences>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  productType?: InputMaybe<ZohoProductType>;
  rate: Scalars['String'];
  sku?: InputMaybe<Scalars['String']>;
  taxExemptionId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateZohoUserArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  userRole?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteFbCreditSettingsArgs = {
  entityId: Scalars['String'];
  entityType: Scalars['String'];
};


export type MutationDeleteFbExtendedCreditInvoiceGroupArgs = {
  extendedCreditInvoiceGroupId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
};


export type MutationDeleteImportSettingsArgs = {
  entityId: Scalars['ID'];
  entityType: EntityType;
  settingName: SettingName;
};


export type MutationDisableFbAdAccountStatsArgs = {
  externalAdAccountId: Scalars['ID'];
};


export type MutationEmailArgs = {
  attachmentEncoding?: InputMaybe<Scalars['String']>;
  attachmentFilename?: InputMaybe<Scalars['String']>;
  attachmentMimetype?: InputMaybe<Scalars['String']>;
  attachmentPath?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  destinationCCs?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  destinationEmails: ReadonlyArray<InputMaybe<Scalars['String']>>;
  message?: InputMaybe<Scalars['String']>;
  messageHtml?: InputMaybe<Scalars['String']>;
  messageTxt?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  template?: InputMaybe<Scalars['String']>;
};


export type MutationEnableFbAdAccountStatsArgs = {
  externalAdAccountId: Scalars['ID'];
};


export type MutationImportNewExternalFbAdAccountsArgs = {
  filter?: InputMaybe<ExternalFbAdAccountFilter>;
};


export type MutationInsertFbCreditSettingsTransactionArgs = {
  entityId: Scalars['ID'];
  entityType: Scalars['String'];
  transactionValue: Scalars['Float'];
};


export type MutationJsErrorTraceArgs = {
  app: JsTraceAppOptions;
  col?: InputMaybe<Scalars['Int']>;
  componentName?: InputMaybe<Scalars['String']>;
  componentStack?: InputMaybe<Scalars['String']>;
  ln?: InputMaybe<Scalars['Int']>;
  locationUrl?: InputMaybe<Scalars['String']>;
  msg: Scalars['String'];
  stackTrace?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationLinkFbAdAccountsWithCustomerArgs = {
  customerId: Scalars['ID'];
  externalAdAccountId: ReadonlyArray<InputMaybe<Scalars['ID']>>;
  externalAdvertiserId: Scalars['ID'];
};


export type MutationLockFbAdAccountArgs = {
  businessId: Scalars['String'];
  externalAdAccountId: Scalars['String'];
  lockReason: Scalars['String'];
  ruleId?: InputMaybe<Scalars['Int']>;
};


export type MutationRefreshFbAdAccountsArgs = {
  filter?: InputMaybe<ExternalFbAdAccountFilter>;
};


export type MutationRemoveFbAdAccountFromFbExtendedCreditInvoiceGroupArgs = {
  extendedCreditInvoiceGroupId: Scalars['String'];
  externalAdAccountId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
};


export type MutationSendZohoInvoiceEmailArgs = {
  invoiceId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationSignEContractArgs = {
  eContractHash: Scalars['String'];
  ip: Scalars['String'];
  repDocument?: InputMaybe<UploadFilesInput>;
  signatureImage: UploadFilesInput;
};


export type MutationSyncExternalFbAdAccountArgs = {
  externalAdvertiserId: Scalars['String'];
  externalFbAdAccountInput: ReadonlyArray<InputMaybe<SyncExternalFbAdAccountInput>>;
};


export type MutationTransferFbAdAccountFundsArgs = {
  bankId?: InputMaybe<Scalars['ID']>;
  fromExternalAdAccounts?: InputMaybe<ReadonlyArray<InputMaybe<DepositExternalAdAccountInput>>>;
  toExternalAdAccounts?: InputMaybe<ReadonlyArray<InputMaybe<DepositExternalAdAccountInput>>>;
  transactionExternalId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateAdminUserArgs = {
  adminUserCredentials?: InputMaybe<ReadonlyArray<InputMaybe<Credential>>>;
  adminUserEmail?: InputMaybe<Scalars['EmailType']>;
  adminUserFbEmail?: InputMaybe<Scalars['EmailType']>;
  adminUserHasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  adminUserId: Scalars['ID'];
  adminUserIsDeleted?: InputMaybe<Scalars['Boolean']>;
  adminUserLogin?: InputMaybe<Scalars['String']>;
  adminUserName?: InputMaybe<Scalars['String']>;
  adminUserPassword?: InputMaybe<Scalars['String']>;
  adminUserPhone?: InputMaybe<Scalars['String']>;
  adminUserSurname?: InputMaybe<Scalars['String']>;
  permittedExternalAdvertisers?: InputMaybe<ReadonlyArray<InputMaybe<PermittedExternalAdvertiser>>>;
};


export type MutationUpdateBusinessEmailRecipientsArgs = {
  adminUserIds: ReadonlyArray<InputMaybe<Scalars['ID']>>;
  adminUserNotificationType: Scalars['String'];
  businessId: Scalars['ID'];
};


export type MutationUpdateCustomerNoticeArgs = {
  customerNoticeId: Scalars['ID'];
  customerNoticeIsRead?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateDepositArgs = {
  depositDescription?: InputMaybe<Scalars['String']>;
  depositDiscount?: InputMaybe<Scalars['Float']>;
  depositId: Scalars['ID'];
  depositReferenceFinal?: InputMaybe<Scalars['String']>;
  depositStatus?: InputMaybe<DepositStatus>;
  externalAdAccounts?: InputMaybe<ReadonlyArray<InputMaybe<DepositExternalAdAccountInput>>>;
  piPayCallbackData?: InputMaybe<PiPayCallbackData>;
  sendZohoInvoice?: InputMaybe<Scalars['Boolean']>;
  zohoInvoiceData?: InputMaybe<ZohoDepositData>;
};


export type MutationUpdateFbAdAccountArgs = {
  externalAdAccountId: Scalars['ID'];
  externalAdAccountMaxSpendCap?: InputMaybe<Scalars['Float']>;
  externalAdAccountMinSpendCap?: InputMaybe<Scalars['Float']>;
  externalAdAccountSpendFactor?: InputMaybe<Scalars['Float']>;
  externalAdAccountType?: InputMaybe<AccountType>;
};


export type MutationUpdateFbAdAccountAgenciesArgs = {
  agencies: ReadonlyArray<InputMaybe<FbAdAccountAgenciesInput>>;
  externalAdAccountId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
};


export type MutationUpdateFbAdAccountAssignedUsersArgs = {
  assignedUsers: ReadonlyArray<InputMaybe<FbAdAccountAssignedUsersInput>>;
  externalAdAccountId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
};


export type MutationUpdateFbCreditLimitLogArgs = {
  autoRebalancedCreditLimits?: InputMaybe<ReadonlyArray<InputMaybe<AutoRebalancedCreditLimit>>>;
};


export type MutationUpdateFbCreditSettingsArgs = {
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  spendCapLimit: Scalars['Float'];
};


export type MutationUpdateFbCustomerArgs = {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankLocalAccountNumber?: InputMaybe<Scalars['String']>;
  bankLocalName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  bankTotalAmount?: InputMaybe<Scalars['String']>;
  bankType?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['String']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerCity?: InputMaybe<Scalars['String']>;
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerContractSigned?: InputMaybe<Scalars['Boolean']>;
  customerCountryId?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerFullName?: InputMaybe<Scalars['String']>;
  customerId: Scalars['ID'];
  customerIsActivated?: InputMaybe<Scalars['Boolean']>;
  customerIsDeleted?: InputMaybe<Scalars['Boolean']>;
  customerIsFullyRegistered?: InputMaybe<Scalars['Boolean']>;
  customerIsTest?: InputMaybe<Scalars['Boolean']>;
  customerIsValidated?: InputMaybe<Scalars['Boolean']>;
  customerIsVatCommitted?: InputMaybe<Scalars['Boolean']>;
  customerLocalAddress?: InputMaybe<Scalars['String']>;
  customerLocalCity?: InputMaybe<Scalars['String']>;
  customerLocalCompanyName?: InputMaybe<Scalars['String']>;
  customerLocalCountry?: InputMaybe<Scalars['String']>;
  customerLocalFullName?: InputMaybe<Scalars['String']>;
  customerLocalName?: InputMaybe<Scalars['String']>;
  customerLocalRegNumber?: InputMaybe<Scalars['String']>;
  customerLocalSurname?: InputMaybe<Scalars['String']>;
  customerLocalVatNumber?: InputMaybe<Scalars['String']>;
  customerLocalZip?: InputMaybe<Scalars['String']>;
  customerMailSubscribed?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerOnboardingCompleted?: InputMaybe<Scalars['Boolean']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerProfileImage?: InputMaybe<Scalars['String']>;
  customerProfileImageId?: InputMaybe<Scalars['ID']>;
  customerRegNumber?: InputMaybe<Scalars['String']>;
  customerSalesforceId?: InputMaybe<Scalars['ID']>;
  customerStatus?: InputMaybe<FbTaUserAccountStatusEnum>;
  customerSurname?: InputMaybe<Scalars['String']>;
  customerVatNumber?: InputMaybe<Scalars['String']>;
  customerZip?: InputMaybe<Scalars['String']>;
  externalAdAccountIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  fbUserEmails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type MutationUpdateFbExtendedCreditInvoiceGroupArgs = {
  emails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  extendedCreditInvoiceGroupId: Scalars['String'];
  externalAdvertiserId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFbRuleArgs = {
  actions?: InputMaybe<Scalars['String']>;
  activatedAt?: InputMaybe<Scalars['String']>;
  applyOn?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyAbsolute?: InputMaybe<Scalars['String']>;
  isFinished?: InputMaybe<Scalars['Int']>;
  lastRun?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  parentTable?: InputMaybe<Scalars['String']>;
  ruleId: Scalars['ID'];
  sendEmail?: InputMaybe<Scalars['Int']>;
  startAfter?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFbRuleLogArgs = {
  entity?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['ID']>;
  ruleLogId: Scalars['ID'];
  runTime?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFbUserArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  email?: InputMaybe<Scalars['String']>;
  hasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  tourFinished?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type MutationUpdateImportSettingsArgs = {
  entityId: Scalars['ID'];
  entityType: EntityType;
  settingName: SettingName;
  settingValue: Scalars['String'];
};


export type MutationUpdateReportArgs = {
  action?: InputMaybe<ReportAction>;
  activate?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<ReadonlyArray<InputMaybe<ReportCondition>>>;
  dataset?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<ReportDateOption>;
  delete?: InputMaybe<Scalars['Boolean']>;
  dimensions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  externalAdvertiserIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  filters?: InputMaybe<ReadonlyArray<InputMaybe<ReportFilterOption>>>;
  hideZeroRows?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ReportLanguage>;
  metrics?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  overviewType?: InputMaybe<ReportOverview>;
  reportReady?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<ReportSchedule>;
  scope?: InputMaybe<ReportScope>;
  statReportId: Scalars['ID'];
};


export type MutationUpdateSmsapiDutyScheduleArgs = {
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  externalAdvertiserId: Scalars['ID'];
  recipients: ReadonlyArray<InputMaybe<Scalars['ID']>>;
};


export type MutationUpdateWalletDepositArgs = {
  depositAmount?: InputMaybe<Scalars['Float']>;
  depositDescription?: InputMaybe<Scalars['String']>;
  depositId: Scalars['ID'];
  depositReferenceFinal?: InputMaybe<Scalars['String']>;
  depositStatus?: InputMaybe<DepositStatus>;
};


export type MutationUploadProfileImageArgs = {
  file?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UploadType']>>>;
};


export type MutationUploadSourceMapsArgs = {
  app: JsTraceAppOptions;
  maps: ReadonlyArray<InputMaybe<JsSourceMapData>>;
};

export enum PaymentType {
  /** ABANET - currently not supported */
  Abanet = 'ABANET',
  /** ABA PayWay & ABA Cards */
  AbaPay = 'ABA_PAY',
  /** ACTIVA_PGW - currently not supported */
  ActivaPgw = 'ACTIVA_PGW',
  /** Bank / Wire Transfer */
  Advance = 'ADVANCE',
  /** EFUNDS - currently not supported */
  Efunds = 'EFUNDS',
  /** Moneta - currently not supported */
  Moneta = 'MONETA',
  /** Paypal - currently not supported */
  Paypal = 'PAYPAL',
  /** Pi Pay */
  PiPay = 'PI_PAY',
  /** SSL COMMERZ */
  SslCommerz = 'SSL_COMMERZ',
  /** Stripe */
  Stripe = 'STRIPE',
  /** TRUE MONEY */
  TrueMoney = 'TRUE_MONEY'
}

export type PiPayCallbackData = {
  readonly digest?: InputMaybe<Scalars['String']>;
  readonly orderId?: InputMaybe<Scalars['ID']>;
  readonly processorId?: InputMaybe<Scalars['ID']>;
  readonly status?: InputMaybe<Scalars['String']>;
  readonly transactionId?: InputMaybe<Scalars['ID']>;
};

export type PiPayTransaction = {
  readonly __typename?: 'PiPayTransaction';
  readonly data?: Maybe<Scalars['keyValueData']>;
  readonly resultCode?: Maybe<Scalars['String']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly adminUsers?: Maybe<ReadonlyArray<Maybe<AdminUser>>>;
  readonly authorizeFbExternalAdvertiserUrl?: Maybe<ExternalFbAdvertiserUrl>;
  readonly businessEmailRecipients?: Maybe<ReadonlyArray<Maybe<BusinessEmailRecipients>>>;
  readonly clientsMetadata?: Maybe<ClientsMetadata>;
  readonly countries?: Maybe<ReadonlyArray<Maybe<Country>>>;
  readonly customerNotices?: Maybe<ReadonlyArray<Maybe<CustomerNotice>>>;
  readonly datasetSpecs?: Maybe<Dataset>;
  readonly deposits?: Maybe<ReadonlyArray<Maybe<Deposit>>>;
  readonly eContracts?: Maybe<ReadonlyArray<Maybe<EContract>>>;
  readonly erpAccounts?: Maybe<ReadonlyArray<Maybe<ErpAccount>>>;
  readonly erpInvoices?: Maybe<ReadonlyArray<Maybe<ErpInvoice>>>;
  readonly externalAdAccountPayin?: Maybe<ReadonlyArray<Maybe<ExternalAdAccountPayin>>>;
  readonly externalAdAccountTransactions?: Maybe<ReadonlyArray<Maybe<ExternalAdAccountTransaction>>>;
  readonly externalAdvertisers?: Maybe<ReadonlyArray<Maybe<ExternalAdvertiser>>>;
  readonly externalFbAdAccounts?: Maybe<ReadonlyArray<Maybe<ExternalFbAdAccount>>>;
  readonly fbAccountActivities?: Maybe<ReadonlyArray<Maybe<FbAccountActivity>>>;
  readonly fbAdAccountActivities?: Maybe<ReadonlyArray<Maybe<FbBudgetActivity>>>;
  readonly fbAdAccountAgencies?: Maybe<ReadonlyArray<Maybe<FbAdAccountAgency>>>;
  readonly fbAdAccountAssignedUsers?: Maybe<ReadonlyArray<Maybe<FbAdAccountAssignedUser>>>;
  readonly fbAdAccounts?: Maybe<ReadonlyArray<Maybe<FbAdAccount>>>;
  readonly fbAdAccountsHistory?: Maybe<ReadonlyArray<Maybe<FbAdAccountHistory>>>;
  readonly fbAdAccountsSpendActivity?: Maybe<ReadonlyArray<Maybe<FbAdAccountSpendActivity>>>;
  readonly fbAdminMetaData?: Maybe<FbAdminMetaData>;
  readonly fbBusinessUsers?: Maybe<ReadonlyArray<Maybe<FbBusinessUser>>>;
  readonly fbBusinesses?: Maybe<ReadonlyArray<Maybe<FbBusiness>>>;
  readonly fbCampaigns?: Maybe<ReadonlyArray<Maybe<FbCampaign>>>;
  readonly fbCreditLimitHistory?: Maybe<ReadonlyArray<Maybe<FbCreditLimitHistory>>>;
  readonly fbCreditSettings?: Maybe<ReadonlyArray<Maybe<FbCreditSetting>>>;
  readonly fbCurrencies?: Maybe<ReadonlyArray<Maybe<FbCurrency>>>;
  readonly fbCustomers?: Maybe<ReadonlyArray<Maybe<FbTaUserAccount>>>;
  readonly fbExtendedCreditInvoiceGroups?: Maybe<ReadonlyArray<Maybe<FbExtendedCreditInvoiceGroup>>>;
  readonly fbExtendedCredits?: Maybe<ReadonlyArray<Maybe<FbExtendedCredit>>>;
  readonly fbExternalAdvertisers?: Maybe<ReadonlyArray<Maybe<FbExternalAdvertiser>>>;
  readonly fbLiveExtendedCreditInvoiceGroups?: Maybe<ReadonlyArray<Maybe<FbLiveExtendedCreditInvoiceGroup>>>;
  readonly fbLiveExtendedCredits?: Maybe<ReadonlyArray<Maybe<FbLiveExtendedCredit>>>;
  readonly fbRuleLogs?: Maybe<ReadonlyArray<Maybe<FbRuleLog>>>;
  readonly fbRules?: Maybe<ReadonlyArray<Maybe<FbRule>>>;
  readonly fbStatistics?: Maybe<ReadonlyArray<Maybe<FbStatistics>>>;
  readonly fbStats?: Maybe<ReadonlyArray<Maybe<FbStats>>>;
  readonly fbUser?: Maybe<FbUser>;
  readonly fbUsers?: Maybe<ReadonlyArray<Maybe<FbTaUser>>>;
  readonly fbWallets?: Maybe<ReadonlyArray<Maybe<FbWallet>>>;
  readonly generateReportToken?: Maybe<ReportToken>;
  readonly genericStatistics?: Maybe<GenericStatistics>;
  readonly importSettings?: Maybe<ReadonlyArray<Maybe<ImportSetting>>>;
  readonly liveErpAccounts?: Maybe<ReadonlyArray<Maybe<ExternalErpAccount>>>;
  readonly liveErpInvoices?: Maybe<ReadonlyArray<Maybe<ExternalErpInvoice>>>;
  readonly localeMetadata?: Maybe<LocaleMetadata>;
  readonly paymentInstructions?: Maybe<PaymentInstruction>;
  readonly piPaySettings?: Maybe<PiPaySettings>;
  readonly profileImage?: Maybe<ProfileImage>;
  readonly reallocationLimit?: Maybe<ReadonlyArray<Maybe<ReallocationLimit>>>;
  readonly reportOAuth?: Maybe<ReportOAuth>;
  readonly reports?: Maybe<ReadonlyArray<Maybe<Report>>>;
  readonly selfOnboardingBusinesses?: Maybe<ReadonlyArray<Maybe<SelfOnboardingBusinesses>>>;
  readonly smsapiDutySchedule?: Maybe<ReadonlyArray<Maybe<SmsapiDutySchedule>>>;
  readonly smsapiMessage?: Maybe<ReadonlyArray<Maybe<SmsapiMessage>>>;
  readonly transactionsExternal?: Maybe<ReadonlyArray<Maybe<TransactionExternal>>>;
  readonly verifyPiPayTranasaction?: Maybe<PiPayTransaction>;
  readonly walletPaymentInstructions?: Maybe<WalletPaymentInstruction>;
  readonly withdraws?: Maybe<ReadonlyArray<Maybe<Withdraw>>>;
  readonly zohoContact?: Maybe<ReadonlyArray<Maybe<ZohoContact>>>;
  readonly zohoCurrency?: Maybe<ReadonlyArray<Maybe<ZohoCurrency>>>;
  readonly zohoCustomerPayment?: Maybe<ReadonlyArray<Maybe<ExternalZohoCustomerPayment>>>;
  readonly zohoExchangeRate?: Maybe<Scalars['String']>;
  readonly zohoField?: Maybe<ReadonlyArray<Maybe<ZohoField>>>;
  readonly zohoInvoice?: Maybe<ReadonlyArray<Maybe<ZohoInvoice>>>;
  readonly zohoItem?: Maybe<ReadonlyArray<Maybe<ExternalZohoItem>>>;
  readonly zohoOrganization?: Maybe<ReadonlyArray<Maybe<ZohoOrganization>>>;
  readonly zohoTax?: Maybe<ReadonlyArray<Maybe<ZohoTax>>>;
  readonly zohoUser?: Maybe<ReadonlyArray<Maybe<ExternalZohoUser>>>;
};


export type QueryAdminUsersArgs = {
  filter?: InputMaybe<AdminUserFilter>;
  filterExclude?: InputMaybe<AdminUserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAuthorizeFbExternalAdvertiserUrlArgs = {
  isAdminLogin?: InputMaybe<Scalars['Boolean']>;
  redirectTo: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
};


export type QueryBusinessEmailRecipientsArgs = {
  filter?: InputMaybe<BusinessEmailRecipientsFilter>;
  filterExclude?: InputMaybe<BusinessEmailRecipientsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryCountriesArgs = {
  filter?: InputMaybe<CountryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryDatasetSpecsArgs = {
  culture?: InputMaybe<Scalars['String']>;
  dataset: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<DatasetSpecsProvider>;
};


export type QueryDepositsArgs = {
  filter?: InputMaybe<DepositFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryEContractsArgs = {
  filter?: InputMaybe<EContractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryErpAccountsArgs = {
  filter?: InputMaybe<ErpAccountFilter>;
  filterExclude?: InputMaybe<ErpAccountFilter>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryErpInvoicesArgs = {
  filter?: InputMaybe<ErpInvoiceFilter>;
  filterExclude?: InputMaybe<ErpInvoiceFilter>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryExternalAdAccountPayinArgs = {
  filter?: InputMaybe<ExternalAdAccountPayinFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryExternalAdAccountTransactionsArgs = {
  filter?: InputMaybe<ExternalAdAccountTransactionFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryExternalAdvertisersArgs = {
  filter?: InputMaybe<ExternalAdvertiserFilter>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  listAll?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryExternalFbAdAccountsArgs = {
  filter?: InputMaybe<ExternalFbAdAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryFbAccountActivitiesArgs = {
  filter?: InputMaybe<FbAccountActivityFilter>;
  filterExclude?: InputMaybe<FbAccountActivityFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryFbAdAccountActivitiesArgs = {
  filter?: InputMaybe<FbBudgetActivityFilter>;
  filterExclude?: InputMaybe<FbBudgetActivityFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbAdAccountAgenciesArgs = {
  conditions?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FbAdAccountAgencyFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbAdAccountAssignedUsersArgs = {
  filter?: InputMaybe<FbAdAccountAssignedUserFilter>;
  filterExclude?: InputMaybe<FbAdAccountAssignedUserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbAdAccountsArgs = {
  filter?: InputMaybe<FbAdAccountFilter>;
  filterExclude?: InputMaybe<FbAdAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFbAdAccountsHistoryArgs = {
  filter?: InputMaybe<FbAdAccountHistoryFilter>;
  filterExclude?: InputMaybe<FbAdAccountHistoryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbAdAccountsSpendActivityArgs = {
  filter?: InputMaybe<FbAdAccountSpendActivityFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbBusinessUsersArgs = {
  externalAdvertiserId: Scalars['String'];
  filter?: InputMaybe<FbBusinessUserFilter>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbBusinessesArgs = {
  filter?: InputMaybe<FbBusinessFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbCampaignsArgs = {
  filter?: InputMaybe<FbCampaignFilter>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbCreditLimitHistoryArgs = {
  filter?: InputMaybe<FbCreditLimitHistoryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFbCreditSettingsArgs = {
  filter?: InputMaybe<FbCreditSettingFilter>;
  filterExclude?: InputMaybe<FbCreditSettingFilter>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbCurrenciesArgs = {
  filter?: InputMaybe<FbCurrencyFilter>;
  filterExclude?: InputMaybe<FbCurrencyFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbCustomersArgs = {
  filter?: InputMaybe<FbTaUserAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbExtendedCreditInvoiceGroupsArgs = {
  filter?: InputMaybe<FbExtendedCreditInvoiceGroupFilter>;
  filterExclude?: InputMaybe<FbExtendedCreditInvoiceGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbExtendedCreditsArgs = {
  filter?: InputMaybe<FbExtendedCreditFilter>;
  filterExclude?: InputMaybe<FbExtendedCreditFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbExternalAdvertisersArgs = {
  displayAll?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FbExternalAdvertiserFilter>;
  filterExclude?: InputMaybe<FbExternalAdvertiserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbLiveExtendedCreditInvoiceGroupsArgs = {
  filter?: InputMaybe<FbLiveExtendedCreditInvoiceGroupFilter>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbLiveExtendedCreditsArgs = {
  filter?: InputMaybe<FbLiveExtendedCreditFilter>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbRuleLogsArgs = {
  filter?: InputMaybe<FbRuleLogFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbRulesArgs = {
  filter?: InputMaybe<FbRuleFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbStatisticsArgs = {
  filter?: InputMaybe<FbStatisticsFilter>;
  filterExclude?: InputMaybe<FbStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbStatsArgs = {
  filter: FbStatsFilter;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  removeZeroValues?: InputMaybe<Scalars['Boolean']>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFbUserArgs = {
  filter?: InputMaybe<FbUserFilter>;
};


export type QueryFbUsersArgs = {
  filter?: InputMaybe<FbTaUserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFbWalletsArgs = {
  filter?: InputMaybe<FbWalletFilter>;
  filterExclude?: InputMaybe<FbWalletFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryGenerateReportTokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGenericStatisticsArgs = {
  conditions?: InputMaybe<Scalars['String']>;
  dataset: Scalars['String'];
  filters?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  rows?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  sort?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  transcode?: InputMaybe<Scalars['Boolean']>;
  values?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryImportSettingsArgs = {
  filter?: InputMaybe<ImportSettingFilter>;
  filterExclude?: InputMaybe<ImportSettingFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryLiveErpAccountsArgs = {
  filter: ExternalErpAccountFilter;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLiveErpInvoicesArgs = {
  filter: ExternalErpInvoiceFilter;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPaymentInstructionsArgs = {
  base64Data?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryPiPaySettingsArgs = {
  id: Scalars['ID'];
};


export type QueryProfileImageArgs = {
  customerId: Scalars['ID'];
};


export type QueryReallocationLimitArgs = {
  filter: ReallocationLimitFilter;
};


export type QueryReportOAuthArgs = {
  email?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['ID']>;
};


export type QueryReportsArgs = {
  filter?: InputMaybe<ReportFilter>;
  filterExclude?: InputMaybe<ReportFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySmsapiDutyScheduleArgs = {
  filter?: InputMaybe<SmsapiDutyScheduleFilter>;
  filterExclude?: InputMaybe<SmsapiDutyScheduleFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySmsapiMessageArgs = {
  filter?: InputMaybe<SmsapiMessageFilter>;
  filterExclude?: InputMaybe<SmsapiMessageFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTransactionsExternalArgs = {
  filter?: InputMaybe<TransactionExternalFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryVerifyPiPayTranasactionArgs = {
  merchantId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  processorId?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['String']>;
};


export type QueryWalletPaymentInstructionsArgs = {
  base64Data?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryWithdrawsArgs = {
  filter?: InputMaybe<WithdrawFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryZohoContactArgs = {
  filter?: InputMaybe<ZohoContactFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryZohoCurrencyArgs = {
  filter?: InputMaybe<ZohoCurrencyFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryZohoCustomerPaymentArgs = {
  customerPaymentId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type QueryZohoFieldArgs = {
  filter?: InputMaybe<ZohoFieldFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryZohoInvoiceArgs = {
  filter?: InputMaybe<ZohoInvoiceFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryZohoItemArgs = {
  itemId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type QueryZohoOrganizationArgs = {
  filter?: InputMaybe<ZohoOrganizationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryZohoTaxArgs = {
  filter?: InputMaybe<ZohoTaxFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryZohoUserArgs = {
  organizationId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type SsoUser = {
  readonly accessToken: Scalars['String'];
  readonly accessTokenExpiresAt?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly refreshToken?: InputMaybe<Scalars['String']>;
  readonly username?: InputMaybe<Scalars['String']>;
};

export enum TransactionType {
  /** Add funds to ad accounts */
  Add = 'ADD',
  /** Deposit */
  Deposit = 'DEPOSIT',
  /** Withdraw / Payout */
  Payout = 'PAYOUT',
  /** Remove funds from ad accounts */
  Remove = 'REMOVE',
  /** Transfer between ad accounts */
  Transfer = 'TRANSFER'
}

/** Upload image/s */
export type UploadFilesInput = {
  /** Base64 string */
  readonly file?: InputMaybe<Scalars['String']>;
  readonly files?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UploadType']>>>;
};

export type Ad = {
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** The id of the ad. */
  readonly adId?: Maybe<Scalars['String']>;
  /** The id of the parent campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external id of the ad. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: Maybe<Scalars['String']>;
  /** The name of the ad. */
  readonly name?: Maybe<Scalars['String']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
};

export enum AdminCredentialNameOption {
  /** Permission to see ads */
  Ads = 'ads',
  /** Assigned user permissions modal on Facebook ad accounts */
  AssignedUsers = 'assigned_users',
  /** Permission to see categories */
  Categories = 'categories',
  /** Permission to see categories p */
  CategoriesP = 'categories_p',
  /** Permission to see Experimental ad accounts */
  ExperimentalAdAccounts = 'experimental_ad_accounts',
  /** Permission to approve/deny request for partner change */
  ExternalAdAccountAgency = 'external_ad_account_agency',
  /** Permission to make request for partner change */
  ExternalAdAccountAgencyRequest = 'external_ad_account_agency_request',
  /** Permission to see Facebook ad accounts */
  FbAdAccounts = 'fb_ad_accounts',
  /** Permission to see finance */
  Finance = 'finance',
  /** Permission to see fraud */
  Fraud = 'fraud',
  /** Permission to see notifications */
  Notifications = 'notifications',
  /** Permission to see reports */
  Reports = 'reports',
  /** Permission to see stats */
  Stats = 'stats',
  /** Permission to see system */
  System = 'system',
  /** Permission to see users */
  Users = 'users'
}

export type AdminUser = {
  readonly __typename?: 'adminUser';
  readonly adminUserCredentials?: Maybe<Scalars['MixedType']>;
  readonly adminUserEmail?: Maybe<Scalars['String']>;
  readonly adminUserFbEmail?: Maybe<Scalars['String']>;
  readonly adminUserHasAgreedToTerms?: Maybe<Scalars['Boolean']>;
  readonly adminUserHasAgreedToTermsTime?: Maybe<Scalars['String']>;
  readonly adminUserId?: Maybe<Scalars['ID']>;
  readonly adminUserIsDeleted?: Maybe<Scalars['Boolean']>;
  readonly adminUserLogin?: Maybe<Scalars['String']>;
  readonly adminUserName?: Maybe<Scalars['String']>;
  readonly adminUserPhone?: Maybe<Scalars['String']>;
  readonly adminUserSurname?: Maybe<Scalars['String']>;
  readonly oauthUserId?: Maybe<Scalars['ID']>;
  readonly permittedExternalAdvertisers?: Maybe<ReadonlyArray<Maybe<FbExternalAdvertiser>>>;
};

export type AdminUserFilter = {
  readonly adminUserEmail?: InputMaybe<Scalars['String']>;
  readonly adminUserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly adminUserIsDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly adminUserName?: InputMaybe<Scalars['String']>;
  readonly adminUserSurname?: InputMaybe<Scalars['String']>;
};

export type AutoRebalancedCreditLimit = {
  readonly externalAdAccountId: Scalars['String'];
  readonly spendCapLimit: Scalars['Int'];
};

export type BusinessEmailRecipients = {
  readonly __typename?: 'businessEmailRecipients';
  readonly adminUserEmail?: Maybe<Scalars['String']>;
  readonly adminUserId?: Maybe<Scalars['ID']>;
  readonly adminUserName?: Maybe<Scalars['String']>;
  readonly adminUserNotificationType?: Maybe<Scalars['String']>;
  readonly businessId?: Maybe<Scalars['ID']>;
  readonly businessName?: Maybe<Scalars['String']>;
};

export type BusinessEmailRecipientsFilter = {
  readonly adminUserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly adminUserName?: InputMaybe<Scalars['String']>;
  readonly adminUserNotificationType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly businessId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly businessName?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId?: InputMaybe<Scalars['ID']>;
};

export type Campaign = {
  /** The id of the campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external id of the campaign. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** The name of the campaign. */
  readonly name?: Maybe<Scalars['String']>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
};

export type ClientsMetadata = {
  readonly __typename?: 'clientsMetadata';
  readonly selfOnboardingBusinesses?: Maybe<ReadonlyArray<Maybe<SelfOnboardingBusinesses>>>;
};

export type Country = {
  readonly __typename?: 'country';
  readonly countryId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type CountryFilter = {
  readonly countryId?: InputMaybe<Scalars['ID']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type Credential = {
  readonly delete?: InputMaybe<Scalars['Boolean']>;
  readonly name: AdminCredentialNameOption;
  readonly read?: InputMaybe<Scalars['Boolean']>;
  readonly write?: InputMaybe<Scalars['Boolean']>;
};

export type Credentials = {
  readonly __typename?: 'credentials';
  readonly delete?: Maybe<Scalars['Boolean']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly read?: Maybe<Scalars['Boolean']>;
  readonly write?: Maybe<Scalars['Boolean']>;
};

export type CustomerNotice = {
  readonly __typename?: 'customerNotice';
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly customerNoticeDateAdded?: Maybe<Scalars['String']>;
  readonly customerNoticeId?: Maybe<Scalars['ID']>;
  readonly customerNoticeIsDeleted?: Maybe<Scalars['Boolean']>;
  readonly customerNoticeIsMass?: Maybe<Scalars['Boolean']>;
  readonly customerNoticeIsNews?: Maybe<Scalars['Boolean']>;
  readonly customerNoticeIsRead?: Maybe<Scalars['Boolean']>;
  readonly customerNoticeIsTranslated?: Maybe<Scalars['Boolean']>;
  readonly customerNoticeMessage?: Maybe<Scalars['String']>;
  readonly customerNoticeNoticeType?: Maybe<Scalars['String']>;
  readonly customerNoticeTitle?: Maybe<Scalars['String']>;
  readonly customerNoticeVisible?: Maybe<Scalars['Boolean']>;
};

export enum CustomerNoticeTypeEnum {
  Advertiser = 'ADVERTISER',
  Publisher = 'PUBLISHER'
}

export type Customers = {
  readonly __typename?: 'customers';
  readonly customerEmail?: Maybe<Scalars['String']>;
  readonly customerFullName?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['ID']>;
};

/** Facebook deposits */
export type Deposit = {
  readonly __typename?: 'deposit';
  readonly bankAccountNumber?: Maybe<Scalars['String']>;
  readonly bankAccountType?: Maybe<Scalars['String']>;
  readonly bankCurrency?: Maybe<Scalars['String']>;
  readonly bankId?: Maybe<Scalars['ID']>;
  readonly customerAddress?: Maybe<Scalars['String']>;
  readonly customerCity?: Maybe<Scalars['String']>;
  readonly customerCompanyName?: Maybe<Scalars['String']>;
  readonly customerEmail?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly customerMinAmount?: Maybe<Scalars['Float']>;
  readonly customerName?: Maybe<Scalars['String']>;
  readonly customerSurname?: Maybe<Scalars['String']>;
  readonly customerVatNumber?: Maybe<Scalars['String']>;
  readonly customerZip?: Maybe<Scalars['String']>;
  readonly depositAmount?: Maybe<Scalars['Float']>;
  readonly depositDescription?: Maybe<Scalars['String']>;
  readonly depositDiscount?: Maybe<Scalars['Float']>;
  readonly depositEntryDate?: Maybe<Scalars['String']>;
  readonly depositId?: Maybe<Scalars['ID']>;
  readonly depositInvoiceNumber?: Maybe<Scalars['String']>;
  readonly depositInvoiceUrl?: Maybe<Scalars['String']>;
  readonly depositLink?: Maybe<Scalars['String']>;
  /** @deprecated Field is not performant and it should never be used when requesting more than 1 deposit */
  readonly depositModifierFullName?: Maybe<Scalars['String']>;
  readonly depositPaymentDueTime?: Maybe<Scalars['String']>;
  readonly depositPaymentType?: Maybe<Scalars['String']>;
  /** base64 encoded proforma invoice pdf. */
  readonly depositProformaInvoice?: Maybe<Scalars['String']>;
  readonly depositReferenceFinal?: Maybe<Scalars['String']>;
  readonly depositReferenceNumber?: Maybe<Scalars['Int']>;
  readonly depositReferenceYear?: Maybe<Scalars['Int']>;
  readonly depositStatus?: Maybe<Scalars['String']>;
  readonly depositStatusTime?: Maybe<Scalars['String']>;
  readonly depositTaxPercentage?: Maybe<Scalars['Float']>;
  /** @deprecated Field deprecated in favor of new field called bankCurrency */
  readonly externalAdAccountCurrency?: Maybe<Scalars['String']>;
  readonly externalAdAccountTransactions?: Maybe<ReadonlyArray<Maybe<ExternalAdAccountTransaction>>>;
};

export type DepositExternalAdAccountInput = {
  /** Currency amount which will be applied to the ad account. */
  readonly amount: Scalars['Float'];
  /** ID of external Facebook ad account to which the operation should be applied. */
  readonly externalAdAccountId: Scalars['ID'];
};

export type DepositFilter = {
  readonly bankAccountType?: InputMaybe<AccountType>;
  readonly bankId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerCompanyName?: InputMaybe<Scalars['String']>;
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerName?: InputMaybe<Scalars['String']>;
  readonly customerSurname?: InputMaybe<Scalars['String']>;
  readonly depositEntryDateFrom?: InputMaybe<Scalars['String']>;
  readonly depositEntryDateTo?: InputMaybe<Scalars['String']>;
  readonly depositId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly depositInvoiceNumber?: InputMaybe<Scalars['String']>;
  readonly depositPaymentType?: InputMaybe<PaymentType>;
  readonly depositReferenceNumber?: InputMaybe<Scalars['Int']>;
  readonly depositReferenceYear?: InputMaybe<Scalars['Int']>;
  readonly depositStatus?: InputMaybe<ReadonlyArray<InputMaybe<DepositStatus>>>;
  readonly depositStatusTime?: InputMaybe<Scalars['String']>;
  readonly depositTaxPercentage?: InputMaybe<Scalars['Float']>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type EContract = {
  readonly __typename?: 'eContract';
  readonly bankAccountNumber: Scalars['String'];
  readonly bankName: Scalars['String'];
  readonly companyAddress?: Maybe<Scalars['String']>;
  readonly companyContactEmail?: Maybe<Scalars['String']>;
  readonly companyContactName?: Maybe<Scalars['String']>;
  readonly companyContactSurname?: Maybe<Scalars['String']>;
  readonly companyName?: Maybe<Scalars['String']>;
  readonly companyRepEmail?: Maybe<Scalars['String']>;
  readonly companyRepName?: Maybe<Scalars['String']>;
  readonly companyRepSurname?: Maybe<Scalars['String']>;
  readonly companyRepTitle?: Maybe<Scalars['String']>;
  readonly contractsHtml?: Maybe<Scalars['keyValueData']>;
  readonly eContractFiles?: Maybe<Scalars['keyValueData']>;
  readonly eContractHash?: Maybe<Scalars['String']>;
  readonly eContractId?: Maybe<Scalars['ID']>;
  readonly isVatCommitted?: Maybe<Scalars['Boolean']>;
  readonly regNumber?: Maybe<Scalars['String']>;
  readonly repDocument?: Maybe<Scalars['String']>;
  readonly signedAt?: Maybe<Scalars['String']>;
  readonly taUserAccountId?: Maybe<Scalars['ID']>;
  readonly taxNumber?: Maybe<Scalars['String']>;
  readonly validTo?: Maybe<Scalars['String']>;
  readonly variants?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};

export type EContractFilter = {
  readonly eContractHash?: InputMaybe<Scalars['String']>;
  readonly eContractId?: InputMaybe<Scalars['ID']>;
  readonly taUserAccountId?: InputMaybe<Scalars['ID']>;
};

export type Email = {
  readonly __typename?: 'email';
  readonly id?: Maybe<Scalars['String']>;
};

export enum EntityType {
  /** Business */
  Business = 'business',
  /** Global */
  Global = 'global',
  /** Invoice group */
  InvoiceGroup = 'invoice_group'
}

export type ErpAccount = {
  readonly __typename?: 'erpAccount';
  readonly addressCountryRegion?: Maybe<Scalars['MixedType']>;
  readonly addressCountryRegionId?: Maybe<Scalars['MixedType']>;
  readonly addressStreet?: Maybe<Scalars['MixedType']>;
  readonly customerAccountId?: Maybe<Scalars['MixedType']>;
  readonly dataAreaId?: Maybe<Scalars['MixedType']>;
  readonly erpAccountId?: Maybe<Scalars['MixedType']>;
  readonly fullPrimaryAddress?: Maybe<Scalars['MixedType']>;
  readonly knownAs?: Maybe<Scalars['MixedType']>;
  readonly nameAlias?: Maybe<Scalars['MixedType']>;
  readonly organizationName?: Maybe<Scalars['MixedType']>;
  readonly partyCountry?: Maybe<Scalars['MixedType']>;
  readonly partyNumber?: Maybe<Scalars['MixedType']>;
  readonly partyType?: Maybe<Scalars['MixedType']>;
  readonly primaryContactPhone?: Maybe<Scalars['MixedType']>;
  readonly primaryContactPhoneRecordId?: Maybe<Scalars['MixedType']>;
  readonly primaryContactUrl?: Maybe<Scalars['MixedType']>;
  readonly salesTaxGroup?: Maybe<Scalars['MixedType']>;
  readonly taUserAccountId?: Maybe<Scalars['MixedType']>;
};

export type ErpAccountFilter = {
  readonly addressCountryRegionId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly dataAreaId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly erpAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly partyCountry?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly partyType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly salesTaxGroup?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly taUserAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export type ErpInvoice = {
  readonly __typename?: 'erpInvoice';
  readonly currencyCode?: Maybe<Scalars['MixedType']>;
  readonly dataAreaId?: Maybe<Scalars['MixedType']>;
  readonly erpAccountId?: Maybe<Scalars['MixedType']>;
  readonly insertionOrderNumber?: Maybe<Scalars['MixedType']>;
  readonly invoiceAmount?: Maybe<Scalars['MixedType']>;
  readonly invoiceCustomerAccount?: Maybe<Scalars['MixedType']>;
  readonly invoiceDate?: Maybe<Scalars['MixedType']>;
  readonly invoiceNumber?: Maybe<Scalars['MixedType']>;
  readonly journalCreatedDateTime?: Maybe<Scalars['MixedType']>;
  readonly journalRecId?: Maybe<Scalars['MixedType']>;
  readonly salesOrderNumber?: Maybe<Scalars['MixedType']>;
};

export type ErpInvoiceFilter = {
  readonly currencyCode?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly dataAreaId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly erpAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly insertionOrderNumber?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly invoiceAmount?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly invoiceCustomerAccount?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly invoiceDate?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly invoiceNumber?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly journalCreatedDateTime?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly journalRecId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly salesOrderNumber?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type ExternalAdAccountPayin = {
  readonly __typename?: 'externalAdAccountPayin';
  readonly amount?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  readonly payinId?: Maybe<Scalars['MixedType']>;
  readonly status?: Maybe<Scalars['MixedType']>;
};

export type ExternalAdAccountPayinFilter = {
  readonly payinId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

/** External ad account transaction */
export type ExternalAdAccountTransaction = {
  readonly __typename?: 'externalAdAccountTransaction';
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly depositId?: Maybe<Scalars['ID']>;
  readonly externalAdAccountCurrency?: Maybe<Scalars['String']>;
  readonly externalAdAccountId?: Maybe<Scalars['ID']>;
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  readonly externalAdAccountTransactionAmount?: Maybe<Scalars['Float']>;
  readonly externalAdAccountTransactionId?: Maybe<Scalars['ID']>;
  readonly externalAdAccountTransactionModificationTime?: Maybe<Scalars['String']>;
  readonly externalAdAccountTransactionStatus?: Maybe<Scalars['String']>;
  readonly transactionExternalId?: Maybe<Scalars['ID']>;
  readonly transactionExternalTransactionType?: Maybe<Scalars['String']>;
  readonly transactionId?: Maybe<Scalars['ID']>;
  readonly withdrawId?: Maybe<Scalars['ID']>;
};

export type ExternalAdAccountTransactionFilter = {
  readonly customerId?: InputMaybe<Scalars['ID']>;
  readonly depositId?: InputMaybe<Scalars['ID']>;
  readonly externalAdAccountTransactionId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdAccountTransactionStatus?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly withdrawId?: InputMaybe<Scalars['ID']>;
};

export type ExternalAdvertiser = {
  readonly __typename?: 'externalAdvertiser';
  readonly accessToken?: Maybe<Scalars['MixedType']>;
  readonly accessTokenExpiresAt?: Maybe<Scalars['MixedType']>;
  readonly accessTokenValid?: Maybe<Scalars['MixedType']>;
  readonly adminUserId?: Maybe<Scalars['MixedType']>;
  readonly agencyId?: Maybe<Scalars['MixedType']>;
  readonly currency?: Maybe<Scalars['MixedType']>;
  readonly deletedAt?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserId?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserName?: Maybe<Scalars['MixedType']>;
  readonly graph?: Maybe<Scalars['MixedType']>;
  readonly id?: Maybe<Scalars['MixedType']>;
  readonly isActive?: Maybe<Scalars['MixedType']>;
  readonly name?: Maybe<Scalars['MixedType']>;
  readonly refreshToken?: Maybe<Scalars['MixedType']>;
  readonly seat?: Maybe<Scalars['MixedType']>;
  readonly supplier?: Maybe<Scalars['MixedType']>;
  readonly supportedAdServers?: Maybe<Scalars['MixedType']>;
  readonly taUserAccountId?: Maybe<Scalars['MixedType']>;
  readonly userData?: Maybe<Scalars['MixedType']>;
  readonly userId?: Maybe<Scalars['MixedType']>;
};

export type ExternalAdvertiserFilter = {
  readonly accessTokenValid?: InputMaybe<Scalars['Boolean']>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdvertiserName?: InputMaybe<Scalars['String']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']>;
  readonly supplier?: InputMaybe<ReadonlyArray<InputMaybe<Supplier>>>;
  readonly taUserAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

/** ERP account (live call) */
export type ExternalErpAccount = {
  readonly __typename?: 'externalErpAccount';
  readonly addressCountryRegionId?: Maybe<Scalars['MixedType']>;
  readonly addressStreet?: Maybe<Scalars['MixedType']>;
  readonly customerAccountId?: Maybe<Scalars['MixedType']>;
  readonly dataAreaId?: Maybe<Scalars['MixedType']>;
  readonly fullPrimaryAddress?: Maybe<Scalars['MixedType']>;
  readonly knownAs?: Maybe<Scalars['MixedType']>;
  readonly nameAlias?: Maybe<Scalars['MixedType']>;
  readonly organizationName?: Maybe<Scalars['MixedType']>;
  readonly partyNumber?: Maybe<Scalars['MixedType']>;
  readonly partyType?: Maybe<Scalars['MixedType']>;
  readonly primaryContactPhone?: Maybe<Scalars['MixedType']>;
  readonly primaryContactPhoneRecordId?: Maybe<Scalars['MixedType']>;
  readonly primaryContactUrl?: Maybe<Scalars['MixedType']>;
  readonly salesTaxGroup?: Maybe<Scalars['MixedType']>;
  readonly taxExemptNumber?: Maybe<Scalars['MixedType']>;
};

export type ExternalErpAccountFilter = {
  readonly customerAccount?: InputMaybe<Scalars['ID']>;
  readonly dataAreaId: Scalars['ID'];
  readonly organizationName?: InputMaybe<Scalars['String']>;
  readonly taxExemptNumber?: InputMaybe<Scalars['String']>;
};

/** ERP account (live call) */
export type ExternalErpInvoice = {
  readonly __typename?: 'externalErpInvoice';
  readonly currencyCode?: Maybe<Scalars['MixedType']>;
  readonly dataAreaId?: Maybe<Scalars['MixedType']>;
  readonly insertionOrderNumber?: Maybe<Scalars['MixedType']>;
  readonly invoiceAmount?: Maybe<Scalars['MixedType']>;
  readonly invoiceCustomerAccount?: Maybe<Scalars['MixedType']>;
  readonly invoiceDate?: Maybe<Scalars['MixedType']>;
  readonly invoiceNumber?: Maybe<Scalars['MixedType']>;
  readonly journalCreatedDateTime?: Maybe<Scalars['MixedType']>;
  readonly journalRecId?: Maybe<Scalars['MixedType']>;
  readonly salesOrderNumber?: Maybe<Scalars['MixedType']>;
};

export type ExternalErpInvoiceFilter = {
  readonly customerAccount?: InputMaybe<Scalars['ID']>;
  readonly dataAreaId: Scalars['ID'];
};

export type ExternalFbAdAccount = {
  readonly __typename?: 'externalFbAdAccount';
  readonly amountSpent?: Maybe<Scalars['String']>;
  readonly balance?: Maybe<Scalars['String']>;
  readonly business?: Maybe<Scalars['keyValueData']>;
  readonly currency?: Maybe<Scalars['String']>;
  readonly endAdvertiserId?: Maybe<Scalars['String']>;
  readonly endAdvertiserName?: Maybe<Scalars['String']>;
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  readonly spendCap?: Maybe<Scalars['String']>;
  readonly timezoneId?: Maybe<Scalars['String']>;
  readonly timezoneName?: Maybe<Scalars['String']>;
};

export type ExternalFbAdAccountFilter = {
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdvertiserId: Scalars['String'];
};

export type ExternalFbAdvertiserUrl = {
  readonly __typename?: 'externalFbAdvertiserUrl';
  readonly url?: Maybe<Scalars['String']>;
};

export type ExternalTwCampaign = {
  readonly __typename?: 'externalTwCampaign';
  readonly accountId?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  /** Currency (budget, bid) */
  readonly currency?: Maybe<Scalars['String']>;
  /** The daily budget amount to be allocated to the campaign. */
  readonly dailyBudget?: Maybe<Scalars['String']>;
  /** The time that the campaign will begin. */
  readonly dateFrom?: Maybe<Scalars['String']>;
  /** The time that the campaign will end. */
  readonly dateTo?: Maybe<Scalars['String']>;
  /** Deleted date of campaign. */
  readonly deletedAt?: Maybe<Scalars['String']>;
  readonly deliveryType?: Maybe<Scalars['Boolean']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external id of the campaign. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  readonly fundingInstrumentId?: Maybe<Scalars['String']>;
  /** The name of the campaign. */
  readonly name?: Maybe<Scalars['String']>;
  /** The status of the campaign. Representing status on the external system. */
  readonly status?: Maybe<TwStatus>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
  /** The total budget amount to be allocated to the campaign. */
  readonly totalBudget?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['String']>;
};

export type ExternalZohoCustomerPayment = {
  readonly __typename?: 'externalZohoCustomerPayment';
  /** Amount paid in the respective payment. */
  readonly amount?: Maybe<Scalars['Float']>;
  /** Amount that is refunded. Refunds are applicable only for payments whose payment_mode is autotransaction. Refunds would be made to the respective card provided by the customer. */
  readonly amountRefunded?: Maybe<Scalars['Float']>;
  /** Customer's currency symbol. */
  readonly bankCharges?: Maybe<Scalars['Float']>;
  /** Currency code in which the payment is made. */
  readonly currencyCode?: Maybe<Scalars['String']>;
  /** Customer's currency symbol. */
  readonly currencySymbol?: Maybe<Scalars['String']>;
  /** Customer ID of the customer involved in the payment. */
  readonly customerId?: Maybe<Scalars['String']>;
  /** Name of the customer to whom the invoice is raised. Maximum length: 100 */
  readonly customerName?: Maybe<Scalars['String']>;
  /** Date on which payment is made. Date Format [yyyy-mm-dd] */
  readonly date?: Maybe<Scalars['String']>;
  /** Description about the payment. */
  readonly description?: Maybe<Scalars['String']>;
  /** Email address of the customer involved in the payment. */
  readonly email?: Maybe<Scalars['String']>;
  /** Exchange rate for the currency used in the invoices and customer's currency. The payment amount would be the multiplicative product of the original amount and the exchange rate. */
  readonly exchangeRate?: Maybe<Scalars['Float']>;
  /** List of invoices associated with the payment. Each invoice object contains invoice_id, invoice_number, date, invoice_amount, amount_applied and balance_amount. */
  readonly invoices?: Maybe<Scalars['MixedType']>;
  /** Unique ID of the payment generated by the server. Maximum length allowed: 2000 */
  readonly paymentId?: Maybe<Scalars['String']>;
  /** Mode through which payment is made. This can be check, cash, creditcard, banktransfer, bankremittance, autotransaction or others. Maximum length: 100 */
  readonly paymentMode?: Maybe<Scalars['String']>;
  /** Reference number generated for the payment. A string of your choice can also be used as the reference number. Maximum length of the reference number: 100 */
  readonly referenceNumber?: Maybe<Scalars['String']>;
  /** Status of the payment. It can either be success or failure. */
  readonly status?: Maybe<Scalars['String']>;
};

export type ExternalZohoItem = {
  readonly __typename?: 'externalZohoItem';
  /** Description for the item. Maximum characters to be used for describing the item: 2000. */
  readonly description?: Maybe<Scalars['String']>;
  /** Unique ID generated by the server for an item. */
  readonly itemId?: Maybe<Scalars['String']>;
  /** Name of the item. Maximum length of the name: 100. */
  readonly name?: Maybe<Scalars['String']>;
  /** Specify the type of an item. It can be either goods or service */
  readonly productType?: Maybe<Scalars['String']>;
  /** SKU or the Stock Keeping Unit value of an item, should be unique throughout the product. */
  readonly sku?: Maybe<Scalars['String']>;
  /** Status of the item. It can be active or inactive. It tells whether the Item is available for transactions. */
  readonly status?: Maybe<Scalars['String']>;
  /** Quantifying the amount of an item, using a measurement unit. */
  readonly unit?: Maybe<Scalars['String']>;
};

export type ExternalZohoUser = {
  readonly __typename?: 'externalZohoUser';
  /** Email address of the user. */
  readonly email?: Maybe<Scalars['String']>;
  /** Name of the user. */
  readonly name?: Maybe<Scalars['String']>;
  /** User ID */
  readonly userId?: Maybe<Scalars['String']>;
};

/** Ad account activity */
export type FbAccountActivity = {
  readonly __typename?: 'fbAccountActivity';
  readonly actorId?: Maybe<Scalars['ID']>;
  readonly actorName?: Maybe<Scalars['String']>;
  readonly applicationId?: Maybe<Scalars['ID']>;
  readonly applicationName?: Maybe<Scalars['String']>;
  readonly category?: Maybe<Scalars['String']>;
  /** @deprecated Field replaced with importedAt */
  readonly createdAt?: Maybe<Scalars['MixedType']>;
  readonly eventTime?: Maybe<Scalars['String']>;
  readonly eventTimeInTimezone?: Maybe<Scalars['String']>;
  /** @deprecated Field replaced with eventTime */
  readonly eventTimeInUtc?: Maybe<Scalars['MixedType']>;
  readonly eventType?: Maybe<Scalars['String']>;
  readonly extendedCreditInvoiceGroupId?: Maybe<Scalars['ID']>;
  readonly externalAdAccountId?: Maybe<Scalars['ID']>;
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  readonly externalAdAccountTimezone?: Maybe<Scalars['String']>;
  readonly externalAdAccountType?: Maybe<Scalars['String']>;
  readonly externalAdvertiserId?: Maybe<Scalars['ID']>;
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  readonly extraData?: Maybe<Scalars['MixedType']>;
  readonly importedAt?: Maybe<Scalars['String']>;
  /** @deprecated Field replaced with importedAt */
  readonly importedAtInUtc?: Maybe<Scalars['MixedType']>;
  readonly objectId?: Maybe<Scalars['ID']>;
  readonly objectName?: Maybe<Scalars['String']>;
  readonly objectType?: Maybe<Scalars['String']>;
  readonly translatedEventType?: Maybe<Scalars['String']>;
};

export type FbAccountActivityFilter = {
  readonly actorId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly actorName?: InputMaybe<Scalars['String']>;
  readonly applicationId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly applicationName?: InputMaybe<Scalars['String']>;
  readonly category?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly eventTime?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly eventType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly extendedCreditInvoiceGroupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdAccountName?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdvertiserName?: InputMaybe<Scalars['String']>;
  readonly importedAt?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly importedAtInUtc?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly objectId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly objectName?: InputMaybe<Scalars['String']>;
  readonly objectType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type FbAdAccount = {
  readonly __typename?: 'fbAdAccount';
  readonly customerEmail?: Maybe<Scalars['String']>;
  readonly customerFullName?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly extendedCreditInvoiceGroupDefaultSpendCapLimit?: Maybe<Scalars['Float']>;
  readonly extendedCreditInvoiceGroupId?: Maybe<Scalars['ID']>;
  readonly extendedCreditInvoiceGroupName?: Maybe<Scalars['String']>;
  readonly extendedCreditInvoiceGroupSpendCapLimit?: Maybe<Scalars['Float']>;
  readonly extendedCreditInvoiceGroupSpendCapLimitTransaction?: Maybe<Scalars['Float']>;
  readonly externalAdAccountAmountSpent?: Maybe<Scalars['Float']>;
  readonly externalAdAccountAmountSpentInCents?: Maybe<Scalars['Int']>;
  readonly externalAdAccountAutoRebalancedSpendCapLimit?: Maybe<Scalars['Float']>;
  readonly externalAdAccountBalance?: Maybe<Scalars['Float']>;
  readonly externalAdAccountBalanceInCents?: Maybe<Scalars['Int']>;
  readonly externalAdAccountCurrency?: Maybe<Scalars['String']>;
  readonly externalAdAccountDefaultSpendCapLimit?: Maybe<Scalars['Float']>;
  readonly externalAdAccountDetailedStatsEnabled?: Maybe<Scalars['Boolean']>;
  readonly externalAdAccountFundingSourceId?: Maybe<Scalars['ID']>;
  readonly externalAdAccountId?: Maybe<Scalars['ID']>;
  readonly externalAdAccountImportedAt?: Maybe<Scalars['String']>;
  readonly externalAdAccountLifetimeSpend?: Maybe<Scalars['Float']>;
  readonly externalAdAccountMaxSpendCap?: Maybe<Scalars['Float']>;
  readonly externalAdAccountMaxSpendCapInCents?: Maybe<Scalars['Int']>;
  readonly externalAdAccountMinSpendCap?: Maybe<Scalars['Float']>;
  readonly externalAdAccountMinSpendCapInCents?: Maybe<Scalars['Int']>;
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  readonly externalAdAccountSpendCap?: Maybe<Scalars['Float']>;
  readonly externalAdAccountSpendCapInCents?: Maybe<Scalars['Int']>;
  readonly externalAdAccountSpendCapLimit?: Maybe<Scalars['Float']>;
  readonly externalAdAccountSpendCapLimitTransaction?: Maybe<Scalars['Float']>;
  readonly externalAdAccountSpendFactor?: Maybe<Scalars['Float']>;
  readonly externalAdAccountStatus?: Maybe<Scalars['String']>;
  readonly externalAdAccountTimezone?: Maybe<Scalars['String']>;
  readonly externalAdAccountType?: Maybe<Scalars['String']>;
  readonly externalAdvertiserId?: Maybe<Scalars['ID']>;
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  readonly statistics?: Maybe<ReadonlyArray<Maybe<FbStatistics>>>;
};


export type FbAdAccountStatisticsArgs = {
  filter?: InputMaybe<FbStatisticsFilter>;
  filterExclude?: InputMaybe<FbStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type FbAdAccountAgenciesInput = {
  readonly business: Scalars['String'];
  readonly permittedTasks: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

/** Facebook ad account agency */
export type FbAdAccountAgency = {
  readonly __typename?: 'fbAdAccountAgency';
  readonly accessRequestedTime?: Maybe<Scalars['MixedType']>;
  readonly accessStatus?: Maybe<Scalars['MixedType']>;
  readonly accessUpdatedTime?: Maybe<Scalars['MixedType']>;
  readonly agencyId?: Maybe<Scalars['MixedType']>;
  readonly deletedAt?: Maybe<Scalars['String']>;
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  readonly isDeleted?: Maybe<Scalars['Boolean']>;
  readonly name?: Maybe<Scalars['MixedType']>;
  readonly permittedTasks?: Maybe<Scalars['MixedType']>;
  readonly verificationStatus?: Maybe<Scalars['MixedType']>;
};

export type FbAdAccountAgencyFilter = {
  readonly agencyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type FbAdAccountAssignedUser = {
  readonly __typename?: 'fbAdAccountAssignedUser';
  readonly assignedUserId?: Maybe<Scalars['MixedType']>;
  readonly deletedAt?: Maybe<Scalars['String']>;
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  readonly isDeleted?: Maybe<Scalars['Boolean']>;
  readonly name?: Maybe<Scalars['MixedType']>;
  readonly permittedTasks?: Maybe<Scalars['MixedType']>;
  readonly tasks?: Maybe<Scalars['MixedType']>;
};

export type FbAdAccountAssignedUserFilter = {
  readonly assignedUserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type FbAdAccountAssignedUsersInput = {
  readonly tasks: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly user: Scalars['String'];
};

export type FbAdAccountFilter = {
  readonly customerFullName?: InputMaybe<Scalars['String']>;
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly extendedCreditInvoiceGroupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly extendedCreditInvoiceGroupName?: InputMaybe<Scalars['String']>;
  readonly externalAdAccountCurrency?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdAccountDetailedStatsEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly externalAdAccountFundingSourceId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdAccountInInvoiceGroup?: InputMaybe<Scalars['Boolean']>;
  readonly externalAdAccountName?: InputMaybe<Scalars['String']>;
  readonly externalAdAccountStatus?: InputMaybe<ReadonlyArray<InputMaybe<FbAdAccountStatus>>>;
  readonly externalAdAccountType?: InputMaybe<ReadonlyArray<InputMaybe<AccountType>>>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdvertiserName?: InputMaybe<Scalars['String']>;
};

/** Facebook ad account history */
export type FbAdAccountHistory = {
  readonly __typename?: 'fbAdAccountHistory';
  readonly accountType?: Maybe<Scalars['MixedType']>;
  readonly amountSpent?: Maybe<Scalars['MixedType']>;
  readonly balance?: Maybe<Scalars['MixedType']>;
  readonly createdAt?: Maybe<Scalars['MixedType']>;
  readonly currency?: Maybe<Scalars['MixedType']>;
  readonly currentStatus?: Maybe<Scalars['MixedType']>;
  readonly endAdvertiserId?: Maybe<Scalars['MixedType']>;
  readonly endAdvertiserName?: Maybe<Scalars['MixedType']>;
  readonly extendedCreditInvoiceGroupId?: Maybe<Scalars['MixedType']>;
  readonly extendedCreditInvoiceGroupName?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountName?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserId?: Maybe<Scalars['MixedType']>;
  readonly fundingSourceDisplayString?: Maybe<Scalars['MixedType']>;
  readonly fundingSourceId?: Maybe<Scalars['MixedType']>;
  readonly fundingSourceType?: Maybe<Scalars['MixedType']>;
  readonly importedAt?: Maybe<Scalars['MixedType']>;
  readonly ioNumber?: Maybe<Scalars['MixedType']>;
  readonly lifetimeSpend?: Maybe<Scalars['MixedType']>;
  readonly lockReason?: Maybe<Scalars['MixedType']>;
  readonly lockedAt?: Maybe<Scalars['MixedType']>;
  readonly maxSpendCap?: Maybe<Scalars['MixedType']>;
  readonly minSpendCap?: Maybe<Scalars['MixedType']>;
  readonly modificationTime?: Maybe<Scalars['MixedType']>;
  readonly modifierId?: Maybe<Scalars['MixedType']>;
  readonly modifierLevel?: Maybe<Scalars['MixedType']>;
  readonly ownerId?: Maybe<Scalars['MixedType']>;
  readonly spendCap?: Maybe<Scalars['MixedType']>;
  readonly spendFactor?: Maybe<Scalars['MixedType']>;
  readonly status?: Maybe<Scalars['MixedType']>;
  readonly timezone?: Maybe<Scalars['MixedType']>;
};

export type FbAdAccountHistoryFilter = {
  readonly accountType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly createdAt?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly currency?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly currentStatus?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly importedAt?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly modificationTime?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly modifierId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly modifierLevel?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

/** Facebook ad account hourly amount spent and spend cap data. */
export type FbAdAccountSpendActivity = {
  readonly __typename?: 'fbAdAccountSpendActivity';
  readonly accountId?: Maybe<Scalars['MixedType']>;
  readonly amountSpent?: Maybe<Scalars['MixedType']>;
  readonly spendCap?: Maybe<Scalars['MixedType']>;
  readonly timestamp?: Maybe<Scalars['MixedType']>;
};

export type FbAdAccountSpendActivityFilter = {
  readonly accountId: ReadonlyArray<InputMaybe<Scalars['ID']>>;
  readonly timestamp: Scalars['String'];
};

export enum FbAdAccountStatus {
  /** Account is active */
  Active = 'ACTIVE',
  /** Any active */
  AnyActive = 'ANY_ACTIVE',
  /** Any closed */
  AnyClosed = 'ANY_CLOSED',
  /** Account is closed */
  Closed = 'CLOSED',
  /** Account is disabled */
  Disabled = 'DISABLED',
  /** In grace period */
  InGracePeriod = 'IN_GRACE_PERIOD',
  /** Pending - closure */
  PendingClosure = 'PENDING_CLOSURE',
  /** Pending - risk review */
  PendingRiskReview = 'PENDING_RISK_REVIEW',
  /** Pending - settlement */
  PendingSettlement = 'PENDING_SETTLEMENT',
  /** Unsettled */
  Unsettled = 'UNSETTLED'
}

export type FbAdminMetaData = {
  readonly __typename?: 'fbAdminMetaData';
  readonly adminId?: Maybe<Scalars['Int']>;
  readonly adminName?: Maybe<Scalars['String']>;
  readonly credentials?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly culture?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly environment?: Maybe<Scalars['String']>;
  readonly externalAdvertisers?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly global_network?: Maybe<Scalars['String']>;
  readonly locale?: Maybe<Scalars['MixedType']>;
  readonly network?: Maybe<Scalars['String']>;
  readonly oauthUserId?: Maybe<Scalars['Int']>;
  readonly timezone?: Maybe<Scalars['String']>;
};

/** Ad account activity */
export type FbBudgetActivity = {
  readonly __typename?: 'fbBudgetActivity';
  readonly actorId?: Maybe<Scalars['MixedType']>;
  readonly actorName?: Maybe<Scalars['MixedType']>;
  readonly applicationId?: Maybe<Scalars['MixedType']>;
  readonly applicationName?: Maybe<Scalars['MixedType']>;
  /** @deprecated Field replaced with eventTimeInTimezone */
  readonly dateTimeInTimezone?: Maybe<Scalars['MixedType']>;
  /** @deprecated Field replaced with eventTimeInUtc */
  readonly eventTime?: Maybe<Scalars['MixedType']>;
  readonly eventTimeInTimezone?: Maybe<Scalars['MixedType']>;
  readonly eventTimeInUtc?: Maybe<Scalars['MixedType']>;
  readonly eventType?: Maybe<Scalars['MixedType']>;
  readonly extendedCreditInvoiceGroupId?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountName?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountTimezone?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserId?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserName?: Maybe<Scalars['MixedType']>;
  readonly extraData?: Maybe<Scalars['MixedType']>;
  readonly importedAtInUtc?: Maybe<Scalars['MixedType']>;
  /** @deprecated Field replaced with importedAtInUtc */
  readonly insertedTime?: Maybe<Scalars['MixedType']>;
  readonly objectId?: Maybe<Scalars['MixedType']>;
  readonly objectName?: Maybe<Scalars['MixedType']>;
  readonly objectType?: Maybe<Scalars['MixedType']>;
  readonly translatedEventType?: Maybe<Scalars['MixedType']>;
};

export type FbBudgetActivityFilter = {
  readonly actorId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly actorName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly applicationId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly applicationName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly eventTime?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly eventType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly extendedCreditInvoiceGroupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly importedAtInUtc?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly insertedTime?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly objectId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly objectName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly objectType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type FbBusiness = {
  readonly __typename?: 'fbBusiness';
  readonly businessAddress?: Maybe<Scalars['MixedType']>;
  readonly businessBankAccountNumber?: Maybe<Scalars['MixedType']>;
  readonly businessBankDataId?: Maybe<Scalars['MixedType']>;
  readonly businessBankName?: Maybe<Scalars['MixedType']>;
  readonly businessCity?: Maybe<Scalars['MixedType']>;
  readonly businessCountryId?: Maybe<Scalars['MixedType']>;
  readonly businessCountryName?: Maybe<Scalars['MixedType']>;
  readonly businessCurrencyTag?: Maybe<Scalars['MixedType']>;
  readonly businessEmail?: Maybe<Scalars['String']>;
  readonly businessFinanceEmail?: Maybe<Scalars['String']>;
  readonly businessHasLocalFields?: Maybe<Scalars['Boolean']>;
  readonly businessHasSelfOnboarding?: Maybe<Scalars['Boolean']>;
  readonly businessId?: Maybe<Scalars['MixedType']>;
  readonly businessIsVatCommitted?: Maybe<Scalars['MixedType']>;
  readonly businessLocalAddress?: Maybe<Scalars['MixedType']>;
  readonly businessLocalBankAccountNumber?: Maybe<Scalars['MixedType']>;
  readonly businessLocalBankName?: Maybe<Scalars['MixedType']>;
  readonly businessLocalCity?: Maybe<Scalars['MixedType']>;
  readonly businessLocalCountry?: Maybe<Scalars['MixedType']>;
  readonly businessLocalName?: Maybe<Scalars['MixedType']>;
  readonly businessLocalRegNumber?: Maybe<Scalars['MixedType']>;
  readonly businessLocalVatNumber?: Maybe<Scalars['MixedType']>;
  readonly businessLocalZip?: Maybe<Scalars['MixedType']>;
  readonly businessName?: Maybe<Scalars['MixedType']>;
  readonly businessRegNumber?: Maybe<Scalars['MixedType']>;
  readonly businessVatNumber?: Maybe<Scalars['MixedType']>;
  readonly businessZip?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserId?: Maybe<Scalars['MixedType']>;
};

export type FbBusinessFilter = {
  readonly businessCountryId?: InputMaybe<Scalars['String']>;
  readonly businessCurrencyTag?: InputMaybe<Scalars['String']>;
  readonly businessHasLocalFields?: InputMaybe<Scalars['Boolean']>;
  readonly businessHasSelfOnboarding?: InputMaybe<Scalars['Boolean']>;
  readonly businessId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly businessName?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

/** Facebook business user. */
export type FbBusinessUser = {
  readonly __typename?: 'fbBusinessUser';
  readonly business?: Maybe<Scalars['MixedType']>;
  readonly businessUserId?: Maybe<Scalars['MixedType']>;
  readonly email?: Maybe<Scalars['MixedType']>;
  readonly financePermission?: Maybe<Scalars['MixedType']>;
  readonly firstName?: Maybe<Scalars['MixedType']>;
  readonly ipPermission?: Maybe<Scalars['MixedType']>;
  readonly lastName?: Maybe<Scalars['MixedType']>;
  readonly name?: Maybe<Scalars['MixedType']>;
  readonly pendingEmail?: Maybe<Scalars['MixedType']>;
  readonly role?: Maybe<Scalars['MixedType']>;
  readonly title?: Maybe<Scalars['MixedType']>;
  readonly twoFacStatus?: Maybe<Scalars['MixedType']>;
};

export type FbBusinessUserFilter = {
  readonly businessUserId?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId: Scalars['String'];
};

export type FbCampaign = {
  readonly __typename?: 'fbCampaign';
  readonly campaignId?: Maybe<Scalars['MixedType']>;
  readonly createdAt?: Maybe<Scalars['MixedType']>;
  readonly currency?: Maybe<Scalars['MixedType']>;
  readonly dailyBudget?: Maybe<Scalars['MixedType']>;
  readonly dateFrom?: Maybe<Scalars['MixedType']>;
  readonly dateTo?: Maybe<Scalars['MixedType']>;
  readonly deletedAt?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  readonly externalAdAccountName?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserId?: Maybe<Scalars['MixedType']>;
  readonly externalAdvertiserName?: Maybe<Scalars['MixedType']>;
  readonly externalId?: Maybe<Scalars['MixedType']>;
  readonly importedAt?: Maybe<Scalars['MixedType']>;
  readonly name?: Maybe<Scalars['MixedType']>;
  readonly objective?: Maybe<Scalars['MixedType']>;
  readonly status?: Maybe<Scalars['MixedType']>;
  readonly supplier?: Maybe<Scalars['MixedType']>;
  readonly timezone?: Maybe<Scalars['MixedType']>;
  readonly totalBudget?: Maybe<Scalars['MixedType']>;
  readonly updatedAt?: Maybe<Scalars['MixedType']>;
};

export type FbCampaignFilter = {
  readonly campaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  readonly externalId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly objective?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export enum FbClientTypeEnum {
  /** Client onboarded via the HttpoolExpress App */
  Express = 'EXPRESS',
  /** Client onboarded by the Admin (via the admin screen) */
  FbsA = 'FBS_A',
  /** Client self-onboarded (via the Clients self-onboarding process) */
  FbsC = 'FBS_C'
}

/** Facebook monthly credit limit history. */
export type FbCreditLimitHistory = {
  readonly __typename?: 'fbCreditLimitHistory';
  readonly entityId?: Maybe<Scalars['ID']>;
  readonly entityType?: Maybe<Scalars['String']>;
  readonly modificationTime?: Maybe<Scalars['String']>;
  readonly modificationType?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly spendCapLimit?: Maybe<Scalars['String']>;
  readonly surname?: Maybe<Scalars['String']>;
};

export type FbCreditLimitHistoryFilter = {
  readonly entityId?: InputMaybe<Scalars['ID']>;
  readonly entityType?: InputMaybe<Scalars['String']>;
};

export type FbCreditSetting = {
  readonly __typename?: 'fbCreditSetting';
  readonly entityId?: Maybe<Scalars['MixedType']>;
  readonly entityType?: Maybe<Scalars['MixedType']>;
  readonly spendCapLimit?: Maybe<Scalars['MixedType']>;
  readonly spendCapLimitDefault?: Maybe<Scalars['MixedType']>;
  readonly spendCapLimitTransaction?: Maybe<Scalars['MixedType']>;
};

export type FbCreditSettingFilter = {
  readonly entityId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly entityType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type FbCurrency = {
  readonly __typename?: 'fbCurrency';
  readonly facebookCurrency?: Maybe<Scalars['String']>;
  readonly facebookCurrencyMinValue?: Maybe<Scalars['Float']>;
  readonly facebookCurrencyOffset?: Maybe<Scalars['Int']>;
  readonly facebookCurrencySymbol?: Maybe<Scalars['String']>;
};

export type FbCurrencyFilter = {
  readonly facebookCurrency?: InputMaybe<Scalars['String']>;
  readonly facebookCurrencyMinValue?: InputMaybe<Scalars['Float']>;
  readonly facebookCurrencyOffset?: InputMaybe<Scalars['Int']>;
  readonly facebookCurrencySymbol?: InputMaybe<Scalars['String']>;
};

/** Facebook extended credit */
export type FbExtendedCredit = {
  readonly __typename?: 'fbExtendedCredit';
  readonly extendedCreditAllocatedAmount?: Maybe<Scalars['Float']>;
  readonly extendedCreditBalance?: Maybe<Scalars['Float']>;
  readonly extendedCreditCreditAvailable?: Maybe<Scalars['Float']>;
  readonly extendedCreditCreditType?: Maybe<Scalars['String']>;
  readonly extendedCreditId?: Maybe<Scalars['ID']>;
  readonly extendedCreditIsAccessRevoked?: Maybe<Scalars['Boolean']>;
  readonly externalAdvertiserId?: Maybe<Scalars['ID']>;
};

export type FbExtendedCreditFilter = {
  readonly extendedCreditCreditType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly extendedCreditId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly extendedCreditIsAccessRevoked?: InputMaybe<Scalars['Boolean']>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

/** Facebook extended credit invoice group. */
export type FbExtendedCreditInvoiceGroup = {
  readonly __typename?: 'fbExtendedCreditInvoiceGroup';
  readonly extendedCreditId?: Maybe<Scalars['ID']>;
  readonly extendedCreditInvoiceGroupAutoEnroll?: Maybe<Scalars['Boolean']>;
  readonly extendedCreditInvoiceGroupCustomerPoNumber?: Maybe<Scalars['String']>;
  readonly extendedCreditInvoiceGroupEmails?: Maybe<Scalars['MixedType']>;
  readonly extendedCreditInvoiceGroupId?: Maybe<Scalars['ID']>;
  readonly extendedCreditInvoiceGroupName?: Maybe<Scalars['String']>;
  readonly externalAdvertiserId?: Maybe<Scalars['ID']>;
};

export type FbExtendedCreditInvoiceGroupFilter = {
  readonly extendedCreditId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly extendedCreditInvoiceGroupAutoEnroll?: InputMaybe<Scalars['Boolean']>;
  readonly extendedCreditInvoiceGroupCustomerPoNumber?: InputMaybe<Scalars['String']>;
  readonly extendedCreditInvoiceGroupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly extendedCreditInvoiceGroupName?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export type FbExternalAdvertiser = {
  readonly __typename?: 'fbExternalAdvertiser';
  readonly adminUsers?: Maybe<ReadonlyArray<Maybe<AdminUser>>>;
  readonly externalAdvertiserCurrency?: Maybe<Scalars['String']>;
  readonly externalAdvertiserId?: Maybe<Scalars['ID']>;
  readonly externalAdvertiserIsActive?: Maybe<Scalars['Boolean']>;
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  readonly externalAdvertiserUserId?: Maybe<Scalars['String']>;
};

export type FbExternalAdvertiserFilter = {
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdvertiserIsActive?: InputMaybe<Scalars['Boolean']>;
  readonly externalAdvertiserName?: InputMaybe<Scalars['String']>;
};

/** Facebook extended credit */
export type FbLiveExtendedCredit = {
  readonly __typename?: 'fbLiveExtendedCredit';
  readonly allocatedAmount?: Maybe<Scalars['MixedType']>;
  readonly balance?: Maybe<Scalars['MixedType']>;
  readonly creditAvailable?: Maybe<Scalars['MixedType']>;
  readonly creditType?: Maybe<Scalars['MixedType']>;
  readonly currency?: Maybe<Scalars['MixedType']>;
  readonly extendedCreditId?: Maybe<Scalars['MixedType']>;
  readonly isAccessRevoked?: Maybe<Scalars['MixedType']>;
  readonly isAutomatedExperience?: Maybe<Scalars['MixedType']>;
  readonly legalEntityName?: Maybe<Scalars['MixedType']>;
  readonly liableBizName?: Maybe<Scalars['MixedType']>;
  readonly maxBalance?: Maybe<Scalars['MixedType']>;
  readonly onlineMaxBalance?: Maybe<Scalars['MixedType']>;
  readonly ownerBusiness?: Maybe<Scalars['MixedType']>;
  readonly ownerBusinessName?: Maybe<Scalars['MixedType']>;
  readonly partitionFrom?: Maybe<Scalars['MixedType']>;
  readonly receivingCreditAllocationConfig?: Maybe<Scalars['MixedType']>;
  readonly sendBillToBizName?: Maybe<Scalars['MixedType']>;
};

export type FbLiveExtendedCreditFilter = {
  readonly extendedCreditId?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId: Scalars['String'];
};

/** Facebook extended credit invoice group. */
export type FbLiveExtendedCreditInvoiceGroup = {
  readonly __typename?: 'fbLiveExtendedCreditInvoiceGroup';
  readonly autoEnroll?: Maybe<Scalars['MixedType']>;
  readonly customerPoNumber?: Maybe<Scalars['MixedType']>;
  readonly email?: Maybe<Scalars['MixedType']>;
  readonly emails?: Maybe<Scalars['MixedType']>;
  readonly extendedCreditInvoiceGroupId?: Maybe<Scalars['MixedType']>;
  readonly name?: Maybe<Scalars['MixedType']>;
};

export type FbLiveExtendedCreditInvoiceGroupFilter = {
  readonly extendedCreditId?: InputMaybe<Scalars['String']>;
  readonly extendedCreditInvoiceGroupId?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId: Scalars['String'];
};

export type FbRule = {
  readonly __typename?: 'fbRule';
  /** Rule actions in format [{"type":"pause_campaign"},{"type":"send_email"}] */
  readonly actions?: Maybe<Scalars['String']>;
  /** Activated date in format Y-m-d H:i */
  readonly activatedAt?: Maybe<Scalars['String']>;
  /** Defines on which level rule should be applied (campaign, group, ad) */
  readonly applyOn?: Maybe<Scalars['String']>;
  /** Rule conditions in format [{"operator":"greater_equal","statistic":"spend", ...}] */
  readonly conditions?: Maybe<Scalars['String']>;
  /** Date when rule was created in format Y-m-d H:i */
  readonly createdAt?: Maybe<Scalars['String']>;
  /** Rule data in json format */
  readonly data?: Maybe<Scalars['String']>;
  /** Deleted date in format Y-m-d H:i */
  readonly deletedAt?: Maybe<Scalars['String']>;
  /** Send email addresses in format ["test@test.com", ...] */
  readonly emailAddress?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** Frequency defined in minutes from 1 to 1440 */
  readonly frequency?: Maybe<Scalars['Int']>;
  /** Defines specific time in format 04:00:00 */
  readonly frequencyAbsolute?: Maybe<Scalars['String']>;
  readonly guards?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** Defines if rule should be flagged as finished */
  readonly isFinished?: Maybe<Scalars['Int']>;
  /** Defines when rule was last run in format Y-m-d H:i */
  readonly lastRun?: Maybe<Scalars['String']>;
  /** Rule name */
  readonly name?: Maybe<Scalars['String']>;
  /** Primary key: parent id (campaign, group, ad) */
  readonly parentId?: Maybe<Scalars['ID']>;
  /** Creation level (campaign, group, ad) */
  readonly parentTable?: Maybe<Scalars['String']>;
  /** Primary key: rule id */
  readonly ruleId?: Maybe<Scalars['ID']>;
  /** Should send email 0/1 */
  readonly sendEmail?: Maybe<Scalars['Int']>;
  /** Start after specific date in format Y-m-d H:i */
  readonly startAfter?: Maybe<Scalars['String']>;
  /** Timezone for rule */
  readonly timezoneName?: Maybe<Scalars['String']>;
  /** Rule type (name of strategy) */
  readonly type?: Maybe<Scalars['String']>;
};

export type FbRuleFilter = {
  readonly actions?: InputMaybe<Scalars['String']>;
  readonly activatedAt?: InputMaybe<Scalars['String']>;
  readonly applyOn?: InputMaybe<Scalars['String']>;
  readonly createdAt?: InputMaybe<Scalars['String']>;
  readonly deletedAt?: InputMaybe<Scalars['String']>;
  readonly frequency?: InputMaybe<Scalars['Int']>;
  readonly frequencyAbsolute?: InputMaybe<Scalars['String']>;
  readonly isFinished?: InputMaybe<Scalars['Int']>;
  readonly lastRun?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly parentId?: InputMaybe<Scalars['ID']>;
  readonly parentTable?: InputMaybe<Scalars['String']>;
  readonly ruleId?: InputMaybe<Scalars['String']>;
  readonly startAfter?: InputMaybe<Scalars['String']>;
  readonly timezoneName?: InputMaybe<Scalars['String']>;
  readonly type?: InputMaybe<Scalars['String']>;
};

export type FbRuleLog = {
  readonly __typename?: 'fbRuleLog';
  /** Creation level (campaign, group, ad) */
  readonly entity?: Maybe<Scalars['String']>;
  /** Primary key: parent id (campaign, group, ad) */
  readonly entityId?: Maybe<Scalars['ID']>;
  /** Result data in json format (array or object) */
  readonly result?: Maybe<Scalars['String']>;
  /** Foreign key: rule id */
  readonly ruleId?: Maybe<Scalars['ID']>;
  /** Primary key: rule log id */
  readonly ruleLogId?: Maybe<Scalars['ID']>;
  /** Runtime date in format Y-m-d H:i:s */
  readonly runTime?: Maybe<Scalars['String']>;
};

export type FbRuleLogFilter = {
  readonly entity?: InputMaybe<Scalars['String']>;
  readonly entityId?: InputMaybe<Scalars['String']>;
  readonly result?: InputMaybe<Scalars['String']>;
  readonly ruleId?: InputMaybe<Scalars['String']>;
  readonly ruleLogId?: InputMaybe<Scalars['String']>;
  readonly runTime?: InputMaybe<Scalars['String']>;
};

export type FbSpendCap = {
  readonly action: FbSpendCapAction;
  readonly reset?: InputMaybe<Scalars['Boolean']>;
  readonly value?: InputMaybe<Scalars['Float']>;
};

export enum FbSpendCapAction {
  /** Add additional funds to Facebook ad account */
  Add = 'ADD',
  /** Remove some funds from Facebook ad account */
  Remove = 'REMOVE',
  /** Remove all funds */
  RemoveAll = 'REMOVE_ALL',
  /** Set account funds to a specific value */
  Set = 'SET'
}

export type FbStatistics = {
  readonly __typename?: 'fbStatistics';
  readonly adId?: Maybe<Scalars['ID']>;
  readonly age?: Maybe<Scalars['String']>;
  readonly appStoreClicks?: Maybe<Scalars['Int']>;
  readonly campaignId?: Maybe<Scalars['ID']>;
  readonly canvasAvgViewPercent?: Maybe<Scalars['Float']>;
  readonly canvasAvgViewTime?: Maybe<Scalars['Float']>;
  readonly clicks?: Maybe<Scalars['Int']>;
  readonly currency?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly customerName?: Maybe<Scalars['String']>;
  readonly date?: Maybe<Scalars['String']>;
  readonly dayOfMonth?: Maybe<Scalars['Int']>;
  readonly deeplinkClicks?: Maybe<Scalars['Int']>;
  readonly externalAdAccountId?: Maybe<Scalars['ID']>;
  readonly externalAdId?: Maybe<Scalars['ID']>;
  readonly externalCampaignId?: Maybe<Scalars['ID']>;
  readonly externalGroupId?: Maybe<Scalars['ID']>;
  readonly gender?: Maybe<Scalars['String']>;
  readonly groupId?: Maybe<Scalars['ID']>;
  readonly impressions?: Maybe<Scalars['Int']>;
  readonly inlineLinkClicks?: Maybe<Scalars['Int']>;
  readonly inlinePostEngagement?: Maybe<Scalars['Int']>;
  readonly lastYearSpend?: Maybe<Scalars['Float']>;
  readonly mobileAppPurchaseRoas?: Maybe<Scalars['Float']>;
  readonly monthName?: Maybe<Scalars['String']>;
  readonly monthNumber?: Maybe<Scalars['Int']>;
  readonly newsfeedAvgPosition?: Maybe<Scalars['Float']>;
  readonly newsfeedClicks?: Maybe<Scalars['Int']>;
  readonly newsfeedImpressions?: Maybe<Scalars['Int']>;
  readonly outboundClicks?: Maybe<Scalars['Int']>;
  readonly purchaseRoas?: Maybe<Scalars['Float']>;
  readonly quarter?: Maybe<Scalars['String']>;
  readonly socialSpend?: Maybe<Scalars['Float']>;
  readonly spend?: Maybe<Scalars['Float']>;
  readonly thisYearSpend?: Maybe<Scalars['Float']>;
  readonly uniqueClicks?: Maybe<Scalars['Int']>;
  readonly uniqueImpressions?: Maybe<Scalars['Int']>;
  readonly uniqueInlineLinkClicks?: Maybe<Scalars['Int']>;
  readonly uniqueOutboundClicks?: Maybe<Scalars['Int']>;
  readonly video10SecWatched?: Maybe<Scalars['Int']>;
  readonly video30SecWatched?: Maybe<Scalars['Int']>;
  readonly videoAverageTimeWatched?: Maybe<Scalars['Int']>;
  readonly videoComplete?: Maybe<Scalars['Int']>;
  readonly videoP25Watched?: Maybe<Scalars['Int']>;
  readonly videoP50Watched?: Maybe<Scalars['Int']>;
  readonly videoP75Watched?: Maybe<Scalars['Int']>;
  readonly videoP95Watched?: Maybe<Scalars['Int']>;
  readonly videoP100Watched?: Maybe<Scalars['Int']>;
  readonly websiteClicks?: Maybe<Scalars['Int']>;
  readonly websitePurchaseRoas?: Maybe<Scalars['Float']>;
  readonly weekNumber?: Maybe<Scalars['String']>;
  readonly weekdayName?: Maybe<Scalars['String']>;
  readonly weekdayNumber?: Maybe<Scalars['Int']>;
  readonly year?: Maybe<Scalars['Int']>;
  readonly yearMonth?: Maybe<Scalars['String']>;
};

export type FbStatisticsFilter = {
  readonly adId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly age?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly campaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly currency?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly dateFrom?: InputMaybe<Scalars['String']>;
  readonly dateTo?: InputMaybe<Scalars['String']>;
  readonly dayOfMonth?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalCampaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalGroupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly gender?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly groupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly monthName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly monthNumber?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly quarter?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly weekNumber?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly weekdayName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly weekdayNumber?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly year?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly yearMonth?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

/** Facebook statistics */
export type FbStats = {
  readonly __typename?: 'fbStats';
  readonly accountLifetimeSpend?: Maybe<Scalars['MixedType']>;
  readonly actionRate?: Maybe<Scalars['MixedType']>;
  readonly actionValues?: Maybe<Scalars['MixedType']>;
  readonly actions?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The ad account id (only with isGlobal filter) */
  readonly adAccountId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The ad account name (only with isGlobal filter) */
  readonly adAccountName?: Maybe<Scalars['MixedType']>;
  readonly adClickActions?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the ad */
  readonly adId?: Maybe<Scalars['MixedType']>;
  readonly adImpressionActions?: Maybe<Scalars['MixedType']>;
  /** Total spend */
  readonly amount?: Maybe<Scalars['MixedType']>;
  readonly auctionBid?: Maybe<Scalars['MixedType']>;
  readonly auctionCompetitiveness?: Maybe<Scalars['MixedType']>;
  readonly auctionMaxCompetitorBid?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the campaign */
  readonly campaignId?: Maybe<Scalars['MixedType']>;
  readonly canvasAvgViewPercent?: Maybe<Scalars['MixedType']>;
  readonly canvasAvgViewTime?: Maybe<Scalars['MixedType']>;
  readonly catalogSegmentActions?: Maybe<Scalars['MixedType']>;
  readonly catalogSegmentValue?: Maybe<Scalars['MixedType']>;
  readonly catalogSegmentValueMobilePurchaseRoas?: Maybe<Scalars['MixedType']>;
  readonly catalogSegmentValueOmniPurchaseRoas?: Maybe<Scalars['MixedType']>;
  readonly catalogSegmentValueWebsitePurchaseRoas?: Maybe<Scalars['MixedType']>;
  /** Click rate */
  readonly clickRate?: Maybe<Scalars['MixedType']>;
  /** Total number of clicks, including favorites and other engagements */
  readonly clicks?: Maybe<Scalars['MixedType']>;
  /** Conversion rate\ conversions/impressions */
  readonly conversionRate?: Maybe<Scalars['MixedType']>;
  readonly conversionRateRanking?: Maybe<Scalars['MixedType']>;
  readonly conversionValues?: Maybe<Scalars['MixedType']>;
  /** Total number of conversions */
  readonly conversions?: Maybe<Scalars['MixedType']>;
  readonly convertedProductQuantity?: Maybe<Scalars['MixedType']>;
  readonly convertedProductValue?: Maybe<Scalars['MixedType']>;
  /** Effective cost per action */
  readonly cpa?: Maybe<Scalars['MixedType']>;
  /** Effective cost per action in EUR */
  readonly cpaEur?: Maybe<Scalars['MixedType']>;
  /** Effective cost per action in USD */
  readonly cpaUsd?: Maybe<Scalars['MixedType']>;
  /** Effective cost per click */
  readonly cpc?: Maybe<Scalars['MixedType']>;
  /** Effective cost click in EUR */
  readonly cpcEur?: Maybe<Scalars['MixedType']>;
  /** Effective cost click in USD */
  readonly cpcUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion */
  readonly cpcv?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion in EUR */
  readonly cpcvEur?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion in USD */
  readonly cpcvUsd?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand impressions */
  readonly cpm?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand impressions in EUR */
  readonly cpmEur?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand impressions in USD */
  readonly cpmUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per website click */
  readonly cpwc?: Maybe<Scalars['MixedType']>;
  /** Cost per website click in EUR */
  readonly cpwcEur?: Maybe<Scalars['MixedType']>;
  /** Cost per website click in USD */
  readonly cpwcUsd?: Maybe<Scalars['MixedType']>;
  /** Click trough rate */
  readonly ctr?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Currency */
  readonly currency?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Statistics date */
  readonly date?: Maybe<Scalars['MixedType']>;
  readonly dayOfMonth?: Maybe<Scalars['MixedType']>;
  readonly ddaCountbyConvs?: Maybe<Scalars['MixedType']>;
  readonly engagementRateRanking?: Maybe<Scalars['MixedType']>;
  readonly estimatedAdRecallRateLowerBound?: Maybe<Scalars['MixedType']>;
  readonly estimatedAdRecallRateUpperBound?: Maybe<Scalars['MixedType']>;
  readonly estimatedAdRecallersLowerBound?: Maybe<Scalars['MixedType']>;
  readonly estimatedAdRecallersUpperBound?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external account id */
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external account name */
  readonly externalAdAccountName?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external advertiser id */
  readonly externalAdvertiserId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external advertiser name */
  readonly externalAdvertiserName?: Maybe<Scalars['MixedType']>;
  readonly frequency?: Maybe<Scalars['MixedType']>;
  readonly fullViewImpressions?: Maybe<Scalars['MixedType']>;
  readonly fullViewReach?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the group */
  readonly groupId?: Maybe<Scalars['MixedType']>;
  /** Total number of impressions */
  readonly impressions?: Maybe<Scalars['MixedType']>;
  /** Number of inline link clicks */
  readonly inlineLinkClicks?: Maybe<Scalars['MixedType']>;
  readonly inlinePostEngagement?: Maybe<Scalars['MixedType']>;
  readonly instantExperienceClicksToOpen?: Maybe<Scalars['MixedType']>;
  readonly instantExperienceClicksToStart?: Maybe<Scalars['MixedType']>;
  readonly instantExperienceOutboundClicks?: Maybe<Scalars['MixedType']>;
  readonly interactiveComponentTap?: Maybe<Scalars['MixedType']>;
  /** This field is only for raw generic response (in combination with values). You have to defined metrics in filter. */
  readonly metrics?: Maybe<Scalars['MixedType']>;
  readonly mobileAppPurchaseRoas?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Month number */
  readonly monthNumber?: Maybe<Scalars['MixedType']>;
  readonly outboundClicks?: Maybe<Scalars['MixedType']>;
  readonly purchaseRoas?: Maybe<Scalars['MixedType']>;
  readonly qualifyingQuestionQualifyAnswerRate?: Maybe<Scalars['MixedType']>;
  readonly qualityRanking?: Maybe<Scalars['MixedType']>;
  readonly quarter?: Maybe<Scalars['MixedType']>;
  readonly reach?: Maybe<Scalars['MixedType']>;
  readonly socialSpend?: Maybe<Scalars['MixedType']>;
  readonly socialSpendEur?: Maybe<Scalars['MixedType']>;
  readonly socialSpendUsd?: Maybe<Scalars['MixedType']>;
  /** Total spend */
  readonly spend?: Maybe<Scalars['MixedType']>;
  /** Total spend in BDT */
  readonly spendBdt?: Maybe<Scalars['MixedType']>;
  /** Total spend in EUR */
  readonly spendEur?: Maybe<Scalars['MixedType']>;
  /** Total spend in USD */
  readonly spendUsd?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Supplier (Facebook) */
  readonly supplier?: Maybe<Scalars['MixedType']>;
  readonly uniqueActions?: Maybe<Scalars['MixedType']>;
  readonly uniqueConversions?: Maybe<Scalars['MixedType']>;
  /** This field is only for raw generic response (in combination with metrics)\ \ _________________________________________________________________________\ \ Facebook metrics */
  readonly values?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 10 seconds were played while 100% in view */
  readonly video10SecWatched?: Maybe<Scalars['MixedType']>;
  readonly video15SecWatchedActions?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 30 seconds were played while 100% in view */
  readonly video30SecWatched?: Maybe<Scalars['MixedType']>;
  readonly videoAverageTimeWatched?: Maybe<Scalars['MixedType']>;
  readonly videoComplete?: Maybe<Scalars['MixedType']>;
  readonly videoContinuous2SecWatchedActions?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 25% of the video was viewed. */
  readonly videoP25Watched?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 50% of the video was viewed. */
  readonly videoP50Watched?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 75% of the video was viewed. */
  readonly videoP75Watched?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 95% of the video was viewed. */
  readonly videoP95Watched?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 100% of the video was viewed. */
  readonly videoP100Watched?: Maybe<Scalars['MixedType']>;
  readonly videoPlayActions?: Maybe<Scalars['MixedType']>;
  readonly videoThruplayWatchedActions?: Maybe<Scalars['MixedType']>;
  readonly videoTimeWatchedActions?: Maybe<Scalars['MixedType']>;
  /** Website click rate\ website clicks/impressions */
  readonly websiteClickRate?: Maybe<Scalars['MixedType']>;
  readonly weekNumber?: Maybe<Scalars['MixedType']>;
  readonly weekdayNumber?: Maybe<Scalars['MixedType']>;
  readonly wishBid?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Year */
  readonly year?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Year-month (2019-01) */
  readonly yearMonth?: Maybe<Scalars['MixedType']>;
};

export type FbStatsFilter = {
  readonly adAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly campaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly date?: InputMaybe<Scalars['String']>;
  /** In ISO 8601 1970-01-01 format */
  readonly dateFrom?: InputMaybe<Scalars['String']>;
  /** In ISO 8601 1970-01-01 format */
  readonly dateTo?: InputMaybe<Scalars['String']>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  readonly metrics?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type FbTaUser = {
  readonly __typename?: 'fbTaUser';
  readonly credentials?: Maybe<ReadonlyArray<Maybe<Credentials>>>;
  readonly customers?: Maybe<ReadonlyArray<Maybe<Customers>>>;
  readonly userCompanyName?: Maybe<Scalars['MixedType']>;
  readonly userEmail?: Maybe<Scalars['MixedType']>;
  readonly userFullName?: Maybe<Scalars['MixedType']>;
  readonly userId?: Maybe<Scalars['MixedType']>;
  readonly userIsActivated?: Maybe<Scalars['MixedType']>;
  readonly userIsDeleted?: Maybe<Scalars['MixedType']>;
  readonly userIsValidated?: Maybe<Scalars['MixedType']>;
  readonly userName?: Maybe<Scalars['MixedType']>;
  readonly userSurname?: Maybe<Scalars['MixedType']>;
  readonly userTourFinished?: Maybe<Scalars['MixedType']>;
};

export type FbTaUserAccount = {
  readonly __typename?: 'fbTaUserAccount';
  readonly bankAccountNumber?: Maybe<Scalars['MixedType']>;
  readonly bankAccountType?: Maybe<Scalars['MixedType']>;
  readonly bankCurrency?: Maybe<Scalars['String']>;
  readonly bankId?: Maybe<Scalars['MixedType']>;
  readonly bankLocalAccountNumber?: Maybe<Scalars['MixedType']>;
  readonly bankLocalName?: Maybe<Scalars['MixedType']>;
  readonly bankName?: Maybe<Scalars['MixedType']>;
  readonly bankTotalAmount?: Maybe<Scalars['MixedType']>;
  readonly bankType?: Maybe<Scalars['MixedType']>;
  readonly billingMinAmount?: Maybe<Scalars['MixedType']>;
  readonly billingTaxPercentage?: Maybe<Scalars['MixedType']>;
  readonly businessAddress?: Maybe<Scalars['MixedType']>;
  readonly businessBankAccountNumber?: Maybe<Scalars['MixedType']>;
  readonly businessBankDataId?: Maybe<Scalars['MixedType']>;
  readonly businessBankName?: Maybe<Scalars['MixedType']>;
  readonly businessCity?: Maybe<Scalars['MixedType']>;
  readonly businessCountryId?: Maybe<Scalars['MixedType']>;
  readonly businessCountryName?: Maybe<Scalars['MixedType']>;
  readonly businessCurrencyTag?: Maybe<Scalars['MixedType']>;
  readonly businessEmail?: Maybe<Scalars['String']>;
  readonly businessFinanceEmail?: Maybe<Scalars['String']>;
  readonly businessHasLocalFields?: Maybe<Scalars['Boolean']>;
  readonly businessHasSelfOnboarding?: Maybe<Scalars['Boolean']>;
  readonly businessId?: Maybe<Scalars['MixedType']>;
  readonly businessIsVatCommitted?: Maybe<Scalars['MixedType']>;
  readonly businessLocalAddress?: Maybe<Scalars['MixedType']>;
  readonly businessLocalBankAccountNumber?: Maybe<Scalars['MixedType']>;
  readonly businessLocalBankName?: Maybe<Scalars['MixedType']>;
  readonly businessLocalCity?: Maybe<Scalars['MixedType']>;
  readonly businessLocalCountry?: Maybe<Scalars['MixedType']>;
  readonly businessLocalName?: Maybe<Scalars['MixedType']>;
  readonly businessLocalRegNumber?: Maybe<Scalars['MixedType']>;
  readonly businessLocalVatNumber?: Maybe<Scalars['MixedType']>;
  readonly businessLocalZip?: Maybe<Scalars['MixedType']>;
  readonly businessName?: Maybe<Scalars['MixedType']>;
  readonly businessRegNumber?: Maybe<Scalars['MixedType']>;
  readonly businessVatNumber?: Maybe<Scalars['MixedType']>;
  readonly businessZip?: Maybe<Scalars['MixedType']>;
  readonly customerAccountType?: Maybe<FbClientTypeEnum>;
  readonly customerAddress?: Maybe<Scalars['MixedType']>;
  readonly customerCity?: Maybe<Scalars['MixedType']>;
  readonly customerCompanyName?: Maybe<Scalars['MixedType']>;
  readonly customerContractSigned?: Maybe<Scalars['MixedType']>;
  readonly customerCountryId?: Maybe<Scalars['MixedType']>;
  readonly customerCountryName?: Maybe<Scalars['MixedType']>;
  readonly customerEmail?: Maybe<Scalars['MixedType']>;
  readonly customerExternalId?: Maybe<Scalars['MixedType']>;
  readonly customerFullName?: Maybe<Scalars['MixedType']>;
  readonly customerFunds?: Maybe<FbTaUserAccountFunds>;
  readonly customerHasEContract?: Maybe<Scalars['MixedType']>;
  readonly customerHasValidEContract?: Maybe<Scalars['MixedType']>;
  readonly customerId?: Maybe<Scalars['MixedType']>;
  readonly customerInternalId?: Maybe<Scalars['MixedType']>;
  readonly customerIsActivated?: Maybe<Scalars['MixedType']>;
  readonly customerIsDeleted?: Maybe<Scalars['MixedType']>;
  readonly customerIsFullyRegistered?: Maybe<Scalars['MixedType']>;
  readonly customerIsTest?: Maybe<Scalars['MixedType']>;
  readonly customerIsValidated?: Maybe<Scalars['MixedType']>;
  readonly customerIsVatCommitted?: Maybe<Scalars['MixedType']>;
  readonly customerLocalAddress?: Maybe<Scalars['MixedType']>;
  readonly customerLocalCity?: Maybe<Scalars['MixedType']>;
  readonly customerLocalCompanyName?: Maybe<Scalars['MixedType']>;
  readonly customerLocalCountry?: Maybe<Scalars['MixedType']>;
  readonly customerLocalFullName?: Maybe<Scalars['MixedType']>;
  readonly customerLocalName?: Maybe<Scalars['MixedType']>;
  readonly customerLocalRegNumber?: Maybe<Scalars['MixedType']>;
  readonly customerLocalSurname?: Maybe<Scalars['MixedType']>;
  readonly customerLocalVatNumber?: Maybe<Scalars['MixedType']>;
  readonly customerLocalZip?: Maybe<Scalars['MixedType']>;
  readonly customerMailSubscribed?: Maybe<Scalars['MixedType']>;
  readonly customerName?: Maybe<Scalars['MixedType']>;
  readonly customerPhone?: Maybe<Scalars['MixedType']>;
  readonly customerProfileImage?: Maybe<ProfileImage>;
  readonly customerProfileImageId?: Maybe<Scalars['MixedType']>;
  readonly customerRegNumber?: Maybe<Scalars['MixedType']>;
  readonly customerSalesforceId?: Maybe<Scalars['ID']>;
  readonly customerStatus?: Maybe<FbTaUserAccountStatusEnum>;
  readonly customerSurname?: Maybe<Scalars['MixedType']>;
  readonly customerVatNumber?: Maybe<Scalars['MixedType']>;
  readonly customerZip?: Maybe<Scalars['MixedType']>;
  readonly deposits?: Maybe<ReadonlyArray<Maybe<Deposit>>>;
  readonly externalAdAccounts?: Maybe<ReadonlyArray<Maybe<FbAdAccount>>>;
  readonly externalAdvertiserId?: Maybe<Scalars['MixedType']>;
  readonly fbUsers?: Maybe<ReadonlyArray<Maybe<FbTaUser>>>;
  readonly walletBalance?: Maybe<Scalars['Float']>;
  readonly walletId?: Maybe<Scalars['ID']>;
};


export type FbTaUserAccountCustomerFundsArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
};


export type FbTaUserAccountDepositsArgs = {
  filter?: InputMaybe<DepositFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type FbTaUserAccountExternalAdAccountsArgs = {
  filter?: InputMaybe<FbAdAccountFilter>;
  filterExclude?: InputMaybe<FbAdAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FbTaUserAccountFbUsersArgs = {
  filter?: InputMaybe<FbTaUserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type FbTaUserAccountFilter = {
  readonly customerAccountType?: InputMaybe<ReadonlyArray<InputMaybe<FbClientTypeEnum>>>;
  readonly customerCompanyName?: InputMaybe<Scalars['String']>;
  readonly customerEmail?: InputMaybe<Scalars['String']>;
  readonly customerExternalId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerFullName?: InputMaybe<Scalars['String']>;
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerIsActivated?: InputMaybe<Scalars['Boolean']>;
  readonly customerIsDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly customerIsTest?: InputMaybe<Scalars['Boolean']>;
  readonly customerIsValidated?: InputMaybe<Scalars['Boolean']>;
  readonly customerName?: InputMaybe<Scalars['String']>;
  readonly customerStatus?: InputMaybe<ReadonlyArray<InputMaybe<FbTaUserAccountStatusEnum>>>;
  readonly customerSurname?: InputMaybe<Scalars['String']>;
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly userEmail?: InputMaybe<Scalars['String']>;
  readonly userId?: InputMaybe<Scalars['ID']>;
};

export type FbTaUserAccountFunds = {
  readonly __typename?: 'fbTaUserAccountFunds';
  readonly customerActiveAccountFunds?: Maybe<Scalars['Float']>;
  readonly customerAvailableToSpendFunds?: Maybe<Scalars['Float']>;
  readonly customerClosedAccountFunds?: Maybe<Scalars['Float']>;
  readonly customerDisabledAccountFunds?: Maybe<Scalars['Float']>;
  readonly customerFundsLeftTotal?: Maybe<Scalars['Float']>;
  readonly customerHasUnlimitedSpendCap?: Maybe<Scalars['Boolean']>;
};

export enum FbTaUserAccountStatusEnum {
  /** Customer is active */
  Active = 'ACTIVE',
  /** Customer is deleted */
  Deleted = 'DELETED',
  /** Customer is pending for activation */
  Pending = 'PENDING'
}

export type FbTaUserFilter = {
  readonly userCompanyName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly userEmail?: InputMaybe<Scalars['String']>;
  readonly userId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly userIsActivated?: InputMaybe<Scalars['Boolean']>;
  readonly userIsDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly userIsValidated?: InputMaybe<Scalars['Boolean']>;
  readonly userName?: InputMaybe<Scalars['String']>;
  readonly userSurname?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

/** Facebook user */
export type FbUser = {
  readonly __typename?: 'fbUser';
  readonly email: Scalars['String'];
  readonly firstName?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly lastName?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type FbUserFilter = {
  readonly accessToken: Scalars['String'];
  readonly jwt?: InputMaybe<Scalars['Int']>;
};

export type FbWallet = {
  readonly __typename?: 'fbWallet';
  readonly bankCurrency?: Maybe<Scalars['String']>;
  readonly bankId?: Maybe<Scalars['ID']>;
  readonly customerFullName?: Maybe<Scalars['ID']>;
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly walletBalance?: Maybe<Scalars['Float']>;
  readonly walletId?: Maybe<Scalars['ID']>;
};

export type FbWalletFilter = {
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly walletId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

/** Generic statistics */
export type GenericStatistics = {
  readonly __typename?: 'genericStatistics';
  readonly categories?: Maybe<Scalars['MixedType']>;
  readonly series?: Maybe<Scalars['MixedType']>;
};

export type GlobalChangeLog = {
  readonly __typename?: 'globalChangeLog';
  readonly action?: Maybe<Scalars['String']>;
  readonly entityId?: Maybe<Scalars['String']>;
  readonly entityType?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['Int']>;
  readonly modifiedAt?: Maybe<Scalars['String']>;
  readonly modifierId?: Maybe<Scalars['Int']>;
  readonly modifierLevel?: Maybe<Scalars['String']>;
  readonly result?: Maybe<Scalars['keyValueData']>;
};

export type Group = {
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** The id of the parent campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external id of the group. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: Maybe<Scalars['String']>;
  /** The name of the group. */
  readonly name?: Maybe<Scalars['String']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
};

export type ImportSetting = {
  readonly __typename?: 'importSetting';
  readonly entityId?: Maybe<Scalars['ID']>;
  readonly entityType?: Maybe<Scalars['String']>;
  readonly settings?: Maybe<Scalars['MixedType']>;
};

export type ImportSettingFilter = {
  readonly entityId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly entityType?: InputMaybe<ReadonlyArray<InputMaybe<EntityType>>>;
  readonly settingName?: InputMaybe<ReadonlyArray<InputMaybe<SettingName>>>;
  readonly settingValue?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

/** Source map filename with base64 encoded content. */
export type JsSourceMapData = {
  /** Base64 encoded source map */
  readonly content: Scalars['String'];
  /** Source map filename */
  readonly name: Scalars['String'];
};

/** Application name to determine to which app the JS source map belongs. */
export enum JsTraceAppOptions {
  /** FBS user application */
  Fbs = 'fbs',
  /** FBS admin application */
  FbsAdmin = 'fbs_admin',
  /** TW user application */
  Tw = 'tw',
  /** TW admin application */
  TwAdmin = 'tw_admin'
}

export type KvsKey = {
  readonly __typename?: 'kvsKey';
  readonly key?: Maybe<Scalars['MixedType']>;
};

export type LiAd = Ad & {
  readonly __typename?: 'liAd';
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** The id of the ad. */
  readonly adId?: Maybe<Scalars['String']>;
  /** The label of the call-to-action button and the external form ID that it points to. */
  readonly callToAction?: Maybe<Scalars['keyValueData']>;
  /** The id of the parent campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  /**
   * Data received from external system (can not be filtered).
   * @deprecated Fields moved from liAd.entityData directly to liAd
   */
  readonly entityData?: Maybe<Scalars['keyValueData']>;
  /** (entity, id, urn) The external sponsored account associated with the campaign. */
  readonly externalAdAccount?: Maybe<Scalars['keyValueData']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external sponsored account name. \ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external advertiser name. \ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  /** (entity, id, urn) The external sponsored campaign data. */
  readonly externalCampaign?: Maybe<Scalars['keyValueData']>;
  /** (entity, id, urn) The external sponsored group data. */
  readonly externalGroup?: Maybe<Scalars['keyValueData']>;
  /** The external id of the ad. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** The external organization/brand id of the campaign. */
  readonly externalOrganizationId?: Maybe<Scalars['String']>;
  /** The external organization/brand name. \ You can search external organization/brand name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalOrganizationName?: Maybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: Maybe<Scalars['String']>;
  /** LinkedIn statistics. */
  readonly liStats?: Maybe<ReadonlyArray<Maybe<LiStats>>>;
  /** The name of the ad. */
  readonly name?: Maybe<Scalars['String']>;
  /** The group objective. */
  readonly objective?: Maybe<Scalars['String']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** A reference for this object to an external system, with semantics varying based on the creative type. */
  readonly reference?: Maybe<Scalars['keyValueData']>;
  /** Review status and rejection reasons. */
  readonly review?: Maybe<Scalars['keyValueData']>;
  /** Status of the creative as controlled by the user. Creative status is set independently from parent entity status, but parent entity status overrides creative status in effect. For example, parent entity status may be PAUSED while creative status is ACTIVE, in which case creative is in effect PAUSED, and not served. */
  readonly servingStatuses?: Maybe<Scalars['keyValueData']>;
  /** The status of the ad. Representing status on the external system. */
  readonly status?: Maybe<Scalars['String']>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
  /** TEXT_AD - Text with sponsored link to landing page on your site \ SPONSORED_STATUS_UPDATE - Sponsored status update from a profile page \ SPONSORED_INMAILS - Sponsored InMails \ SPONSORED_VIDEO - Sponsored Videos */
  readonly type?: Maybe<Scalars['String']>;
  /** Variables for rendering the creative. */
  readonly variables?: Maybe<Scalars['keyValueData']>;
};


export type LiAdLiStatsArgs = {
  filter?: InputMaybe<LiStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  segmentationFilter?: InputMaybe<LiStatisticsSegmentationFilter>;
};

export type LiCampaign = Campaign & {
  readonly __typename?: 'liCampaign';
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** Flag that denotes whether the campaign was created organically or was created to backfill existing groups. */
  readonly backfilled?: Maybe<Scalars['Boolean']>;
  /** The id of the campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  /** The adAccount currency. */
  readonly currency?: Maybe<Scalars['String']>;
  /** The time that the campaign will begin. */
  readonly dateFrom?: Maybe<Scalars['DateTimeUTC']>;
  /** The time that the campaign will end. */
  readonly dateTo?: Maybe<Scalars['DateTimeUTC']>;
  /**
   * Data received from external system (can not be filtered).
   * @deprecated Fields moved from liCampaign.entityData directly to liCampaign
   */
  readonly entityData?: Maybe<Scalars['keyValueData']>;
  /** (entity, id, urn) The external sponsored account associated with the campaign. */
  readonly externalAdAccount?: Maybe<Scalars['keyValueData']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external sponsored account name. \ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external advertiser name. \ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  /** (entity, id, urn) The external sponsored campaign data. */
  readonly externalCampaign?: Maybe<Scalars['keyValueData']>;
  /** The external id of the campaign. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** The external organization/brand id of the campaign. */
  readonly externalOrganizationId?: Maybe<Scalars['String']>;
  /** The external organization/brand name. \ You can search external organization/brand name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalOrganizationName?: Maybe<Scalars['String']>;
  /** Ads under specific campaign. */
  readonly liAds?: Maybe<ReadonlyArray<Maybe<LiAd>>>;
  /** Groups under specific campaign. */
  readonly liGroups?: Maybe<ReadonlyArray<Maybe<LiGroup>>>;
  /** LinkedIn statistics. */
  readonly liStats?: Maybe<ReadonlyArray<Maybe<LiStats>>>;
  /** The name of the campaign. */
  readonly name?: Maybe<Scalars['String']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** Array of enums that determine whether or not groups within the campaign may be served; unlike 'status', which is user-managed, the values are controlled by the service. */
  readonly servingStatuses?: Maybe<Scalars['keyValueData']>;
  /** The status of the campaign. Representing status on the external system. */
  readonly status?: Maybe<Scalars['String']>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
  /** The total budget amount to be allocated to the campaign. */
  readonly totalBudget?: Maybe<Scalars['keyValueData']>;
};


export type LiCampaignLiStatsArgs = {
  filter?: InputMaybe<LiStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  segmentationFilter?: InputMaybe<LiStatisticsSegmentationFilter>;
};

export type LiConversion = {
  readonly __typename?: 'liConversion';
  /** (click and view) Specifies a user's settings on the post click and view through (post view) attribution window in days (post click default = 30, view through default = 7). By setting these fields to something else, the advertiser can narrow the window. Allowed values are 1, 7, or 30 */
  readonly attributionWindow?: Maybe<Scalars['keyValueData']>;
  /** Represents the last time one or more of the URL match rules fired and called back to the server. */
  readonly callbackAt?: Maybe<Scalars['String']>;
  /** The Adplatform id of conversion. */
  readonly conversionId?: Maybe<Scalars['String']>;
  /** Represents the time when conversion was created. */
  readonly createdAt?: Maybe<Scalars['String']>;
  /** The insightTagDomain key that this conversion resides under. */
  readonly domainId?: Maybe<Scalars['String']>;
  /** Set to true or false to enable or disable this rule from matching on the advertiser’s website. The initial state can be either, but only rules that are enabled will trigger conversion events. */
  readonly enabled?: Maybe<Scalars['Boolean']>;
  /** (entity, id, urn) The external sponsored account data that this conversion resides under. */
  readonly externalAdAccount?: Maybe<Scalars['keyValueData']>;
  /** The external sponsored account id that this conversion resides under. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external sponsored account name that this conversion resides under. */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** (entity, id, urn) The external conversion data. */
  readonly externalConversion?: Maybe<Scalars['keyValueData']>;
  /** The external id of conversion. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** Image pixel generated for conversion. */
  readonly imagePixelTag?: Maybe<Scalars['String']>;
  /** The liGroups (groups) associated with this conversion. Groups should consist of the creative you want to show in order to drive a particular outcome on the advertiser’s website. The sponsored groups represent the media and the conversion represents the outcome. If omitted, the conversion will have an empty array of groups. */
  readonly liGroups?: Maybe<ReadonlyArray<Maybe<LiGroup>>>;
  /** Represents the last time of conversion modification. */
  readonly modifiedAt?: Maybe<Scalars['String']>;
  /** A short name for this rule, which will be shown in the UI and in reports. */
  readonly name?: Maybe<Scalars['String']>;
  /** An array that contains the conversion URL match rules associated with this conversion. There must be one or more present on creation. */
  readonly rules?: Maybe<Scalars['keyValueData']>;
  /** The type of the rule. Can be one of the following: \ \ ADD_TO_CART - The user added one or more things to their shopping cart. \ DOWNLOAD - The user downloaded a file. \ INSTALL -The user installed a plugin or an app. \ KEY_PAGE_VIEW - The user viewed an important web page or app screen. \ LEAD - The user filled out a lead generation form. \ PURCHASE - The user made a purchase. \ SIGN_UP - The user signed up for a web site or app service. \ OTHER - Other case not listed above. */
  readonly type?: Maybe<Scalars['String']>;
  /** The monetary value for this conversion. If this is set, the currency code should be identical to the currency set on the advertiser account. */
  readonly value?: Maybe<Scalars['keyValueData']>;
};

export type LiGroup = Group & {
  readonly __typename?: 'liGroup';
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** A strongly associated object, with semantics varying based on the group type. */
  readonly associatedEntity?: Maybe<Scalars['keyValueData']>;
  /** Enable Audience Expansion for the group provides query expansion for certain targeting criteria. */
  readonly audienceExpansionEnabled?: Maybe<Scalars['Boolean']>;
  /** Bid (cost type, unit cost) */
  readonly bid?: Maybe<Scalars['keyValueData']>;
  /** The id of the parent campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  /** ROUND_ROBIN - Rotate through available creatives to serve them as easily as possible \ OPTIMIZED - Bias selection taking into account such things as expected performance. */
  readonly creativeSelection?: Maybe<Scalars['String']>;
  /** The currency associated with the ad account. */
  readonly currency?: Maybe<Scalars['String']>;
  /** Maximum amount to spend per day. Currency included. */
  readonly dailyBudget?: Maybe<Scalars['keyValueData']>;
  /** Scheduled date range to run associated creatives. */
  readonly dateFrom?: Maybe<Scalars['DateTimeUTC']>;
  /** Scheduled date range to run associated creatives. */
  readonly dateTo?: Maybe<Scalars['DateTimeUTC']>;
  /**
   * Data received from external system (can not be filtered).
   * @deprecated Fields moved from liGroup.entityData direct to liGroup
   */
  readonly entityData?: Maybe<Scalars['keyValueData']>;
  /** (entity, id, urn) The external sponsored account associated with the campaign. */
  readonly externalAdAccount?: Maybe<Scalars['keyValueData']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external sponsored account name. \ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external advertiser name. \ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  /** (entity, id, urn) The external sponsored campaign data. */
  readonly externalCampaign?: Maybe<Scalars['keyValueData']>;
  /** (entity, id, urn) The external sponsored group data. */
  readonly externalGroup?: Maybe<Scalars['keyValueData']>;
  /** The external id of the group. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** The external organization/brand id of the campaign. */
  readonly externalOrganizationId?: Maybe<Scalars['String']>;
  /** The external organization/brand name. \ You can search external organization/brand name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalOrganizationName?: Maybe<Scalars['String']>;
  /** The ad format on group level. \ \ The group format is a required field when type = DYNAMIC. It restricts the types of creatives that may be added to this group. For example, groups with the CAROUSEL format can only have creatives of SPONSORED_UPDATE_CAROUSEL type and groups with the SINGLE_VIDEO can only have creatives with SPONSORED_VIDEO type. */
  readonly format?: Maybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: Maybe<Scalars['String']>;
  /** Ads under specific group. */
  readonly liAds?: Maybe<ReadonlyArray<Maybe<LiAd>>>;
  /** Conversions under specific group. */
  readonly liConversions?: Maybe<ReadonlyArray<Maybe<LiConversion>>>;
  /** LinkedIn statistics. */
  readonly liStats?: Maybe<ReadonlyArray<Maybe<LiStats>>>;
  /** Locale of the group. */
  readonly locale?: Maybe<Scalars['keyValueData']>;
  /** The name of the group. */
  readonly name?: Maybe<Scalars['String']>;
  /** The group objective. */
  readonly objective?: Maybe<Scalars['String']>;
  /** Allow this group access to be served on the LinkedIn Advertising Network. Default value is "false". */
  readonly offsiteDeliveryEnabled?: Maybe<Scalars['Boolean']>;
  /** Offsite preferences that an advertiser specifies for this group. An example OffsitePreference is an object that contains App Categories, App Store Urls, Web domain names that this group should be included/excluded for. */
  readonly offsitePreferences?: Maybe<Scalars['keyValueData']>;
  /** Determines how this group is optimized for spending. If this is not set then there is no optimization.  */
  readonly optimizationTargetType?: Maybe<Scalars['String']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** The status of the group. Representing status on the external system. */
  readonly status?: Maybe<Scalars['String']>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
  /** Group targeting. */
  readonly targetingData?: Maybe<Scalars['targetingData']>;
  /** Maximum amount to spend over the life of the group. Currency included. */
  readonly totalBudget?: Maybe<Scalars['keyValueData']>;
  /** TEXT_AD - For the traditional short text with sponsored link advertisement. \ \ SPONSORED_UPDATES - For sponsored linking to status updates on the profile page belonging to the member or company identified by the 'reference' field. \ \ SPONSORED_INMAILS - For sponsored InMail with a CTA. \ \ DYNAMIC - For ads that are dynamically personalized. */
  readonly type?: Maybe<Scalars['String']>;
  /** Each entity has a version tag associated with it which is initiated to 1 when the entity is created. Each single update to the entity will increase its versionTag by 1. */
  readonly versionTag?: Maybe<Scalars['String']>;
};


export type LiGroupLiStatsArgs = {
  filter?: InputMaybe<LiStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  segmentationFilter?: InputMaybe<LiStatisticsSegmentationFilter>;
};

export type LiStatisticsFilter = {
  /** The account id of the campaign. */
  readonly adAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the ad. */
  readonly adId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the campaign. */
  readonly campaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** Get statistics from date (ex: "2018-01-31"). */
  readonly dateFrom: Scalars['String'];
  /** Get statistics to date (ex: "2018-12-31"). */
  readonly dateTo: Scalars['String'];
  /** The external sponsored account id of the campaign. */
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external sponsored account name. \ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: InputMaybe<Scalars['String']>;
  /** The external advertiser id of the campaign. */
  readonly externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  /** The external advertiser name. \ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: InputMaybe<Scalars['String']>;
  /** The external organization/brand id of the campaign. */
  readonly externalOrganizationId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external organization/brand name. \ You can search external organization/brand name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalOrganizationName?: InputMaybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the campaign project. */
  readonly projectId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export type LiStatisticsSegmentationFilter = {
  /** Get statistics from date (ex: "2018-01-31"). */
  readonly dateFrom: Scalars['String'];
  /** Get statistics to date (ex: "2018-12-31"). */
  readonly dateTo: Scalars['String'];
  /** External account id/s. Representing the id on the external system. */
  readonly externalAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** External ad (CONVERSION) id/s. Representing the id on the external system. */
  readonly externalAdId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The external advertiser id of the campaign. */
  readonly externalAdvertiserId: Scalars['String'];
  /** External campaign (CAMPAIGN GROUP) id/s. Representing the id on the external system. */
  readonly externalCampaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** External company id/s. Representing the id on the external system. */
  readonly externalCompanyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** External group (CAMPAIGN) id/s. Representing the id on the external system. */
  readonly externalGroupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** External share id/s. Representing the id on the external system. */
  readonly externalShareId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** Time granularity of results. Valid enum values: \ \ ALL - Results grouped into a single result across the entire time range of the report. \ DAILY - Results grouped by day. \ MONTHLY - Results grouped by month. \ YEARLY - Results grouped by year. */
  readonly granularity: Scalars['String'];
  /** Segmentation of results, which each report data point is grouped by. \ \ The below are valid enum values for query finder(max two can be used): \ \ COMPANY - Group results by advertiser's company. \ ACCOUNT - Group results by account. \ SHARE - Group results by sponsored share. \ CAMPAIGN - Group results by campaign. \ GROUP - Group results by group. \ AD - Group results by ad. \ CONVERSION - Group results by conversion. \ SERVING_LOCATION - Group results by serving location, onsite or offsite. \ CARD_INDEX - Group results by the index of where a card appears in a carousel ad creative. Metrics are based on the index of the card at the time when the user's action (impression, click, etc.) happened on the ad (Carousel ad only). \ \ \ \ The below demographics enum values are supported for a single segmentation: \ \ MEMBER_COMPANY_SIZE - Group results by member company size. \ MEMBER_INDUSTRY - Group results by member industry. \ MEMBER_SENIORITY - Group results by member seniority. \ MEMBER_JOB_TITLE - Group results by member job title. \ MEMBER_JOB_FUNCTION - Group results by member job function. \ MEMBER_COUNTRY - Group results by member country. \ MEMBER_REGION - Group results by member region. \ MEMBER_COMPANY - Group results by member company. */
  readonly segmentation: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

/** Linkedin statistics */
export type LiStats = Statistics & {
  readonly __typename?: 'liStats';
  /** The count of clicks on the action button of the Sponsored InMail. Sponsored InMail only. */
  readonly actionClicks?: Maybe<Scalars['Int']>;
  /** The account id of the campaign. \ \ NOTE: Only available for unsegmented stats! */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** The id of the ad. \ \ NOTE: Only available for unsegmented stats! \ \ _________________________________________________________________________ \ \ linkedIn metrics */
  readonly adId?: Maybe<Scalars['String']>;
  /** The count of clicks on the ad unit displayed alongside the Sponsored InMail. Sponsored InMail only. */
  readonly adUnitClicks?: Maybe<Scalars['Int']>;
  /** The id of the campaign. \ \ NOTE: Only available for unsegmented stats! */
  readonly campaignId?: Maybe<Scalars['String']>;
  /** The number of clicks for each card of a carousel ad. The first card click of the carousel ad results in an immediate cardClick and click, whereas scrolling to other cards and clicking will count as additional cardClick. */
  readonly cardClicks?: Maybe<Scalars['Int']>;
  /** The number of impressions shown for each card of a carousel ad. The first card of the carousel ad results in an immediate cardImpression and impression, whereas scrolling to other cards will count as additional cardImpressions. */
  readonly cardImpressions?: Maybe<Scalars['Int']>;
  /** The count of chargeable clicks. Despite not charging for clicks for CPM campaigns, this field still represents those clicks for which we would otherwise charge advertisers (i.e. clicks to view the landing page or company page). */
  readonly clicks?: Maybe<Scalars['BigInt']>;
  /** The count of likes of a comment. Sponsored Updates only. */
  readonly commentLikes?: Maybe<Scalars['Int']>;
  /** The count of comments. Sponsored Updates only. */
  readonly comments?: Maybe<Scalars['Int']>;
  /** The count of comments. Sponsored Updates only. */
  readonly companyPageClicks?: Maybe<Scalars['Int']>;
  /** Value of the conversions in the account's local currency based on rules defined by the advertiser. Conversion value is set by the advertiser at a per conversion level, and aggregated across the query time range. */
  readonly conversionValueInLocalCurrency?: Maybe<Scalars['Float']>;
  /** Cost in the account's local currency. */
  readonly costInLocalCurrency?: Maybe<Scalars['Float']>;
  /** Cost in USD. */
  readonly costInUsd?: Maybe<Scalars['Float']>;
  /** Statistics date */
  readonly date?: Maybe<Scalars['String']>;
  /** The external account id of the campaign. \ \ NOTE: Only available for unsegmented stats! */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external account name. \ \ NOTE: Only available for unsegmented stats! */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** The external advertiser id of the campaign. \ \ NOTE: Only available for unsegmented stats! */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external advertiser name. \ \ NOTE: Only available for unsegmented stats! */
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  /** The external organization/organization brand id of the campaign. \ \ NOTE: Only available for unsegmented stats! */
  readonly externalOrganizationId?: Maybe<Scalars['String']>;
  /** The external organization/organization brand name. \ \ NOTE: Only available for unsegmented stats! */
  readonly externalOrganizationName?: Maybe<Scalars['String']>;
  /** The count of conversions indicated by pixel loads on an external advertiser website. */
  readonly externalWebsiteConversions?: Maybe<Scalars['Int']>;
  /** The count of post-click conversions indicated by pixel loads on an external advertiser website. */
  readonly externalWebsitePostClickConversions?: Maybe<Scalars['Int']>;
  /** The count of post-view conversions indicated by pixel loads on an external advertiser website. */
  readonly externalWebsitePostViewConversions?: Maybe<Scalars['Int']>;
  /** The count of follows. Sponsored Updates only. */
  readonly follows?: Maybe<Scalars['Int']>;
  /** A user taps on the video, going into video view mode. */
  readonly fullScreenPlays?: Maybe<Scalars['Int']>;
  /** The id of the group. \ \ NOTE: Only available for unsegmented stats! */
  readonly groupId?: Maybe<Scalars['String']>;
  /** This is the count of 'impressions' for Direct Ads and Sponsored Updates and 'sends' for InMails. */
  readonly impressions?: Maybe<Scalars['BigInt']>;
  /** The count of clicks which take the user to the creative landing page. */
  readonly landingPageClicks?: Maybe<Scalars['Int']>;
  /** The number of times a user shared contact info through the One Click Leadgen for Sponsored InMail. Sponsored InMail only. */
  readonly leadGenerationMailContactInfoShares?: Maybe<Scalars['Int']>;
  /** The count of InMail recipients showing interest. Sponsored InMail only. */
  readonly leadGenerationMailInterestedClicks?: Maybe<Scalars['Int']>;
  /** The count of likes. Sponsored Updates only. */
  readonly likes?: Maybe<Scalars['Int']>;
  /** The count of times a user opened the lead form for a One Click Lead Gen campaign. */
  readonly oneClickLeadFormOpens?: Maybe<Scalars['Int']>;
  /** The count of leads generated through One Click Lead Gen. */
  readonly oneClickLeads?: Maybe<Scalars['Int']>;
  /** The count of opens of Sponsored InMail. Sponsored InMail only. */
  readonly opens?: Maybe<Scalars['Int']>;
  /** The count of user interactions with the ad unit that do not fit into any other more specific category. */
  readonly otherEngagements?: Maybe<Scalars['Int']>;
  /** The id of the campaign project. \ \ NOTE: Only available for unsegmented stats! */
  readonly projectId?: Maybe<Scalars['String']>;
  /** Segmentation of results, which each report data point is grouped by. \ \ NOTE: Only available for segmented stats! */
  readonly segmentation?: Maybe<Scalars['String']>;
  /** The value of the segmentations for a specific record returned. For example, supplying segmentations of CREATIVE and CONVERSION will result in a list of records, one for each creative/conversion combination. The segmentValues would contain serialized urns for the specific creative and conversion for a record. \ \ NOTE: Only available for segmented stats! */
  readonly segmentationValues?: Maybe<Scalars['keyValueData']>;
  /** The count of sends of Sponsored InMail. Sponsored InMail only. */
  readonly sends?: Maybe<Scalars['Int']>;
  /** The count of shares. Sponsored Updates only. */
  readonly shares?: Maybe<Scalars['Int']>;
  /** Supplier of the campaign (linkedIn) */
  readonly supplier?: Maybe<Scalars['String']>;
  /** The count of clicks on any links (anchor tags) that were included in the body of the Sponsored InMail. Sponsored InMail only. */
  readonly textUrlClicks?: Maybe<Scalars['Int']>;
  /** The count of all user interactions with the ad unit. */
  readonly totalEngagements?: Maybe<Scalars['Int']>;
  /** The count of video ads that played 97-100% of the video. This includes watches that skipped to this point if the serving location is ON_SITE. */
  readonly videoCompletions?: Maybe<Scalars['Int']>;
  /** The count of video ads that played through the first quartile of the video. This includes watches that skipped to this point if the serving location is ON_SITE. */
  readonly videoFirstQuartileCompletions?: Maybe<Scalars['Int']>;
  /** The count of video ads that played through the midpoint of the video. This includes watches that skippped to this point if the serving location is ON_SITE. */
  readonly videoMidpointCompletions?: Maybe<Scalars['Int']>;
  /** The count of video ads that were started by a user. */
  readonly videoStarts?: Maybe<Scalars['Int']>;
  /** The count of video ads that played through the third quartile of the video. This includes watches that skipped to this point if the serving location is ON_SITE. */
  readonly videoThirdQuartileCompletions?: Maybe<Scalars['Int']>;
  /** A video ad playing for at least 2 continuous seconds 50% in-view, or a click on the CTA, whichever comes first. An interaction with the video (like going to fullscreen mode) does not count as a view. */
  readonly videoViews?: Maybe<Scalars['Int']>;
  /** The number of viralClicks for each card of a carousel ad. The first viralCardClick of the carousel ad results in an immediate viralCardClick and viralClick, whereas scrolling to other cards and clicking will count as additional viralCardClick. */
  readonly viralCardClicks?: Maybe<Scalars['Int']>;
  /** The number of viralImpressions shown for each card of a carousel ad. The first card of the carousel ad results in an immediate viralCardImpression and viralImpression, whereas scrolling to other cards will count as additional viralCardImpressions. */
  readonly viralCardImpressions?: Maybe<Scalars['Int']>;
  /** The count of clicks on viral impressions. See viral impressions definition. Sponsored Updates only. */
  readonly viralClicks?: Maybe<Scalars['Int']>;
  /** The count of likes on comments from viral impressions for this activity. See viral impressions definition. Sponsored Updates only. */
  readonly viralCommentLikes?: Maybe<Scalars['Int']>;
  /** The count of comments from viral impressions for this activity. See viral impressions definition. Sponsored Updates only. */
  readonly viralComments?: Maybe<Scalars['Int']>;
  /** The count of clicks to view the company page from viral impressions for this activity. See viral impressions definition. Sponsored Updates only. */
  readonly viralCompanyPageClicks?: Maybe<Scalars['Int']>;
  /** The count of conversions indicated by pixel loads on an external advertiser website driven by a viral event. See viral impressions definition. */
  readonly viralExternalWebsiteConversions?: Maybe<Scalars['Int']>;
  /** The count of post-click conversions indicated by pixel loads on an external advertiser website driven by a viral click. See viral impressions definition. */
  readonly viralExternalWebsitePostClickConversions?: Maybe<Scalars['Int']>;
  /** The count of post-view conversions indicated by pixel loads on an external advertiser website driven by a viral impression. See viral impressions definition. */
  readonly viralExternalWebsitePostViewConversions?: Maybe<Scalars['Int']>;
  /** The count of follows from viral impressions for this activity. See viral impressions definition. Sponsored Updates only. */
  readonly viralFollows?: Maybe<Scalars['Int']>;
  /** A user taps on the video, going into video view mode. See viralImpressions definition. */
  readonly viralFullScreenPlays?: Maybe<Scalars['Int']>;
  /** The count of viral impressions for this activity. Viral impressions are those resulting from a user sharing a sponsored update to their own network of connections. Viral impressions are not counted as regular impressions. Sponsored Updates only. */
  readonly viralImpressions?: Maybe<Scalars['Int']>;
  /** The count of clicks on viral impressions to take the user to the creative landing page. See viral impressions definition. Sponsored Updates only. */
  readonly viralLandingPageClicks?: Maybe<Scalars['Int']>;
  /** The count of likes from viral impressions for this activity. See viral impressions definition. Sponsored Updates only. */
  readonly viralLikes?: Maybe<Scalars['Int']>;
  /** The count of times a user opened the lead form for viral impressions from a Lead Gen campaign. See viral impressions definition. */
  readonly viralOneClickLeadFormOpens?: Maybe<Scalars['Int']>;
  /** The count of leads generated through One Click Lead Gen from viral impressions for this activity. See viral impressions definition. */
  readonly viralOneClickLeads?: Maybe<Scalars['Int']>;
  /** The count of user interactions with viral impressions that do not fit into any other more specific category. See viral impressions definition. Sponsored Updates only. */
  readonly viralOtherEngagements?: Maybe<Scalars['Int']>;
  /** The count of shares from viral impressions for this activity. See viral impressions definition. Sponsored Updates only. */
  readonly viralShares?: Maybe<Scalars['Int']>;
  /** The count of all user interactions with a viral ad unit. See viral impressions definition. Sponsored Updates only. */
  readonly viralTotalEngagements?: Maybe<Scalars['Int']>;
  /** The count of viral video ads that played 97-100% of the video. This includes watches that skipped to this point. See viralImpressions definition. */
  readonly viralVideoCompletions?: Maybe<Scalars['Int']>;
  /** The count of viral video ads that played through the first quartile of the video. This includes watches that skipped to this point. See viralImpressions definition. */
  readonly viralVideoFirstQuartileCompletions?: Maybe<Scalars['Int']>;
  /** The count of viral video ads that played through the midpoint of the video. This includes watches that skippped to this point. See viralImpressions definition. */
  readonly viralVideoMidpointCompletions?: Maybe<Scalars['Int']>;
  /** The count of viral video ads that were started by a user. See viralImpressions definition. Since viral videos are automatically played for ON_SITE, this will be the same as viralImpressions if the servingLocation is ON_SITE. */
  readonly viralVideoStarts?: Maybe<Scalars['Int']>;
  /** The count of viral video ads that played through the third quartile of the video. This includes watches that skipped to this point. See viralImpressions definition. */
  readonly viralVideoThirdQuartileCompletions?: Maybe<Scalars['Int']>;
  /** A viral video ad playing for at least 2 continuous seconds 50% in-view, or a click on the CTA, whichever comes first. An interaction with the video (like going to fullscreen mode) does not count as a view. See viralImpressions definition. */
  readonly viralVideoViews?: Maybe<Scalars['Int']>;
};

export type LocaleMetadata = {
  readonly __typename?: 'localeMetadata';
  readonly locale?: Maybe<Scalars['MixedType']>;
  readonly timezone?: Maybe<Scalars['String']>;
};

export type PaymentInstruction = {
  readonly __typename?: 'paymentInstruction';
  readonly content?: Maybe<Scalars['String']>;
};

export type PermittedExternalAdvertiser = {
  readonly externalAdvertiserId: Scalars['ID'];
  readonly permitted?: InputMaybe<Scalars['Boolean']>;
};

export type PiPaySettings = {
  readonly __typename?: 'piPaySettings';
  readonly description?: Maybe<Scalars['String']>;
  readonly deviceId?: Maybe<Scalars['ID']>;
  readonly merchantId?: Maybe<Scalars['ID']>;
  readonly storeId?: Maybe<Scalars['ID']>;
};

export type ProfileImage = {
  readonly __typename?: 'profileImage';
  readonly customerId?: Maybe<Scalars['MixedType']>;
  readonly profileImageEncoded?: Maybe<Scalars['MixedType']>;
  readonly profileImageMimeType?: Maybe<Scalars['MixedType']>;
};

export type ReallocationLimit = {
  readonly __typename?: 'reallocationLimit';
  readonly externalAdAccountId: Scalars['String'];
  readonly limit?: Maybe<Scalars['Int']>;
};

export type ReallocationLimitFilter = {
  readonly externalAdAccountId: ReadonlyArray<Scalars['ID']>;
};

export type Report = {
  readonly __typename?: 'report';
  readonly actionFormat?: Maybe<Scalars['String']>;
  readonly actionOptions?: Maybe<Scalars['MixedType']>;
  readonly actionType?: Maybe<Scalars['String']>;
  readonly activatedAt?: Maybe<Scalars['String']>;
  readonly conditions?: Maybe<Scalars['MixedType']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly dataset?: Maybe<Scalars['String']>;
  readonly dateRangeOptions?: Maybe<Scalars['MixedType']>;
  readonly dateType?: Maybe<Scalars['String']>;
  readonly deletedAt?: Maybe<Scalars['String']>;
  readonly dimensions?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly entityId?: Maybe<Scalars['ID']>;
  readonly entityType?: Maybe<Scalars['String']>;
  readonly filters?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly filtersOptions?: Maybe<Scalars['MixedType']>;
  readonly hideZeroRows?: Maybe<Scalars['Boolean']>;
  readonly language?: Maybe<Scalars['String']>;
  readonly metrics?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly name?: Maybe<Scalars['String']>;
  readonly overviewType?: Maybe<Scalars['String']>;
  readonly reportReady?: Maybe<Scalars['String']>;
  readonly reportUrl?: Maybe<Scalars['String']>;
  readonly schedule?: Maybe<Scalars['String']>;
  readonly scopeId?: Maybe<Scalars['ID']>;
  readonly scopeShare?: Maybe<Scalars['String']>;
  readonly scopeType?: Maybe<Scalars['String']>;
  readonly statReportApiId?: Maybe<Scalars['ID']>;
  readonly statReportId?: Maybe<Scalars['ID']>;
  readonly token?: Maybe<Scalars['String']>;
};

export type ReportAction = {
  readonly actionFormat: ReportActionFormat;
  readonly actionOptions?: InputMaybe<ReadonlyArray<InputMaybe<ReportActionOption>>>;
  readonly actionType: ReportActionType;
};

export enum ReportActionFormat {
  Csv = 'csv',
  Excel = 'excel',
  Inline = 'inline',
  Json = 'json'
}

export type ReportActionOption = {
  readonly actionOptionType: ReportActionOptionType;
  readonly actionOptionValue: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

export enum ReportActionOptionType {
  ActionEmails = 'action_emails',
  Dataset = 'dataset',
  From = 'from',
  Table = 'table'
}

export enum ReportActionType {
  /** BigQuery synchronization */
  Bigquery = 'bigquery',
  /** Send report via e-mail */
  Email = 'email',
  /** Display report in UI */
  Show = 'show',
  /**
   * Share URL
   * @deprecated Field was deprecated in favor of BigQuery
   */
  Url = 'url'
}

export type ReportCondition = {
  readonly metric: Scalars['String'];
  readonly operator: Scalars['String'];
  readonly value: Scalars['String'];
};

export type ReportDateOption = {
  readonly dateRange?: InputMaybe<ReportDateRange>;
  readonly dateType: ReportDateType;
};

export type ReportDateRange = {
  readonly dateRangeType: ReportDateRangeType;
  readonly dateRangeValue: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

export enum ReportDateRangeType {
  DateSchedule = 'date_schedule',
  DaysValue = 'days_value'
}

export enum ReportDateType {
  CurrentMonth = 'current_month',
  CurrentWeek = 'current_week',
  CurrentYear = 'current_year',
  Custom = 'custom',
  From = 'from',
  Last = 'last',
  Previous = 'previous',
  Previous_3Months = 'previous_3_months',
  PreviousMonth = 'previous_month',
  PreviousWeek = 'previous_week',
  Today = 'today',
  Yesterday = 'yesterday'
}

export type ReportFilter = {
  readonly actionType?: InputMaybe<ReportActionType>;
  readonly dataset?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly dimensions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly filters?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly metrics?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly statReportId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export enum ReportFilterAction {
  Exclude = 'exclude',
  Include = 'include'
}

export type ReportFilterOption = {
  readonly action: ReportFilterAction;
  readonly filter: Scalars['String'];
  readonly label: Scalars['String'];
  readonly name: Scalars['String'];
  readonly value: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

export enum ReportLanguage {
  En = 'en',
  Si = 'si'
}

export type ReportOAuth = {
  readonly __typename?: 'reportOAuth';
  readonly clientId?: Maybe<Scalars['String']>;
  readonly clientSecret?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
};

export enum ReportOverview {
  Advertiser = 'advertiser',
  Publisher = 'publisher'
}

export enum ReportSchedule {
  EveryMonday = 'every_monday',
  EveryWeekday = 'every_weekday',
  FirstOfTheMonth = 'first_of_the_month',
  OnlyOnce = 'only_once'
}

export type ReportScope = {
  readonly scopeId: Scalars['String'];
  readonly scopeShare: Scalars['Boolean'];
  readonly scopeType: Scalars['String'];
};

export type ReportToken = {
  readonly __typename?: 'reportToken';
  readonly token?: Maybe<Scalars['String']>;
  readonly url?: Maybe<Scalars['String']>;
};

export type ScCampaign = Campaign & {
  readonly __typename?: 'scCampaign';
  readonly adAccountId?: Maybe<Scalars['String']>;
  readonly campaignId?: Maybe<Scalars['String']>;
  readonly currency?: Maybe<Scalars['String']>;
  readonly dailyBudget?: Maybe<Scalars['String']>;
  readonly dateFrom?: Maybe<Scalars['String']>;
  readonly dateTo?: Maybe<Scalars['String']>;
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  readonly externalId?: Maybe<Scalars['String']>;
  readonly isRegistered?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly projectId?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly statusPending?: Maybe<Scalars['String']>;
  readonly supplier?: Maybe<Scalars['String']>;
  readonly totalBudget?: Maybe<Scalars['String']>;
};

export type SelfOnboardingBusinesses = {
  readonly __typename?: 'selfOnboardingBusinesses';
  readonly businessCountryId?: Maybe<Scalars['String']>;
  readonly businessId?: Maybe<Scalars['ID']>;
  readonly externalAdvertiserId?: Maybe<Scalars['ID']>;
};

export enum SettingName {
  /** Account type */
  AccountType = 'account_type',
  /** Max spend cap */
  MaxSpendCap = 'max_spend_cap',
  /** Min spend cap */
  MinSpendCap = 'min_spend_cap',
  /** Spend factor */
  SpendFactor = 'spend_factor'
}

export type SmsapiDutySchedule = {
  readonly __typename?: 'smsapiDutySchedule';
  readonly dateFrom?: Maybe<Scalars['String']>;
  readonly dateTo?: Maybe<Scalars['String']>;
  readonly externalAdvertiserId?: Maybe<Scalars['ID']>;
  readonly recipientId?: Maybe<Scalars['ID']>;
  readonly smsapiDutyScheduleId?: Maybe<Scalars['ID']>;
};

export type SmsapiDutyScheduleFilter = {
  readonly date?: InputMaybe<Scalars['String']>;
  readonly dateFrom?: InputMaybe<Scalars['String']>;
  readonly dateTo?: InputMaybe<Scalars['String']>;
  readonly externalAdvertiserId: Scalars['ID'];
  readonly recipientId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export type SmsapiMessage = {
  readonly __typename?: 'smsapiMessage';
  readonly encoding?: Maybe<Scalars['String']>;
  readonly message?: Maybe<Scalars['String']>;
  readonly recipients?: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly sender?: Maybe<Scalars['String']>;
  readonly smsapiMessageId?: Maybe<Scalars['ID']>;
};

export type SmsapiMessageFilter = {
  readonly encoding?: InputMaybe<Scalars['String']>;
  readonly message?: InputMaybe<Scalars['String']>;
  readonly recipients?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly sender?: InputMaybe<Scalars['String']>;
  readonly smsapiMessageId?: InputMaybe<Scalars['ID']>;
};

/** Minified stack trace to source stack trace email error handler. */
export type StackTrace = {
  readonly __typename?: 'stackTrace';
  readonly record: Scalars['Boolean'];
};

/** Statistics interface */
export type Statistics = {
  readonly adAccountId?: Maybe<Scalars['String']>;
  readonly adId?: Maybe<Scalars['String']>;
  readonly campaignId?: Maybe<Scalars['String']>;
  readonly clicks?: Maybe<Scalars['BigInt']>;
  readonly groupId?: Maybe<Scalars['String']>;
  readonly impressions?: Maybe<Scalars['BigInt']>;
  readonly projectId?: Maybe<Scalars['String']>;
  readonly supplier?: Maybe<Scalars['String']>;
};

export enum Supplier {
  /** Supplier FACEBOOK */
  Facebook = 'FACEBOOK',
  /** Supplier LINKEDIN */
  Linkedin = 'LINKEDIN',
  /** Supplier TWITTER */
  Twitter = 'TWITTER'
}

export type SyncExternalFbAdAccountInput = {
  readonly endAdvertiser?: InputMaybe<Scalars['String']>;
  readonly externalFbAdAccountId: Scalars['String'];
  readonly name?: InputMaybe<Scalars['String']>;
  readonly partner?: InputMaybe<Scalars['String']>;
  readonly spendCap?: InputMaybe<FbSpendCap>;
};

/** Transaction external */
export type TransactionExternal = {
  readonly __typename?: 'transactionExternal';
  readonly bankCurrency?: Maybe<Scalars['String']>;
  readonly bankId?: Maybe<Scalars['ID']>;
  readonly businessCurrency?: Maybe<Scalars['String']>;
  readonly customerCompanyName?: Maybe<Scalars['String']>;
  readonly customerEmail?: Maybe<Scalars['String']>;
  readonly customerFullName?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly customerName?: Maybe<Scalars['String']>;
  readonly customerSurname?: Maybe<Scalars['String']>;
  readonly externalAdAccountTransactions?: Maybe<ReadonlyArray<Maybe<ExternalAdAccountTransaction>>>;
  readonly modifierFullName?: Maybe<Scalars['String']>;
  readonly transactionExternalAmount?: Maybe<Scalars['Float']>;
  readonly transactionExternalDescription?: Maybe<Scalars['String']>;
  readonly transactionExternalEntryDate?: Maybe<Scalars['String']>;
  readonly transactionExternalId?: Maybe<Scalars['ID']>;
  readonly transactionExternalStatus?: Maybe<Scalars['String']>;
  readonly transactionExternalTransactionType?: Maybe<Scalars['String']>;
};


/** Transaction external */
export type TransactionExternalExternalAdAccountTransactionsArgs = {
  filter?: InputMaybe<ExternalAdAccountTransactionFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type TransactionExternalFilter = {
  readonly bankId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly transactionExternalEntryDateFrom: Scalars['String'];
  readonly transactionExternalEntryDateTo: Scalars['String'];
  readonly transactionExternalId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly transactionExternalStatus?: InputMaybe<Scalars['String']>;
  readonly transactionExternalTransactionType?: InputMaybe<ReadonlyArray<InputMaybe<TransactionType>>>;
};

export type TwAd = Ad & {
  readonly __typename?: 'twAd';
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** The id of the ad. */
  readonly adId?: Maybe<Scalars['String']>;
  /** The id of the parent campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external sponsored account name.\ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external advertiser name.\ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  /** The external id of the ad. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: Maybe<Scalars['String']>;
  /** The name of the ad. */
  readonly name?: Maybe<Scalars['String']>;
  readonly objective?: Maybe<Scalars['String']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** The status of the ad. Representing status on the external system. */
  readonly status?: Maybe<TwAdStatus>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
  /** Ad statistics */
  readonly twStats?: Maybe<ReadonlyArray<Maybe<TwStats>>>;
};


export type TwAdTwStatsArgs = {
  excludeFilter?: InputMaybe<TwStatsExcludeFilter>;
  filter?: InputMaybe<TwStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  liveStatsFilter?: InputMaybe<TwLiveStatsFilter>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};

export type TwAdFilter = {
  /** The account id of the campaign. */
  readonly adAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the ad. */
  readonly adId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the parent campaign. */
  readonly campaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external sponsored account name.\ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: InputMaybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  /** The external advertiser name.\ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: InputMaybe<Scalars['String']>;
  /** The external id of the ad. Representing the id on the external system. */
  readonly externalId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the group. */
  readonly groupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The name of the ad. */
  readonly name?: InputMaybe<Scalars['String']>;
  readonly objective?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The id of the campaign project. */
  readonly projectId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The status of the ad. Representing status on the external system. */
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<TwAdStatus>>>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export enum TwAdStatus {
  /** Denotes that the Campaign/Group is fully serving. */
  Active = 'ACTIVE',
  /** Denotes that the Campaign/Group has been permanently deleted and cannot be reactivated. */
  Deleted = 'DELETED',
  /** Denotes that the Campaign/Group meets all requirements to be served, but temporarily should not be. */
  Paused = 'PAUSED'
}

export enum TwBudgetOptimization {
  /** Budget optimization is based on campaign level. */
  Campaign = 'CAMPAIGN',
  /** Budget optimization is based on group level. */
  LineItem = 'LINE_ITEM'
}

export type TwCampaign = Campaign & {
  readonly __typename?: 'twCampaign';
  /** The end time of the AB test that is not deleted. */
  readonly abTestEndTime?: Maybe<Scalars['String']>;
  /** The ID of the AB test that is not deleted. */
  readonly abTestId?: Maybe<Scalars['Int']>;
  /** The name of the AB test that is not deleted. */
  readonly abTestName?: Maybe<Scalars['String']>;
  /** The start time of the AB test that is not deleted. */
  readonly abTestStartTime?: Maybe<Scalars['String']>;
  /** Last activated date for campaign. */
  readonly activatedAt?: Maybe<Scalars['String']>;
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** The internal ad account name. */
  readonly adAccountName?: Maybe<Scalars['String']>;
  readonly budgetOptimization?: Maybe<TwBudgetOptimization>;
  /** The id of the campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  /** The currency associated with the specified funding instrument. */
  readonly currency?: Maybe<Scalars['String']>;
  /** The daily budget amount to be allocated to the campaign. */
  readonly dailyBudget?: Maybe<Scalars['String']>;
  /**
   * The time that the campaign will begin.
   * @deprecated Field was deprecated because of Campaign budget optimization feature
   */
  readonly dateFrom?: Maybe<Scalars['String']>;
  /**
   * The time that the campaign will end.
   * @deprecated Field was deprecated because of Campaign budget optimization feature
   */
  readonly dateTo?: Maybe<Scalars['String']>;
  /** Deleted date of campaign. */
  readonly deletedAt?: Maybe<Scalars['String']>;
  /** Enable standard or accelerated delivery. See Budget Pacing for more information on standard versus accelerated delivery.\ \ Type: boolean\ \ Default: STANDARD\ Possible values: STANDARD, ACCELERATED */
  readonly deliveryType?: Maybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external sponsored account name.\ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external advertiser name.\ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  /** The external id of the campaign. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  readonly fundingInstrumentDescription?: Maybe<Scalars['String']>;
  /** The identifier for the funding instrument to create the campaign under.\ \ Type: string\ \ Example: lygyi */
  readonly fundingInstrumentId?: Maybe<Scalars['String']>;
  readonly groupCount?: Maybe<Scalars['Int']>;
  /** If there is combined mode strategy applied on campaign */
  readonly hasCombinedMode?: Maybe<Scalars['Int']>;
  /** If there is product feed for dynamic ads on group */
  readonly hasProductFeed?: Maybe<Scalars['Int']>;
  /** If there is rule applied on campaign */
  readonly hasRule?: Maybe<Scalars['Int']>;
  readonly hasScheduledBidRule?: Maybe<Scalars['Boolean']>;
  readonly isHeartToRemind?: Maybe<Scalars['Int']>;
  readonly kpis?: Maybe<Scalars['keyValueData']>;
  readonly maxGroupDateTo?: Maybe<Scalars['String']>;
  readonly minGroupDateFrom?: Maybe<Scalars['String']>;
  /** The name of the campaign. */
  readonly name?: Maybe<Scalars['String']>;
  /** The campaign objective.\ \ Type: enum\ \ Possible values: APP_ENGAGEMENTS, APP_INSTALLS, REACH, FOLLOWERS, ENGAGEMENTS, VIDEO_VIEWS, PREROLL_VIEWS, WEBSITE_CLICKS */
  readonly objective?: Maybe<Scalars['String']>;
  /**
   * The placement location(s) for this group to display in. Specify a comma-separated list of placement values.\ \ Type: enum\ \ Possible values: ALL_ON_TWITTER, PUBLISHER_NETWORK, TWITTER_PROFILE, TWITTER_SEARCH, TWITTER_TIMELINE
   * @deprecated Field moved from TwCampaign to TwGroup
   */
  readonly placements?: Maybe<Scalars['String']>;
  /** The type of promoted product that this group will contain.\ \ Type: enum\ \ Possible values: PROMOTED_ACCOUNT, PROMOTED_TWEETS */
  readonly productType?: Maybe<Scalars['String']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** The status of the campaign. Representing status on the external system. */
  readonly status?: Maybe<TwStatus>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
  /** Timezone name of the external ad account */
  readonly timezoneName?: Maybe<Scalars['String']>;
  /** The total budget amount to be allocated to the campaign. */
  readonly totalBudget?: Maybe<Scalars['String']>;
  /** Ads associated with the campaign */
  readonly twAds?: Maybe<ReadonlyArray<Maybe<TwAd>>>;
  /** Ad groups associated with the campaign */
  readonly twGroups?: Maybe<ReadonlyArray<Maybe<TwGroup>>>;
  /** Campaign statistics */
  readonly twStats?: Maybe<ReadonlyArray<Maybe<TwStats>>>;
  readonly updatedAt?: Maybe<Scalars['String']>;
  /** The campaign was in an AB test that was deleted after the campaign started. */
  readonly usedInDeletedTest?: Maybe<Scalars['Boolean']>;
};


export type TwCampaignTwAdsArgs = {
  filter?: InputMaybe<TwAdFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type TwCampaignTwGroupsArgs = {
  filter?: InputMaybe<TwGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type TwCampaignTwStatsArgs = {
  excludeFilter?: InputMaybe<TwStatsExcludeFilter>;
  filter?: InputMaybe<TwStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  liveStatsFilter?: InputMaybe<TwLiveStatsFilter>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};

export type TwGroup = Group & {
  readonly __typename?: 'twGroup';
  readonly abTestEndTime?: Maybe<Scalars['String']>;
  readonly abTestId?: Maybe<Scalars['Int']>;
  readonly abTestName?: Maybe<Scalars['String']>;
  readonly abTestStartTime?: Maybe<Scalars['String']>;
  /** Last activated date for group. */
  readonly activatedAt?: Maybe<Scalars['String']>;
  /** The account id of the campaign. */
  readonly adAccountId?: Maybe<Scalars['String']>;
  /** The internal ad account name. */
  readonly adAccountName?: Maybe<Scalars['String']>;
  readonly adsNum?: Maybe<Scalars['Int']>;
  /** The Google App Store identifier for the promoted application associated with the group */
  readonly androidAppId?: Maybe<Scalars['String']>;
  /** The Google app name for the promoted application associated with the group */
  readonly androidAppName?: Maybe<Scalars['String']>;
  /** The bid amount to be associated with this group. The currency associated with the specified funding instrument will be used.\ \ Note: Required if bidType is set to either MAX or TARGET.\ \ Note: Only values greater than zero are accepted.\ \ Type: decimal\ \ Example: 5.50000000 */
  readonly bidAmount?: Maybe<Scalars['String']>;
  /** The bidding mechanism.\ \ AUTO automatically optimizes bidding based on daily budget and campaign flight dates.\ \ MAX sets the maximum allowable bid and is not available when the objective is set to REACH or FOLLOWERS.\ \ TARGET attempts to make daily bid averages within 20% of the specified bidAmount and is available when the objective is set to REACH, FOLLOWERS, OR WEBSITE_CLICKS.\ \ Note: If set to AUTO, bidAmount will be ignored.\ \ Note: Default based on objective.\ \ Type: enum \ \ Possible values: AUTO, MAX, TARGET */
  readonly bidType?: Maybe<Scalars['String']>;
  /**
   * The bid unit for this group. This setting is available for groups using the APP_INSTALLS or VIDEO_VIEWS objectives.\ \ Note: For other objectives, the bid unit is automatically set.\ \ Type: enum \ \ Possible values: APP_CLICK, APP_INSTALL, VIEW, VIEW_3S_100PCT
   * @deprecated Is set by "goal" since Ads API v9 and no longer returned.
   */
  readonly bidUnit?: Maybe<Scalars['String']>;
  /** The id of the parent campaign. */
  readonly campaignId?: Maybe<Scalars['String']>;
  readonly campaignName?: Maybe<Scalars['String']>;
  /** The relevant IAB categories for this advertiser. See GET iab_categories.\ \ Note: Required when the group’s placement is set to PUBLISHER_NETWORK.\ \ Type: string\ \ Example: IAB3-1 */
  readonly categories?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /** The unit to charge this group by. This setting is only available for groups using the APP_INSTALLS objective, where chargeBy defaults to APP_CLICK. \ \ Note: For other objectives, chargeBy is automatically set and defaults to the group’s bid unit. \ \ Type: enum \ \ Possible values: APP_CLICK, APP_INSTALL */
  readonly chargeBy?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  /** The currency associated with the specified funding instrument. */
  readonly currency?: Maybe<Scalars['String']>;
  readonly dailyBudget?: Maybe<Scalars['String']>;
  readonly dateFrom?: Maybe<Scalars['String']>;
  readonly dateTo?: Maybe<Scalars['String']>;
  /** Deleted date of group. */
  readonly deletedAt?: Maybe<Scalars['String']>;
  /** The website domain for this advertiser, without the protocol specification.\ \ Note: Required when the group’s placement is set to PUBLISHER_NETWORK.\ \ Type: string\ \ Example: twitter.com */
  readonly domain?: Maybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: Maybe<Scalars['String']>;
  /** The external sponsored account name.\ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  /** The external advertiser name.\ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: Maybe<Scalars['String']>;
  /** The external id of the group. Representing the id on the external system. */
  readonly externalId?: Maybe<Scalars['String']>;
  readonly forceSync?: Maybe<Scalars['Int']>;
  /** Set your own limit to the amount of times someone might see your ad */
  readonly frequencyCap?: Maybe<Scalars['Int']>;
  /** Set your own limit to the amount of times someone might see your ad (in num of days) */
  readonly frequencyCapDuration?: Maybe<Scalars['Int']>;
  /** The optimization setting for group. Automatically set optimization_preference and bid_unit on the backend. */
  readonly goal?: Maybe<Scalars['String']>;
  readonly groupDateFrom?: Maybe<Scalars['String']>;
  readonly groupDateTo?: Maybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: Maybe<Scalars['String']>;
  /** If there is product feed for dynamic ads on group */
  readonly hasProductFeed?: Maybe<Scalars['Int']>;
  /** If there is rule applied on group */
  readonly hasRule?: Maybe<Scalars['Int']>;
  /** The numeric portion of the Apple App Store identifier for promoted applications associated with the group */
  readonly iosAppId?: Maybe<Scalars['String']>;
  /** The Apple app name for promoted applications associated with the group */
  readonly iosAppName?: Maybe<Scalars['String']>;
  /** The name of the group. */
  readonly name?: Maybe<Scalars['String']>;
  /** The campaign objective for this group.\ \ Type: enum\ \ Possible values: APP_ENGAGEMENTS, APP_INSTALLS, REACH, FOLLOWERS, ENGAGEMENTS, VIDEO_VIEWS, PREROLL_VIEWS, WEBSITE_CLICKS */
  readonly objective?: Maybe<Scalars['String']>;
  /**
   * The optimization setting to use with this group.\ \ Type: enum\ \ Default: DEFAULT\ Possible values: DEFAULT, ENGAGEMENTS, WEBSITE_CONVERSIONS
   * @deprecated Is set by "goal" since Ads API v9 and no longer returned.
   */
  readonly optimization?: Maybe<Scalars['String']>;
  readonly placements?: Maybe<Scalars['keyValueData']>;
  /** The id of the campaign project. */
  readonly projectId?: Maybe<Scalars['String']>;
  /** The status of the group. Representing status on the external system. */
  readonly status?: Maybe<TwStatus>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: Maybe<Scalars['String']>;
  /** The total budget amount to be allocated to the group. The currency associated with the specified funding instrument will be used.\ \ Type: decimal\ \ Example: 3.75000000 */
  readonly totalBudget?: Maybe<Scalars['String']>;
  /** Ads associated with the group */
  readonly twAds?: Maybe<ReadonlyArray<Maybe<TwAd>>>;
  /** Group statistics */
  readonly twStats?: Maybe<ReadonlyArray<Maybe<TwStats>>>;
  readonly updatedAt?: Maybe<Scalars['String']>;
  readonly usedInDeletedTest?: Maybe<Scalars['Boolean']>;
  /** The identifier of the primary web event tag. Allows more accurate tracking of engagements for the campaign pertaining to this group.\ \ Type: string\ \ Example: nvo4z */
  readonly webTag?: Maybe<Scalars['String']>;
};


export type TwGroupTwAdsArgs = {
  filter?: InputMaybe<TwAdFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type TwGroupTwStatsArgs = {
  excludeFilter?: InputMaybe<TwStatsExcludeFilter>;
  filter?: InputMaybe<TwStatisticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  liveStatsFilter?: InputMaybe<TwLiveStatsFilter>;
  orderBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  returnFlatData?: InputMaybe<Scalars['Boolean']>;
};

export type TwGroupFilter = {
  /** The account id of the campaign. */
  readonly adAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The bidding mechanism.\ \ AUTO automatically optimizes bidding based on daily budget and campaign flight dates.\ \ MAX sets the maximum allowable bid and is not available when the objective is set to REACH or FOLLOWERS.\ \ TARGET attempts to make daily bid averages within 20% of the specified bidAmount and is available when the objective is set to REACH, FOLLOWERS, OR WEBSITE_CLICKS.\ \ Note: If set to AUTO, bidAmount will be ignored.\ \ Note: Default based on objective.\ \ Type: enum \ \ Possible values: AUTO, MAX, TARGET */
  readonly bidType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The id of the parent campaign. */
  readonly campaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The unit to charge this group by. This setting is only available for groups using the APP_INSTALLS objective, where chargeBy defaults to APP_CLICK. \ \ Note: For other objectives, chargeBy is automatically set and defaults to the group’s bid unit. \ \ Type: enum \ \ Possible values: APP_CLICK, APP_INSTALL */
  readonly chargeBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The currency associated with the specified funding instrument. */
  readonly currency?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The website domain for this advertiser, without the protocol specification.\ \ Note: Required when the group’s placement is set to PUBLISHER_NETWORK.\ \ Type: string\ \ Example: twitter.com */
  readonly domain?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  /** The external id of the group. Representing the id on the external system. */
  readonly externalId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly forceSync?: InputMaybe<Scalars['Int']>;
  /** The optimization setting for group. Automatically set optimization_preference and bid_unit on the backend. */
  readonly goal?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The id of the group. */
  readonly groupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The name of the group. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The campaign objective for this group.\ \ Type: enum\ \ Possible values: APP_ENGAGEMENTS, APP_INSTALLS, REACH, FOLLOWERS, ENGAGEMENTS, VIDEO_VIEWS, PREROLL_VIEWS, WEBSITE_CLICKS */
  readonly objective?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The id of the campaign project. */
  readonly projectId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The status of the group. Representing status on the external system. */
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<TwStatus>>>;
  /** Supplier of the campaign (twitter, LinkedIn, snapchat). */
  readonly supplier?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** The identifier of the primary web event tag. Allows more accurate tracking of engagements for the campaign pertaining to this group.\ \ Type: string\ \ Example: nvo4z */
  readonly webTag?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type TwLiveStatsFilter = {
  /** Get statistics from date (ex: "2018-01-31"). */
  readonly dateFrom?: InputMaybe<Scalars['String']>;
  /** Get statistics to date (ex: "2018-12-31"). */
  readonly dateTo?: InputMaybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: InputMaybe<Scalars['ID']>;
  /** The external ad id. */
  readonly externalAdId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external advertiser id. */
  readonly externalAdvertiserId: Scalars['ID'];
  /** The external campaign id. */
  readonly externalCampaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external creative id. */
  readonly externalCreativeId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external group id. */
  readonly externalGroupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** Stats granularity */
  readonly granularity?: InputMaybe<TwStatsGranularityEnum>;
};

export type TwStatisticsFilter = {
  /** The account id of the campaign. */
  readonly adAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the ad. */
  readonly adId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The name of the ad. */
  readonly adName?: InputMaybe<Scalars['String']>;
  /** The id of the campaign. */
  readonly campaignId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The name of the campaign. */
  readonly campaignName?: InputMaybe<Scalars['String']>;
  readonly cardId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly creativeId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** Filter by currency. */
  readonly currency?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  /** Get statistics from date (ex: "2018-01-31"). */
  readonly dateFrom?: InputMaybe<Scalars['String']>;
  /** Get statistics to date (ex: "2018-12-31"). */
  readonly dateTo?: InputMaybe<Scalars['String']>;
  /** From date in UTC format. */
  readonly dateUtcFrom?: InputMaybe<Scalars['String']>;
  /** To date in UTC format. */
  readonly dateUtcTo?: InputMaybe<Scalars['String']>;
  /** The external sponsored account id. */
  readonly externalAdAccountId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The external sponsored account name.\ You can search external account name using LIKE(**\***) prefix/suffix -> ex: "\*Acco\*" */
  readonly externalAdAccountName?: InputMaybe<Scalars['String']>;
  /** The external advertiser id. */
  readonly externalAdvertiserId?: InputMaybe<Scalars['ID']>;
  /** The external advertiser name.\ You can search advertiser name using LIKE(**\***) prefix/suffix -> ex: "\*Adverti\*" */
  readonly externalAdvertiserName?: InputMaybe<Scalars['String']>;
  /** The id of the group. */
  readonly groupId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The name of the group. */
  readonly groupName?: InputMaybe<Scalars['String']>;
  readonly mediaId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** Define which metrics will be returned under metrics field in response. */
  readonly metrics?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly parentCardId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** The id of the campaign project. */
  readonly projectId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  /** Filter using SQL.\ \ Possible operators: =, !=, <, <=, >, >=, LIKE, NOT LIKE, IN, NOT IN */
  readonly query?: InputMaybe<Scalars['String']>;
  readonly textId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

/** Twitter statistics */
export type TwStats = {
  readonly __typename?: 'twStats';
  /** (GROUP BY) The account id of the campaign */
  readonly adAccountId?: Maybe<Scalars['MixedType']>;
  readonly adAccountInternalId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The account name */
  readonly adAccountName?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the ad */
  readonly adId?: Maybe<Scalars['MixedType']>;
  readonly adName?: Maybe<Scalars['MixedType']>;
  readonly adRank?: Maybe<Scalars['MixedType']>;
  /** Average revenue per user (AppsFlyer) */
  readonly afArpu?: Maybe<Scalars['MixedType']>;
  /** Average revenue per user in EUR (AppsFlyer) */
  readonly afArpuEur?: Maybe<Scalars['MixedType']>;
  /** Average revenue per user in USD (AppsFlyer) */
  readonly afArpuUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per app install (AppsFlyer) */
  readonly afCpi?: Maybe<Scalars['MixedType']>;
  /** Cost per app install in EUR (AppsFlyer) */
  readonly afCpiEur?: Maybe<Scalars['MixedType']>;
  /** Cost per app install in USD (AppsFlyer) */
  readonly afCpiUsd?: Maybe<Scalars['MixedType']>;
  /** Installs (AppsFlyer) */
  readonly afInstalls?: Maybe<Scalars['MixedType']>;
  /** Loyal users (AppsFlyer) */
  readonly afLoyalUsers?: Maybe<Scalars['MixedType']>;
  /** Revenue (AppsFlyer) */
  readonly afRevenue?: Maybe<Scalars['MixedType']>;
  /** Revenue in EUR (AppsFlyer) */
  readonly afRevenueEur?: Maybe<Scalars['MixedType']>;
  /** Revenue in USD (AppsFlyer) */
  readonly afRevenueUsd?: Maybe<Scalars['MixedType']>;
  /** Return on advertising spend (AppsFlyer) */
  readonly afRoas?: Maybe<Scalars['MixedType']>;
  /** Return on investment (AppsFlyer) */
  readonly afRoi?: Maybe<Scalars['MixedType']>;
  /** Sessions (AppsFlyer) */
  readonly afSessions?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Stats segmented by age */
  readonly age?: Maybe<Scalars['MixedType']>;
  /** Cohort gross revenue (Adjust) */
  readonly ajCohortGrossRevenue?: Maybe<Scalars['MixedType']>;
  /** Cohort gross revenue in EUR (Adjust) */
  readonly ajCohortGrossRevenueEur?: Maybe<Scalars['MixedType']>;
  /** Cohort gross revenue in USD (Adjust) */
  readonly ajCohortGrossRevenueUsd?: Maybe<Scalars['MixedType']>;
  /** Cohort revenue (Adjust) */
  readonly ajCohortRevenue?: Maybe<Scalars['MixedType']>;
  /** Cohort revenue in EUR (Adjust) */
  readonly ajCohortRevenueEur?: Maybe<Scalars['MixedType']>;
  /** Cohort revenue in USD (Adjust) */
  readonly ajCohortRevenueUsd?: Maybe<Scalars['MixedType']>;
  /** Cohort return on advertising spend (Adjust) */
  readonly ajCohortRoas?: Maybe<Scalars['MixedType']>;
  /** Cohort return on investment (Adjust) */
  readonly ajCohortRoi?: Maybe<Scalars['MixedType']>;
  /** Cost per app install (Adjust) */
  readonly ajCpi?: Maybe<Scalars['MixedType']>;
  /** Cost per app install in EUR (Adjust) */
  readonly ajCpiEur?: Maybe<Scalars['MixedType']>;
  /** Cost per app install in USD (Adjust) */
  readonly ajCpiUsd?: Maybe<Scalars['MixedType']>;
  /** Deattributions (Adjust) */
  readonly ajDeattributions?: Maybe<Scalars['MixedType']>;
  /** Installs (Adjust) */
  readonly ajInstalls?: Maybe<Scalars['MixedType']>;
  /** Reattribution reinstalls (Adjust) */
  readonly ajReattributionReinstalls?: Maybe<Scalars['MixedType']>;
  /** Reattributions (Adjust) */
  readonly ajReattributions?: Maybe<Scalars['MixedType']>;
  /** Reinstalls (Adjust) */
  readonly ajReinstalls?: Maybe<Scalars['MixedType']>;
  /** Revenue (Adjust) */
  readonly ajRevenue?: Maybe<Scalars['MixedType']>;
  /** Revenue in EUR (Adjust) */
  readonly ajRevenueEur?: Maybe<Scalars['MixedType']>;
  /** Revenue events (Adjust) */
  readonly ajRevenueEvents?: Maybe<Scalars['MixedType']>;
  /** Revenue in USD (Adjust) */
  readonly ajRevenueUsd?: Maybe<Scalars['MixedType']>;
  /** Return on advertising spend (Adjust) */
  readonly ajRoas?: Maybe<Scalars['MixedType']>;
  /** Return on investment (Adjust) */
  readonly ajRoi?: Maybe<Scalars['MixedType']>;
  /** Sessions (Adjust) */
  readonly ajSessions?: Maybe<Scalars['MixedType']>;
  /** Uninstall cohort (Adjust) */
  readonly ajUninstallCohort?: Maybe<Scalars['MixedType']>;
  /** Uninstalls (Adjust) */
  readonly ajUninstalls?: Maybe<Scalars['MixedType']>;
  /** Total spend */
  readonly amount?: Maybe<Scalars['MixedType']>;
  /** App click rate\ app clicks/impressions */
  readonly appClickRate?: Maybe<Scalars['MixedType']>;
  /** Number of app install or app open attempts */
  readonly appClicks?: Maybe<Scalars['MixedType']>;
  /** App install rate\ app installs/impressions */
  readonly appInstallRate?: Maybe<Scalars['MixedType']>;
  /** total number of app installs */
  readonly appInstalls?: Maybe<Scalars['MixedType']>;
  /** Average bid weighted by impressions */
  readonly averageWeightedBid?: Maybe<Scalars['MixedType']>;
  /** Number of groups for average weighted bid */
  readonly averageWeightedBidGroupCount?: Maybe<Scalars['MixedType']>;
  /** Average maximum bid weighted by impressions */
  readonly averageWeightedMaxBid?: Maybe<Scalars['MixedType']>;
  /** Total number of billed engagements */
  readonly billedEngagements?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the campaign */
  readonly campaignId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The name of the campaign */
  readonly campaignName?: Maybe<Scalars['MixedType']>;
  /** Total number of card engagements */
  readonly cardEngagements?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the card */
  readonly cardId?: Maybe<Scalars['MixedType']>;
  /** Click rate */
  readonly clickRate?: Maybe<Scalars['MixedType']>;
  /** Total number of clicks, including favorites and other engagements */
  readonly clicks?: Maybe<Scalars['MixedType']>;
  /** Number of conversions of type CUSTOM */
  readonly conversionCustom?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type CUSTOM by assisted */
  readonly conversionCustomAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type CUSTOM by order_quantity */
  readonly conversionCustomOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type CUSTOM by post_engagement */
  readonly conversionCustomPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type CUSTOM by post_view */
  readonly conversionCustomPostView?: Maybe<Scalars['MixedType']>;
  /** Conversion custom rate */
  readonly conversionCustomRate?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type CUSTOM by sale_amount */
  readonly conversionCustomSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Conversion Download rate */
  readonly conversionDownloadRate?: Maybe<Scalars['MixedType']>;
  /** Number of conversions of type DOWNLOAD */
  readonly conversionDownloads?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type DOWNLOAD by assisted */
  readonly conversionDownloadsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type DOWNLOAD by order_quantity */
  readonly conversionDownloadsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type DOWNLOAD by post_engagement */
  readonly conversionDownloadsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type DOWNLOAD by post_view */
  readonly conversionDownloadsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type DOWNLOAD by sale_amount */
  readonly conversionDownloadsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Conversion purchase rate */
  readonly conversionPurchaseRate?: Maybe<Scalars['MixedType']>;
  /** Number of conversions of type PURCHASE */
  readonly conversionPurchases?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type PURCHASE by assisted */
  readonly conversionPurchasesAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type PURCHASE by order_quantity */
  readonly conversionPurchasesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type PURCHASE by post_engagement */
  readonly conversionPurchasesPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type PURCHASE by post_view */
  readonly conversionPurchasesPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type PURCHASE by sale_amount */
  readonly conversionPurchasesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type PURCHASE by sale_amount in EUR */
  readonly conversionPurchasesSaleAmountEur?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type PURCHASE by sale_amount in USD */
  readonly conversionPurchasesSaleAmountUsd?: Maybe<Scalars['MixedType']>;
  /** Conversion rate\ conversions/impressions */
  readonly conversionRate?: Maybe<Scalars['MixedType']>;
  /** Conversion Sign up rate */
  readonly conversionSignUpRate?: Maybe<Scalars['MixedType']>;
  /** Number of conversions of type SIGN_UP */
  readonly conversionSignUps?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SIGN_UP by assisted */
  readonly conversionSignUpsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SIGN_UP by order_quantity */
  readonly conversionSignUpsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SIGN_UP by post_engagement */
  readonly conversionSignUpsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SIGN_UP by post_view */
  readonly conversionSignUpsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SIGN_UP by sale_amount */
  readonly conversionSignUpsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Conversion site visit rate */
  readonly conversionSiteVisitRate?: Maybe<Scalars['MixedType']>;
  /** Number of conversions of type SITE_VISIT */
  readonly conversionSiteVisits?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SITE_VISIT by assisted */
  readonly conversionSiteVisitsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SITE_VISIT by order_quantity */
  readonly conversionSiteVisitsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SITE_VISIT by post_engagement */
  readonly conversionSiteVisitsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SITE_VISIT by post_view */
  readonly conversionSiteVisitsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of conversions of type SITE_VISIT by sale_amount */
  readonly conversionSiteVisitsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Total number of conversions */
  readonly conversions?: Maybe<Scalars['MixedType']>;
  /** Cost per lifetime value of type PURCHASE */
  readonly costLifetimeValuePurchase?: Maybe<Scalars['MixedType']>;
  /** Cost per lifetime conversion of type PURCHASE in EUR */
  readonly costLifetimeValuePurchaseEur?: Maybe<Scalars['MixedType']>;
  /** Cost per lifetime value of type PURCHASE in USD */
  readonly costLifetimeValuePurchaseUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per lifetime value of type SIGN_UP */
  readonly costLifetimeValueSignUp?: Maybe<Scalars['MixedType']>;
  /** Cost per lifetime conversion of type SIGN_UP in EUR */
  readonly costLifetimeValueSignUpEur?: Maybe<Scalars['MixedType']>;
  /** Cost per lifetime value of type SIGN_UP in USD */
  readonly costLifetimeValueSignUpUsd?: Maybe<Scalars['MixedType']>;
  readonly costPerAchievementUnlocked?: Maybe<Scalars['MixedType']>;
  readonly costPerAchievementUnlockedPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type CUSTOM */
  readonly costPerConversionCustom?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type CUSTOM in EUR */
  readonly costPerConversionCustomEur?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type CUSTOM in USD */
  readonly costPerConversionCustomUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type DOWNLOAD */
  readonly costPerConversionDownload?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type DOWNLOAD in EUR */
  readonly costPerConversionDownloadEur?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type DOWNLOAD in USD */
  readonly costPerConversionDownloadUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type PURCHASE */
  readonly costPerConversionPurchase?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type PURCHASE in EUR */
  readonly costPerConversionPurchaseEur?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type PURCHASE in USD */
  readonly costPerConversionPurchaseUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type SIGN_UP */
  readonly costPerConversionSignUp?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type SIGN_UP in EUR */
  readonly costPerConversionSignUpEur?: Maybe<Scalars['MixedType']>;
  readonly costPerConversionSignUpPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type SIGN_UP in USD */
  readonly costPerConversionSignUpUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type SITE_VISIT */
  readonly costPerConversionSiteVisit?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type SITE_VISIT in EUR */
  readonly costPerConversionSiteVisitEur?: Maybe<Scalars['MixedType']>;
  /** Cost per conversion of type SITE_VISIT in USD */
  readonly costPerConversionSiteVisitUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per lead */
  readonly costPerLead?: Maybe<Scalars['MixedType']>;
  /** Cost per mobile conversion of type PURCHASE */
  readonly costPerMobileConversionPurchase?: Maybe<Scalars['MixedType']>;
  /** Stats associated with objective\ if objective is APP_INSTALLS then costPerResult is cpai, if objective is APP_ENGAGEMENTS then costPerResult is cpac, if objective is FOLLOWERS then costPerResult is cpf,... */
  readonly costPerResult?: Maybe<Scalars['MixedType']>;
  /** Stats associated with objective\ if objective is APP_INSTALLS then costPerResultEur is cpai, if objective is APP_ENGAGEMENTS then costPerResultEur is cpac, if objective is FOLLOWERS then costPerResultEur is cpf,...\ Value in EUR currency */
  readonly costPerResultEur?: Maybe<Scalars['MixedType']>;
  /** Stats associated with objective\ if objective is APP_INSTALLS then costPerResultUsd is cpai, if objective is APP_ENGAGEMENTS then costPerResultUsd is cpac, if objective is FOLLOWERS then costPerResultUsd is cpf,...\ Value in USD currency */
  readonly costPerResultUsd?: Maybe<Scalars['MixedType']>;
  readonly costPerTutorialCompleted?: Maybe<Scalars['MixedType']>;
  /** Cost per views where at least 3 seconds were played while 100% in view */
  readonly costPerVideo3s100pctView?: Maybe<Scalars['MixedType']>;
  /** Cost per views where at least 3 seconds were played while 100% in view in EUR */
  readonly costPerVideo3s100pctViewEur?: Maybe<Scalars['MixedType']>;
  /** Cost per views where at least 3 seconds were played while 100% in view in USD */
  readonly costPerVideo3s100pctViewUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per view */
  readonly costPerView?: Maybe<Scalars['MixedType']>;
  /** Cost per view in EUR */
  readonly costPerViewEur?: Maybe<Scalars['MixedType']>;
  /** Cost per view in USD */
  readonly costPerViewUsd?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Stats segmented by country */
  readonly country?: Maybe<Scalars['MixedType']>;
  readonly countryCode?: Maybe<Scalars['MixedType']>;
  /** Cost per app click */
  readonly cpac?: Maybe<Scalars['MixedType']>;
  /** Cost per app click in EUR */
  readonly cpacEur?: Maybe<Scalars['MixedType']>;
  /** Cost per app click in USD */
  readonly cpacUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per app install */
  readonly cpai?: Maybe<Scalars['MixedType']>;
  /** Cost per app install in EUR */
  readonly cpaiEur?: Maybe<Scalars['MixedType']>;
  /** Cost per app install in USD */
  readonly cpaiUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per engagements */
  readonly cpe?: Maybe<Scalars['MixedType']>;
  /** Cost per engagement in EUR */
  readonly cpeEur?: Maybe<Scalars['MixedType']>;
  /** Cost per engagement in USD */
  readonly cpeUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per follow */
  readonly cpf?: Maybe<Scalars['MixedType']>;
  /** Cost per follow in EUR */
  readonly cpfEur?: Maybe<Scalars['MixedType']>;
  /** Cost per follow in USD */
  readonly cpfUsd?: Maybe<Scalars['MixedType']>;
  /** Cost per like */
  readonly cpl?: Maybe<Scalars['MixedType']>;
  /** Cost per like in EUR */
  readonly cplEur?: Maybe<Scalars['MixedType']>;
  /** Cost per like in USD */
  readonly cplUsd?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the creative */
  readonly creativeId?: Maybe<Scalars['MixedType']>;
  /** Click trough rate */
  readonly ctr?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Currency */
  readonly currency?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Statistics date */
  readonly date?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) UTC date */
  readonly dateUtc?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the combined creative(derived by parentCardId and textId) */
  readonly derivedCreativeId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Stats segmented by device */
  readonly device?: Maybe<Scalars['MixedType']>;
  /** Effective cost per  */
  readonly ecpa?: Maybe<Scalars['MixedType']>;
  /** Effective cost per click */
  readonly ecpc?: Maybe<Scalars['MixedType']>;
  /** Effective cost click in EUR */
  readonly ecpcEur?: Maybe<Scalars['MixedType']>;
  /** Effective cost click in USD */
  readonly ecpcUsd?: Maybe<Scalars['MixedType']>;
  /** Effective cost per link click */
  readonly ecplc?: Maybe<Scalars['MixedType']>;
  /** Effective cost link click in EUR */
  readonly ecplcEur?: Maybe<Scalars['MixedType']>;
  /** Effective cost link click in USD */
  readonly ecplcUsd?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand impressions */
  readonly ecpm?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand impressions in EUR */
  readonly ecpmEur?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand impressions in USD */
  readonly ecpmUsd?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand qualified impressions */
  readonly ecpmq?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand qualified impressions in EUR */
  readonly ecpmqEur?: Maybe<Scalars['MixedType']>;
  /** Effective cost per thousand qualified impressions in USD */
  readonly ecpmqUsd?: Maybe<Scalars['MixedType']>;
  /** Engagement rate\ engagements/impressions */
  readonly engagementRate?: Maybe<Scalars['MixedType']>;
  /** Number of engagements */
  readonly engagements?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external account id of the campaign */
  readonly externalAdAccountId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external account name */
  readonly externalAdAccountName?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external ad id */
  readonly externalAdId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external campaign id */
  readonly externalCampaignId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external card id */
  readonly externalCardId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external creative id */
  readonly externalCreativeId?: Maybe<Scalars['MixedType']>;
  /** The funding instrument ability. */
  readonly externalFundingAbleToFund?: Maybe<Scalars['MixedType']>;
  /** The total credit available against this funding instrument. Is only valid for CREDIT_CARD or CREDIT_LINE type funding instruments and represents the credit limit for that instrument. */
  readonly externalFundingCreditLimit?: Maybe<Scalars['MixedType']>;
  /** The funding instrument credit remaining. Is valid for CREDIT_LINE and AGENCY_CREDIT_LINE type funding instruments. It represents the externalFundingCreditLimit minus the amount already spent on that funding instrument. It does not represent the difference between externalFundingFundedAmount and the amount spent. Twitter draws a distinction between the credit limit and the funded amount because they represent different underlying funding methods and spending agreements they have with advertisers. */
  readonly externalFundingCreditRemaining?: Maybe<Scalars['MixedType']>;
  /** The funding instrument currency. */
  readonly externalFundingCurrency?: Maybe<Scalars['MixedType']>;
  /** The date for the funding instrument to become active and usable. */
  readonly externalFundingDateFrom?: Maybe<Scalars['MixedType']>;
  /** The date for the funding instrument to become inactive. */
  readonly externalFundingDateTo?: Maybe<Scalars['MixedType']>;
  /** The funding instrument description. */
  readonly externalFundingDescription?: Maybe<Scalars['MixedType']>;
  /** The total budget amount allocated to this funding instrument. Is only valid for INSERTION_ORDER type funding instruments and represents the allocated budget. */
  readonly externalFundingFundedAmount?: Maybe<Scalars['MixedType']>;
  /** The funding instrument ID. */
  readonly externalFundingId?: Maybe<Scalars['MixedType']>;
  /** The funding instrument insertion order header ID. May be associated with multiple funding instruments. */
  readonly externalFundingIoHeader?: Maybe<Scalars['MixedType']>;
  /** The reasons, why not able to fund.\ \ _________________________________________________________________________\ \ Special fields */
  readonly externalFundingReasonsNotAbleToFund?: Maybe<Scalars['MixedType']>;
  /** The funding instrument status. */
  readonly externalFundingStatus?: Maybe<Scalars['MixedType']>;
  /** The type of funding instrument (AGENCY_CREDIT_LINE, CREDIT_CARD, CREDIT_LINE, INSERTION_ORDER, PARTNER_MANAGED). */
  readonly externalFundingType?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The external group id */
  readonly externalGroupId?: Maybe<Scalars['MixedType']>;
  /** Follow rate\ follows/impressions */
  readonly followRate?: Maybe<Scalars['MixedType']>;
  /** Total number of followers */
  readonly followers?: Maybe<Scalars['MixedType']>;
  /** Total number of follows */
  readonly follows?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Stats segmented by gender */
  readonly gender?: Maybe<Scalars['MixedType']>;
  readonly ggAvgOrderValue?: Maybe<Scalars['MixedType']>;
  readonly ggAvgOrderValueEur?: Maybe<Scalars['MixedType']>;
  readonly ggAvgOrderValueUsd?: Maybe<Scalars['MixedType']>;
  readonly ggAvgSessionDurationSec?: Maybe<Scalars['MixedType']>;
  readonly ggBounceRate?: Maybe<Scalars['MixedType']>;
  readonly ggBounces?: Maybe<Scalars['MixedType']>;
  readonly ggEcommerceConversionRate?: Maybe<Scalars['MixedType']>;
  readonly ggGoal1Completions?: Maybe<Scalars['MixedType']>;
  readonly ggGoal1ConversionRate?: Maybe<Scalars['MixedType']>;
  readonly ggGoal1Value?: Maybe<Scalars['MixedType']>;
  readonly ggGoal1ValueEur?: Maybe<Scalars['MixedType']>;
  readonly ggGoal1ValueUsd?: Maybe<Scalars['MixedType']>;
  readonly ggGoal2Completions?: Maybe<Scalars['MixedType']>;
  readonly ggGoal2ConversionRate?: Maybe<Scalars['MixedType']>;
  readonly ggGoal2Value?: Maybe<Scalars['MixedType']>;
  readonly ggGoal2ValueEur?: Maybe<Scalars['MixedType']>;
  readonly ggGoal2ValueUsd?: Maybe<Scalars['MixedType']>;
  readonly ggRevenue?: Maybe<Scalars['MixedType']>;
  readonly ggRevenueEur?: Maybe<Scalars['MixedType']>;
  readonly ggRevenueUsd?: Maybe<Scalars['MixedType']>;
  readonly ggSessions?: Maybe<Scalars['MixedType']>;
  readonly ggTransactions?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the group */
  readonly groupId?: Maybe<Scalars['MixedType']>;
  readonly groupName?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Statistics hour */
  readonly hour?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) UTC hour */
  readonly hourUtc?: Maybe<Scalars['MixedType']>;
  /** Total number of impressions */
  readonly impressions?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Stats segmented by language */
  readonly language?: Maybe<Scalars['MixedType']>;
  /** Lead rate\ leads/impressions */
  readonly leadRate?: Maybe<Scalars['MixedType']>;
  /** Total number of leads */
  readonly leads?: Maybe<Scalars['MixedType']>;
  /** Total number of likes */
  readonly likes?: Maybe<Scalars['MixedType']>;
  readonly linkClicks?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) */
  readonly localDate?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) */
  readonly localHour?: Maybe<Scalars['MixedType']>;
  readonly logins?: Maybe<Scalars['MixedType']>;
  /** Total number of clicks of media across Videos, Vines, GIFs, and Images. */
  readonly mediaEngagements?: Maybe<Scalars['MixedType']>;
  readonly mediaId?: Maybe<Scalars['MixedType']>;
  /** media view rate\ media views/impressions */
  readonly mediaViewRate?: Maybe<Scalars['MixedType']>;
  /** Total number of views (autoplay and click) of media across Videos, Vines, GIFs, and Images. */
  readonly mediaViews?: Maybe<Scalars['MixedType']>;
  /** This field is only for raw generic response (in combination with values). You have to defined metrics in filter. */
  readonly metrics?: Maybe<Scalars['MixedType']>;
  readonly mobileAppInstalls?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type ACHIEVEMENT_UNLOCKED */
  readonly mobileConversionAchievementsUnlocked?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ACHIEVEMENT_UNLOCKED by assisted */
  readonly mobileConversionAchievementsUnlockedAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ACHIEVEMENT_UNLOCKED by order_quantity */
  readonly mobileConversionAchievementsUnlockedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ACHIEVEMENT_UNLOCKED by post_engagement */
  readonly mobileConversionAchievementsUnlockedPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ACHIEVEMENT_UNLOCKED by post_view */
  readonly mobileConversionAchievementsUnlockedPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ACHIEVEMENT_UNLOCKED by sale_amount */
  readonly mobileConversionAchievementsUnlockedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type ADD_TO_CART */
  readonly mobileConversionAddToCarts?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_CART by assisted */
  readonly mobileConversionAddToCartsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_CART by order_quantity */
  readonly mobileConversionAddToCartsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_CART by post_engagement */
  readonly mobileConversionAddToCartsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_CART by post_view */
  readonly mobileConversionAddToCartsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_CART by sale_amount */
  readonly mobileConversionAddToCartsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type ADD_TO_WISHLIST */
  readonly mobileConversionAddToWishlists?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_WISHLIST by assisted */
  readonly mobileConversionAddToWishlistsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_WISHLIST by order_quantity */
  readonly mobileConversionAddToWishlistsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_WISHLIST by post_engagement */
  readonly mobileConversionAddToWishlistsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_WISHLIST by post_view */
  readonly mobileConversionAddToWishlistsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_WISHLIST by sale_amount */
  readonly mobileConversionAddToWishlistsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type CHECKOUT_INITIATED */
  readonly mobileConversionCheckoutsInitiated?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CHECKOUT_INITIATED by assisted */
  readonly mobileConversionCheckoutsInitiatedAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CHECKOUT_INITIATED by order_quantity */
  readonly mobileConversionCheckoutsInitiatedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CHECKOUT_INITIATED by post_engagement */
  readonly mobileConversionCheckoutsInitiatedPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CHECKOUT_INITIATED by post_view */
  readonly mobileConversionCheckoutsInitiatedPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CHECKOUT_INITIATED by sale_amount */
  readonly mobileConversionCheckoutsInitiatedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type CONTENT_VIEW */
  readonly mobileConversionContentViews?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CONTENT_VIEW by assisted */
  readonly mobileConversionContentViewsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CONTENT_VIEW by order_quantity */
  readonly mobileConversionContentViewsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CONTENT_VIEW by post_engagement */
  readonly mobileConversionContentViewsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CONTENT_VIEW by post_view */
  readonly mobileConversionContentViewsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CONTENT_VIEW by sale_amount */
  readonly mobileConversionContentViewsSaleAmount?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionDownloadsOrderQuantity?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionDownloadsPostEngagement?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionDownloadsPostView?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionDownloadsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type INSTALL */
  readonly mobileConversionInstalls?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INSTALL by assisted */
  readonly mobileConversionInstallsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INSTALL by order_quantity */
  readonly mobileConversionInstallsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INSTALL by post_engagement */
  readonly mobileConversionInstallsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INSTALL by post_view */
  readonly mobileConversionInstallsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INSTALL by sale_amount */
  readonly mobileConversionInstallsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type INVITE */
  readonly mobileConversionInvites?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INVITE by assisted */
  readonly mobileConversionInvitesAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INVITE by order_quantity */
  readonly mobileConversionInvitesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INVITE by post_engagement */
  readonly mobileConversionInvitesPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INVITE by post_view */
  readonly mobileConversionInvitesPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INVITE by sale_amount */
  readonly mobileConversionInvitesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type KEY_PAGE_VIEW */
  readonly mobileConversionKeyPageViews?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type KEY_PAGE_VIEW by assisted */
  readonly mobileConversionKeyPageViewsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type KEY_PAGE_VIEW by order_quantity */
  readonly mobileConversionKeyPageViewsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type KEY_PAGE_VIEW by post_engagement */
  readonly mobileConversionKeyPageViewsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type KEY_PAGE_VIEW by post_view */
  readonly mobileConversionKeyPageViewsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type KEY_PAGE_VIEW by sale_amount */
  readonly mobileConversionKeyPageViewsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mmobile conversions of type LEVEL_ACHIEVED */
  readonly mobileConversionLevelsAchieved?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LEVEL_ACHIEVED by assisted */
  readonly mobileConversionLevelsAchievedAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LEVEL_ACHIEVED by order_quantity */
  readonly mobileConversionLevelsAchievedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LEVEL_ACHIEVED by post_engagement */
  readonly mobileConversionLevelsAchievedPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LEVEL_ACHIEVED by post_view */
  readonly mobileConversionLevelsAchievedPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LEVEL_ACHIEVED by sale_amount */
  readonly mobileConversionLevelsAchievedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type ACHIEVEMENT_UNLOCKED */
  readonly mobileConversionLifetimeValueAchievementsUnlocked?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ACHIEVEMENT_UNLOCKED by order_quantity */
  readonly mobileConversionLifetimeValueAchievementsUnlockedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ACHIEVEMENT_UNLOCKED by sale_amount */
  readonly mobileConversionLifetimeValueAchievementsUnlockedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type ADD_TO_CART */
  readonly mobileConversionLifetimeValueAddToCarts?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_CART by order_quantity */
  readonly mobileConversionLifetimeValueAddToCartsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_CART by sale_amount */
  readonly mobileConversionLifetimeValueAddToCartsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type ADD_TO_WISHLIST */
  readonly mobileConversionLifetimeValueAddToWishlists?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_WISHLIST by order_quantity */
  readonly mobileConversionLifetimeValueAddToWishlistsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type ADD_TO_WISHLIST by sale_amount */
  readonly mobileConversionLifetimeValueAddToWishlistsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type CHECKOUT_INITIATED */
  readonly mobileConversionLifetimeValueCheckoutsInitiated?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CHECKOUT_INITIATED by order_quantity */
  readonly mobileConversionLifetimeValueCheckoutsInitiatedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type CHECKOUT_INITIATED by sale_amount */
  readonly mobileConversionLifetimeValueCheckoutsInitiatedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type INVITE */
  readonly mobileConversionLifetimeValueInvites?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INVITE by order_quantity */
  readonly mobileConversionLifetimeValueInvitesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type INVITE by sale_amount */
  readonly mobileConversionLifetimeValueInvitesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type LEVEL_ACHIEVED */
  readonly mobileConversionLifetimeValueLevelsAchieved?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LEVEL_ACHIEVED by order_quantity */
  readonly mobileConversionLifetimeValueLevelsAchievedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LEVEL_ACHIEVED by sale_amount */
  readonly mobileConversionLifetimeValueLevelsAchievedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type PAYMENT_INFO_ADDITION */
  readonly mobileConversionLifetimeValuePaymentInfoAdditions?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PAYMENT_INFO_ADDITION by order_quantity */
  readonly mobileConversionLifetimeValuePaymentInfoAdditionsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PAYMENT_INFO_ADDITION by sale_amount */
  readonly mobileConversionLifetimeValuePaymentInfoAdditionsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type PURCHASE */
  readonly mobileConversionLifetimeValuePurchases?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PURCHASE by order_quantity */
  readonly mobileConversionLifetimeValuePurchasesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PURCHASE by sale_amount */
  readonly mobileConversionLifetimeValuePurchasesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type RATE */
  readonly mobileConversionLifetimeValueRates?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RATE by order_quantity */
  readonly mobileConversionLifetimeValueRatesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RATE by sale_amount */
  readonly mobileConversionLifetimeValueRatesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type RESERVATION */
  readonly mobileConversionLifetimeValueReservations?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RESERVATION by order_quantity */
  readonly mobileConversionLifetimeValueReservationsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RESERVATION by sale_amount */
  readonly mobileConversionLifetimeValueReservationsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type SHARE */
  readonly mobileConversionLifetimeValueShares?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SHARE by order_quantity */
  readonly mobileConversionLifetimeValueSharesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SHARE by sale_amount */
  readonly mobileConversionLifetimeValueSharesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type SIGN_UP */
  readonly mobileConversionLifetimeValueSignUps?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SIGN_UP by order_quantity */
  readonly mobileConversionLifetimeValueSignUpsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SIGN_UP by sale_amount */
  readonly mobileConversionLifetimeValueSignUpsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type SPENT_CREDIT */
  readonly mobileConversionLifetimeValueSpentCredits?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SPENT_CREDIT by order_quantity */
  readonly mobileConversionLifetimeValueSpentCreditsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SPENT_CREDIT by sale_amount */
  readonly mobileConversionLifetimeValueSpentCreditsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type TUTORIAL_COMPLETED */
  readonly mobileConversionLifetimeValueTutorialsCompleted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type TUTORIAL_COMPLETED by order_quantity */
  readonly mobileConversionLifetimeValueTutorialsCompletedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type TUTORIAL_COMPLETED by sale_amount */
  readonly mobileConversionLifetimeValueTutorialsCompletedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type UPDATE */
  readonly mobileConversionLifetimeValueUpdates?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type UPDATE by order_quantity */
  readonly mobileConversionLifetimeValueUpdatesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type UPDATE by sale_amount */
  readonly mobileConversionLifetimeValueUpdatesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type LOGIN */
  readonly mobileConversionLogins?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LOGIN by assisted */
  readonly mobileConversionLoginsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LOGIN by order_quantity */
  readonly mobileConversionLoginsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LOGIN by post_engagement */
  readonly mobileConversionLoginsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LOGIN by post_view */
  readonly mobileConversionLoginsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type LOGIN by sale_amount */
  readonly mobileConversionLoginsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type PAYMENT_INFO_ADDITION */
  readonly mobileConversionPaymentInfoAdditions?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PAYMENT_INFO_ADDITION by assisted */
  readonly mobileConversionPaymentInfoAdditionsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PAYMENT_INFO_ADDITION by order_quantity */
  readonly mobileConversionPaymentInfoAdditionsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PAYMENT_INFO_ADDITION by post_engagement */
  readonly mobileConversionPaymentInfoAdditionsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PAYMENT_INFO_ADDITION by post_view */
  readonly mobileConversionPaymentInfoAdditionsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type PAYMENT_INFO_ADDITION by sale_amount */
  readonly mobileConversionPaymentInfoAdditionsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversion purchase rate */
  readonly mobileConversionPurchaseRate?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type PURCHASES */
  readonly mobileConversionPurchases?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionPurchasesOrderQuantity?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionPurchasesPostEngagement?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionPurchasesPostView?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionPurchasesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type RATE */
  readonly mobileConversionRates?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RATE by assisted */
  readonly mobileConversionRatesAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RATE by order_quantity */
  readonly mobileConversionRatesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RATE by post_engagement */
  readonly mobileConversionRatesPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RATE by post_view */
  readonly mobileConversionRatesPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RATE by sale_amount */
  readonly mobileConversionRatesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type RE_ENGAGE */
  readonly mobileConversionReEngages?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RE_ENGAGE by assisted */
  readonly mobileConversionReEngagesAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RE_ENGAGE by order_quantity */
  readonly mobileConversionReEngagesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RE_ENGAGE by post_engagement */
  readonly mobileConversionReEngagesPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RE_ENGAGE by post_view */
  readonly mobileConversionReEngagesPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RE_ENGAGE by sale_amount */
  readonly mobileConversionReEngagesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type RESERVATION */
  readonly mobileConversionReservations?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RESERVATION by assisted */
  readonly mobileConversionReservationsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RESERVATION by order_quantity */
  readonly mobileConversionReservationsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RESERVATION by post_engagement */
  readonly mobileConversionReservationsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RESERVATION by post_view */
  readonly mobileConversionReservationsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type RESERVATION by sale_amount */
  readonly mobileConversionReservationsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type SEARCH */
  readonly mobileConversionSearches?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SEARCH by assisted */
  readonly mobileConversionSearchesAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SEARCH by order_quantity */
  readonly mobileConversionSearchesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SEARCH by post_engagement */
  readonly mobileConversionSearchesPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SEARCH by post_view */
  readonly mobileConversionSearchesPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SEARCH by sale_amount */
  readonly mobileConversionSearchesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type SHARE */
  readonly mobileConversionShares?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SHARE by assisted */
  readonly mobileConversionSharesAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SHARE by order_quantity */
  readonly mobileConversionSharesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SHARE by post_engagement */
  readonly mobileConversionSharesPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SHARE by post_view */
  readonly mobileConversionSharesPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SHARE by sale_amount */
  readonly mobileConversionSharesSaleAmount?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSignUps?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSignUpsOrderQuantity?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSignUpsPostEngagement?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSignUpsPostView?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSignUpsSaleAmount?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSiteVisitsOrderQuantity?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSiteVisitsPostEngagement?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSiteVisitsPostView?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSiteVisitsSaleAmount?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSkanInstallsPostEngagement?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSkanInstallsPostView?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSkanPurchases?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSkanPurchasesPostEngagement?: Maybe<Scalars['MixedType']>;
  readonly mobileConversionSkanPurchasesPostView?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type SPENT_CREDIT */
  readonly mobileConversionSpentCredits?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SPENT_CREDIT by assisted */
  readonly mobileConversionSpentCreditsAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SPENT_CREDIT by order_quantity */
  readonly mobileConversionSpentCreditsOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SPENT_CREDIT by post_engagement */
  readonly mobileConversionSpentCreditsPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SPENT_CREDIT by post_view */
  readonly mobileConversionSpentCreditsPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type SPENT_CREDIT by sale_amount */
  readonly mobileConversionSpentCreditsSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type TUTORIAL_COMPLETED */
  readonly mobileConversionTutorialsCompleted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type TUTORIAL_COMPLETED by assisted */
  readonly mobileConversionTutorialsCompletedAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type TUTORIAL_COMPLETED by order_quantity */
  readonly mobileConversionTutorialsCompletedOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type TUTORIAL_COMPLETED by post_engagement */
  readonly mobileConversionTutorialsCompletedPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type TUTORIAL_COMPLETED by post_view */
  readonly mobileConversionTutorialsCompletedPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type TUTORIAL_COMPLETED by sale_amount */
  readonly mobileConversionTutorialsCompletedSaleAmount?: Maybe<Scalars['MixedType']>;
  /** Mobile conversions of type UPDATE */
  readonly mobileConversionUpdates?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type UPDATE by assisted */
  readonly mobileConversionUpdatesAssisted?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type UPDATE by order_quantity */
  readonly mobileConversionUpdatesOrderQuantity?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type UPDATE by post_engagement */
  readonly mobileConversionUpdatesPostEngagement?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type UPDATE by post_view */
  readonly mobileConversionUpdatesPostView?: Maybe<Scalars['MixedType']>;
  /** Breakdown of mobile conversions of type UPDATE by sale_amount */
  readonly mobileConversionUpdatesSaleAmount?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Month short name (Jan) */
  readonly monthName?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Month number */
  readonly monthNumber?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the children cards' parent card */
  readonly parentCardId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Stats segmented by placement */
  readonly placement?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) The id of the campaign project */
  readonly projectId?: Maybe<Scalars['MixedType']>;
  /** Total number of qualified impressions */
  readonly qualifiedImpressions?: Maybe<Scalars['MixedType']>;
  /** Total number of replies */
  readonly replies?: Maybe<Scalars['MixedType']>;
  /** Stats associated with objective\ if objective is APP_INSTALLS then resultRate is appInstallRate, if objective is APP_ENGAGEMENTS then resultRate is appClickRate, if objective is FOLLOWERS then resultRate is followRate,... */
  readonly resultRate?: Maybe<Scalars['MixedType']>;
  /** Stats associated with objective\ if objective is APP_INSTALLS then results are appInstalls, if objective is APP_ENGAGEMENTS then results are appClicks, if objective is FOLLOWERS then results are followers,... */
  readonly results?: Maybe<Scalars['MixedType']>;
  /** Total number of retweets */
  readonly retweets?: Maybe<Scalars['MixedType']>;
  /** Return on advertising spend */
  readonly roas?: Maybe<Scalars['MixedType']>;
  /** Return on investment */
  readonly roi?: Maybe<Scalars['MixedType']>;
  readonly skanAppInstalls?: Maybe<Scalars['MixedType']>;
  /** Total spend */
  readonly spend?: Maybe<Scalars['MixedType']>;
  /** Total spend in EUR */
  readonly spendEur?: Maybe<Scalars['MixedType']>;
  /** Total spend in USD */
  readonly spendUsd?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Supplier of the campaign (twitter) */
  readonly supplier?: Maybe<Scalars['MixedType']>;
  readonly textId?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Timezone name */
  readonly timezoneName?: Maybe<Scalars['MixedType']>;
  /** Total number of engagements */
  readonly totalEngagements?: Maybe<Scalars['MixedType']>;
  /** Total number of unfollows */
  readonly unfollows?: Maybe<Scalars['MixedType']>;
  /** Number of clicks on linked URLs */
  readonly urlClicks?: Maybe<Scalars['MixedType']>;
  /** This field is only for raw generic response (in combination with metrics)\ \ _________________________________________________________________________\ \ Twitter metrics */
  readonly values?: Maybe<Scalars['MixedType']>;
  /** Rate of views where at least 3 seconds were played while 100% in view */
  readonly video3s100pctRate?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 3 seconds were played while 100% in view (legacy video_total_views) */
  readonly video3s100pctViews?: Maybe<Scalars['MixedType']>;
  /** Total number of video playback starts */
  readonly videoContentStarts?: Maybe<Scalars['MixedType']>;
  /** Total clicks on the call to action */
  readonly videoCtaClicks?: Maybe<Scalars['MixedType']>;
  /** Total number of views according to Media Rating Council guidelines */
  readonly videoMrcViews?: Maybe<Scalars['MixedType']>;
  /** Video rate\ videos/impressions */
  readonly videoRate?: Maybe<Scalars['MixedType']>;
  /** Total number of video views */
  readonly videoTotalViews?: Maybe<Scalars['MixedType']>;
  /** Total number of video views */
  readonly videoViews?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 25% of the video was viewed. */
  readonly videoViews25?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 50% of the video was viewed. */
  readonly videoViews50?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 75% of the video was viewed. */
  readonly videoViews75?: Maybe<Scalars['MixedType']>;
  /** Total number of views where at least 100% of the video was viewed. */
  readonly videoViews100?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Year */
  readonly year?: Maybe<Scalars['MixedType']>;
  /** (GROUP BY) Year-month (2019-01) */
  readonly yearMonth?: Maybe<Scalars['MixedType']>;
};

export type TwStatsExcludeFilter = {
  /** The name of the ad. */
  readonly adName?: InputMaybe<Scalars['String']>;
  /** The name of the campaign. */
  readonly campaignName?: InputMaybe<Scalars['String']>;
  /** The name of the group. */
  readonly groupName?: InputMaybe<Scalars['String']>;
};

export enum TwStatsGranularityEnum {
  /** Get stats granulated by day */
  Day = 'DAY',
  /** Get stats granulated by hour */
  Hour = 'HOUR',
  /** Get total stats */
  Total = 'TOTAL'
}

export enum TwStatus {
  /** Denotes that the Campaign/Group is fully serving. */
  Active = 'ACTIVE',
  /** Denotes that the Campaign/Group is presently inactive. */
  Archived = 'ARCHIVED',
  /** Denotes that the Campaign/Group has been permanently deleted and cannot be reactivated. */
  Deleted = 'DELETED',
  /** Denotes that the Campaign/Group meets all requirements to be served, but temporarily should not be. */
  Paused = 'PAUSED'
}

export type UploadJsSourceMap = {
  readonly __typename?: 'uploadJSSourceMap';
  readonly created: Scalars['Boolean'];
  readonly errors?: Maybe<Scalars['MixedType']>;
};

export type UploadProfileImage = {
  readonly __typename?: 'uploadProfileImage';
  readonly extension?: Maybe<Scalars['MixedType']>;
  readonly id?: Maybe<Scalars['MixedType']>;
  readonly mimeType?: Maybe<Scalars['MixedType']>;
  readonly size?: Maybe<Scalars['MixedType']>;
};

export type WalletPaymentInstruction = {
  readonly __typename?: 'walletPaymentInstruction';
  readonly content?: Maybe<Scalars['String']>;
};

/** Withdraw (payout) */
export type Withdraw = {
  readonly __typename?: 'withdraw';
  readonly bankId?: Maybe<Scalars['ID']>;
  readonly customerAddress?: Maybe<Scalars['String']>;
  readonly customerCity?: Maybe<Scalars['String']>;
  readonly customerCompanyName?: Maybe<Scalars['String']>;
  readonly customerEmail?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly customerName?: Maybe<Scalars['String']>;
  readonly customerSurname?: Maybe<Scalars['String']>;
  readonly customerTaxNumber?: Maybe<Scalars['String']>;
  readonly externalAdAccountCurrency?: Maybe<Scalars['String']>;
  readonly externalAdAccountName?: Maybe<Scalars['String']>;
  readonly withdrawAmount?: Maybe<Scalars['Float']>;
  readonly withdrawDescription?: Maybe<Scalars['String']>;
  readonly withdrawEntryDate?: Maybe<Scalars['String']>;
  readonly withdrawId?: Maybe<Scalars['ID']>;
  readonly withdrawIncomeTaxBasePercentage?: Maybe<Scalars['Float']>;
  readonly withdrawIncomeTaxPercentage?: Maybe<Scalars['Float']>;
  readonly withdrawIsAutoGenerated?: Maybe<Scalars['Boolean']>;
  readonly withdrawIsSent?: Maybe<Scalars['Boolean']>;
  readonly withdrawReferenceFinal?: Maybe<Scalars['String']>;
  readonly withdrawReferenceNumber?: Maybe<Scalars['Int']>;
  readonly withdrawReferenceNumberUser?: Maybe<Scalars['Int']>;
  readonly withdrawReferenceYear?: Maybe<Scalars['String']>;
  readonly withdrawStatus?: Maybe<Scalars['String']>;
  readonly withdrawStatusTime?: Maybe<Scalars['String']>;
  readonly withdrawTaxPercentage?: Maybe<Scalars['Float']>;
};

export type WithdrawFilter = {
  readonly bankId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerCompanyName?: InputMaybe<Scalars['String']>;
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly customerName?: InputMaybe<Scalars['String']>;
  readonly customerSurname?: InputMaybe<Scalars['String']>;
  readonly withdrawEntryDateFrom?: InputMaybe<Scalars['String']>;
  readonly withdrawEntryDateTo?: InputMaybe<Scalars['String']>;
  readonly withdrawId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly withdrawReferenceNumber?: InputMaybe<Scalars['Int']>;
  readonly withdrawReferenceYear?: InputMaybe<Scalars['Int']>;
  readonly withdrawStatus?: InputMaybe<ReadonlyArray<InputMaybe<DepositStatus>>>;
  readonly withdrawStatusTime?: InputMaybe<Scalars['String']>;
};

export type ZohoAddress = {
  readonly address?: InputMaybe<Scalars['String']>;
  readonly attention?: InputMaybe<Scalars['String']>;
  readonly city?: InputMaybe<Scalars['String']>;
  readonly country?: InputMaybe<Scalars['String']>;
  readonly fax?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly stateCode?: InputMaybe<Scalars['String']>;
  readonly street2?: InputMaybe<Scalars['String']>;
  readonly zip?: InputMaybe<Scalars['String']>;
};

export type ZohoContact = {
  readonly __typename?: 'zohoContact';
  readonly customerId?: Maybe<Scalars['ID']>;
  readonly zohoContactCreatedAt?: Maybe<Scalars['String']>;
  readonly zohoContactDeletedAt?: Maybe<Scalars['String']>;
  readonly zohoContactId?: Maybe<Scalars['ID']>;
  readonly zohoContactImportedAt?: Maybe<Scalars['String']>;
  readonly zohoContactIsConnected?: Maybe<Scalars['Boolean']>;
  readonly zohoContactIsDeleted?: Maybe<Scalars['Boolean']>;
  readonly zohoContactName?: Maybe<Scalars['String']>;
  readonly zohoContactPersons?: Maybe<Scalars['keyValueData']>;
  readonly zohoOrganizationId?: Maybe<Scalars['ID']>;
  readonly zohoTaxId?: Maybe<Scalars['ID']>;
};

export type ZohoContactFilter = {
  readonly customerId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly zohoContactId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly zohoContactIsConnected?: InputMaybe<Scalars['Boolean']>;
  readonly zohoContactIsDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly zohoContactName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type ZohoContactPerson = {
  readonly department?: InputMaybe<Scalars['String']>;
  readonly designation?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly enablePortal?: InputMaybe<Scalars['Boolean']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly isPrimaryContact?: InputMaybe<Scalars['Boolean']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly mobile?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly salutation?: InputMaybe<Scalars['String']>;
  readonly skype?: InputMaybe<Scalars['String']>;
};

export type ZohoCurrency = {
  readonly __typename?: 'zohoCurrency';
  readonly currencyCode?: Maybe<Scalars['String']>;
  readonly currencyName?: Maybe<Scalars['String']>;
  readonly currencySymbol?: Maybe<Scalars['String']>;
  readonly deletedAt?: Maybe<Scalars['String']>;
  readonly importedAt?: Maybe<Scalars['String']>;
  readonly isDeleted?: Maybe<Scalars['Boolean']>;
  readonly zohoCurrencyId?: Maybe<Scalars['String']>;
  readonly zohoOrganizationId?: Maybe<Scalars['String']>;
};

export type ZohoCurrencyFilter = {
  readonly currencyCode?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly currencyName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly currencySymbol?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly zohoCurrencyId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoOrganizationId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type ZohoCustomField = {
  readonly customfieldId?: InputMaybe<Scalars['String']>;
  readonly index?: InputMaybe<Scalars['String']>;
  readonly label?: InputMaybe<Scalars['String']>;
  readonly value: Scalars['String'];
};

export type ZohoDefaultTemplates = {
  readonly creditnoteEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly creditnoteTemplateId?: InputMaybe<Scalars['String']>;
  readonly estimateEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly estimateTemplateId?: InputMaybe<Scalars['String']>;
  readonly invoiceEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly invoiceTemplateId?: InputMaybe<Scalars['String']>;
  readonly paymentthankyouEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly paymentthankyouTemplateId?: InputMaybe<Scalars['String']>;
  readonly purchaseorderEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly purchaseorderTemplateId?: InputMaybe<Scalars['String']>;
  readonly retainerinvoiceEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly retainerinvoicePaymentthankyouEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly retainerinvoicePaymentthankyouTemplateId?: InputMaybe<Scalars['String']>;
  readonly retainerinvoiceTemplateId?: InputMaybe<Scalars['String']>;
  readonly salesorderEmailTemplateId?: InputMaybe<Scalars['String']>;
  readonly salesorderTemplateId?: InputMaybe<Scalars['String']>;
};

export type ZohoDepositData = {
  readonly customFields?: InputMaybe<ReadonlyArray<InputMaybe<ZohoCustomField>>>;
  readonly dueDate?: InputMaybe<Scalars['zohoDate']>;
  readonly exchangeRate?: InputMaybe<Scalars['Float']>;
  readonly salespersonName?: InputMaybe<Scalars['String']>;
};

export type ZohoField = {
  readonly __typename?: 'zohoField';
  readonly zohoFieldDataType?: Maybe<Scalars['String']>;
  readonly zohoFieldEntity?: Maybe<Scalars['String']>;
  readonly zohoFieldId?: Maybe<Scalars['ID']>;
  readonly zohoFieldIndex?: Maybe<Scalars['Int']>;
  readonly zohoFieldIsActive?: Maybe<Scalars['Boolean']>;
  readonly zohoFieldIsCustomField?: Maybe<Scalars['Boolean']>;
  readonly zohoFieldIsMandatory?: Maybe<Scalars['Boolean']>;
  readonly zohoFieldName?: Maybe<Scalars['String']>;
  readonly zohoFieldNameFormatted?: Maybe<Scalars['String']>;
  readonly zohoOrganizationId?: Maybe<Scalars['ID']>;
};

export type ZohoFieldFilter = {
  readonly zohoFieldDataType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoFieldEntity?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoFieldId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly zohoFieldIndex?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly zohoFieldIsActive?: InputMaybe<Scalars['Boolean']>;
  readonly zohoFieldIsCustomField?: InputMaybe<Scalars['Boolean']>;
  readonly zohoFieldIsMandatory?: InputMaybe<Scalars['Boolean']>;
  readonly zohoFieldName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoFieldNameFormatted?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoOrganizationId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export enum ZohoGstTreatment {
  /** GST registered business. */
  BusinessGst = 'business_gst',
  /** GST non-registered business. */
  BusinessNone = 'business_none',
  /** Consumer. */
  Consumer = 'consumer',
  /** Overseas business. */
  Overseas = 'overseas'
}

export type ZohoInputInvoice = {
  readonly amount_applied?: InputMaybe<Scalars['String']>;
  readonly invoice_id?: InputMaybe<Scalars['String']>;
};

export type ZohoInvoice = {
  readonly __typename?: 'zohoInvoice';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly createdTime?: Maybe<Scalars['String']>;
  readonly date?: Maybe<Scalars['String']>;
  readonly deletedAt?: Maybe<Scalars['String']>;
  readonly dueDate?: Maybe<Scalars['String']>;
  readonly invoiceNumber?: Maybe<Scalars['String']>;
  readonly isEmailed?: Maybe<Scalars['Boolean']>;
  readonly payinId?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly zohoInvoiceId?: Maybe<Scalars['String']>;
};

export type ZohoInvoiceFilter = {
  readonly date?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly dueDate?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly invoiceNumber?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly isEmailed?: InputMaybe<Scalars['Boolean']>;
  readonly payinId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoInvoiceId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type ZohoItemTaxPreferences = {
  readonly taxId?: InputMaybe<Scalars['Int']>;
  readonly taxSpecification?: InputMaybe<Scalars['String']>;
};

export enum ZohoLanguageCode {
  /** German */
  De = 'de',
  /** English */
  En = 'en',
  /** English (United Kingdom) */
  EnGn = 'en_gn',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr',
  /** Italian */
  It = 'it',
  /** Japanese */
  Ja = 'ja',
  /** Dutch */
  Nl = 'nl',
  /** Portuguese */
  Pt = 'pt',
  /** Brazilian Portuguese */
  PtBr = 'pt_br',
  /** Swedish */
  Sv = 'sv',
  /** Chinese */
  Zh = 'zh'
}

export type ZohoLineItem = {
  /** The description of the line items. Maximum length: 2000. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** Discount applied to the invoice. It can be either in % or in amount. e.g. 12.5% or 190. Maximum length: 100 */
  readonly discount?: InputMaybe<Scalars['String']>;
  /** Unique ID of the expenses associated. */
  readonly expenseId?: InputMaybe<Scalars['String']>;
  /** India Edition only. Add HSN/SAC code for your goods/services */
  readonly hsnOrSac?: InputMaybe<Scalars['String']>;
  /** Unique item id. */
  readonly itemId: Scalars['String'];
  /** The order of the line. */
  readonly itemOrder?: InputMaybe<Scalars['Int']>;
  /** The total amount of the line items. */
  readonly itemTotal?: InputMaybe<Scalars['String']>;
  /** The name of the line item. Maximum length: 100. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Enter goods/services. */
  readonly productType?: InputMaybe<ZohoProductType>;
  /** Unique ID of the project associated to an invoice. */
  readonly projectId?: InputMaybe<Scalars['String']>;
  /** The quantity of the line item. */
  readonly quantity: Scalars['String'];
  /** Rate of the line item. */
  readonly rate: Scalars['String'];
  /** India, US and CA edition only. ID of the tax exemption. */
  readonly taxExemptionId?: InputMaybe<Scalars['String']>;
  /** ID of the tax or tax group applied to the estimate. */
  readonly taxId?: InputMaybe<Scalars['String']>;
  /** The name of the tax. */
  readonly taxName?: InputMaybe<Scalars['String']>;
  /** The percentage of tax levied. */
  readonly taxPercentage?: InputMaybe<Scalars['String']>;
  /** The type of the tax. */
  readonly taxType?: InputMaybe<Scalars['String']>;
  /** Unit of the line item e.g. kgs, Nos. Maximum length: 100 */
  readonly unit?: InputMaybe<Scalars['String']>;
};

export type ZohoOrganization = {
  readonly __typename?: 'zohoOrganization';
  readonly countryCode?: Maybe<Scalars['String']>;
  readonly currencyId?: Maybe<Scalars['String']>;
  readonly deletedAt?: Maybe<Scalars['String']>;
  readonly domain?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly externalAdvertiserId?: Maybe<Scalars['String']>;
  readonly importedAt?: Maybe<Scalars['String']>;
  readonly isDeleted?: Maybe<Scalars['String']>;
  readonly isGstIndiaVersion?: Maybe<Scalars['Boolean']>;
  readonly isRegisteredForGst?: Maybe<Scalars['Boolean']>;
  readonly isRegisteredForTax?: Maybe<Scalars['Boolean']>;
  readonly isTaxRegistered?: Maybe<Scalars['Boolean']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly zohoOrganizationId?: Maybe<Scalars['String']>;
};

export type ZohoOrganizationFilter = {
  readonly domain?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly externalAdvertiserId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly isDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly isGstIndiaVersion?: InputMaybe<Scalars['Boolean']>;
  readonly isRegisteredForGst?: InputMaybe<Scalars['Boolean']>;
  readonly isRegisteredForTax?: InputMaybe<Scalars['Boolean']>;
  readonly isTaxRegistered?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoOrganizationId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type ZohoPaymentGateway = {
  /** Paypal payment method. Allowed Values: standard and adaptive. */
  readonly additional_field1?: InputMaybe<Scalars['String']>;
  /** Boolean check to see if a payment gateway has been configured. */
  readonly configured?: InputMaybe<Scalars['Boolean']>;
  /** Name of the payment gateway associated with the invoice. E.g. paypal, stripe. Allowed Values: paypal, authorize_net, payflow_pro, stripe, 2checkout and braintree. */
  readonly gatewayName?: InputMaybe<Scalars['String']>;
};

export enum ZohoPaymentMode {
  Autotransaction = 'autotransaction',
  Bankremittance = 'bankremittance',
  Banktransfer = 'banktransfer',
  Cash = 'cash',
  Check = 'check',
  Creditcard = 'creditcard',
  Others = 'others'
}

export type ZohoPaymentOptions = {
  /** Payment gateways integrated and supported. */
  readonly paymentGateways?: InputMaybe<ReadonlyArray<InputMaybe<ZohoPaymentGateway>>>;
};

export enum ZohoProductType {
  Goods = 'goods',
  Service = 'service'
}

export type ZohoQuickCreatePayment = {
  readonly accountId: Scalars['String'];
  readonly paymentMode: Scalars['String'];
};

export type ZohoTag = {
  readonly tag_id?: InputMaybe<Scalars['String']>;
  readonly tag_option_id?: InputMaybe<Scalars['String']>;
};

export type ZohoTax = {
  readonly __typename?: 'zohoTax';
  readonly isDefault?: Maybe<Scalars['Boolean']>;
  readonly taxName?: Maybe<Scalars['String']>;
  readonly taxPercentage?: Maybe<Scalars['Float']>;
  readonly zohoOrganizationId?: Maybe<Scalars['String']>;
  readonly zohoTaxId?: Maybe<Scalars['String']>;
};

export type ZohoTaxFilter = {
  readonly isDefault?: InputMaybe<Scalars['Boolean']>;
  readonly taxName?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly taxPercentage?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
  readonly zohoOrganizationId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly zohoTaxId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};
